import Cookie from 'js.cookie';
import axios from 'axios';
import axiosInterceptors from '../axiosInter';
import { curUrl, apiUrl } from "../index"
import { channelApis } from './channel'
let api = curUrl;
window.Cookie = Cookie;
// 切换环境, 重新赋值, 只在本地环境可用
const isHavePort = !!window.location.port

if (isHavePort) {
  const processEnv = window.localStorage.getItem('processEnv');
  // if (!processEnv) return
  // console.log('processEnv', processEnv);

  switch (processEnv) {
    case 'prod':
      api = apiUrl.master
      break;
    case 'prodsw':
      api = apiUrl.mastersw
      break;
    case 'prodnew':
      api = apiUrl.masternew
      break;
    default:
      break;
  }
}

const gameListAPI = api.gameListAPI; // 游戏统一列表
const gameAreaListAPI = api.gameAreaListAPI; // 子游戏列表
const txCloudAPI = api.txCloudAPI;  // 腾讯云服务
const wxOpappApi = api.wxOpappApi;// 张宇锋后台服务
const wxRecodeApi = api.wxOpappDataApi; // 小游戏运营数据
const wxInviteApi = api.wxInviteApi; // 邀请任务服务
const wxTriggerApi = api.wxTriggerApi; // 事件触发
const xyxD2Api = api.xyxD2Api; // 新年礼包和ios索要
const xyxUpdateApi = api.xyxUpdateApi; // 小游戏版本
const daZhuanPanApi = api.daZhuanPanApi; // 大转盘服务
const clubopapiAPI = api.clubopapiAPI; // 留存
const sportMeetAPI = api.sportMeetAPI;   // 智力运动会
const matchAPI = api.matchAPI;  // 比赛
const propAPI = api.propAPI; // 后台服务
const payAPI = api.payAPI; // 支付服务
const xyxZonstApi = api.xyxZonstApi;
const WhiteListAPI = api.WhiteListAPI; // 比赛白名单
// const authpermissionAPI = api.authpermissionAPI; // 权限管理
const goldFeildAPI = api.goldFeildAPI; // 金币场信息(测试服)
const adaptiveScoreAPI = api.adaptiveScoreAPI; // 金币场信息(测试服)
const robotAPI = api.robotAPI; // 机器人分配地址(测试服)      使用原有正式服（李挺的接口）
const matchInfoAPI = api.matchInfoAPI; // 比赛场信息
const foodAPI = api.foodAPI;
const operatorAPI = api.operatorAPI;  //
const ksclientAPI = api.ksclientAPI // 获取用户金币数量
const outTxtApi = api.outTxtApi  // 投放码导出接
const pokerSetAPI = api.pokerSetAPI // 英生牌库配置接口
const fluCard = api.fluCard;       // 福卡配置
const logApi = api.logApi          // 日志
const operationApi = api.xyxNewDataApi         // 行为上报
const taskSetApi = api.taskSetApi             // 任务配置
const robotGoldApi = api.robotGoldApi    // 机器人金币控制
const eventApi = api.eventApi;     // 事件配置
const liveGameApi = api.liveGameApi         // 线下赛事配置
const mjLibApi = api.mjLibApi      // 麻将牌库测试用
const cardLibApi = api.cardLibApi           // 跑得快， 牌库
const clubopapi = api.clubopapi; // 留存
const middlegroundapi = api.middlegroundapi // 金币分享
const kamiapisrvAPI = api.kamiapisrvAPI // 卡密
const xyxpropapisrvAPI = api.xyxpropapisrvAPI
const matchhonoursAPI = api.matchhonoursAPI // 智运会服务
const activeConfigApi = api.activeConfigApi// 活动配置
const kamiwatchsrvAPI = api.kamiwatchsrvAPI // 卡密道具类型绑定配置
const controlCardApi = api.controlCardApi // 控牌配置服务
const gameAreaSortApi = api.gameAreaSortApi // 卡密道具类型绑定配置
const challengeApi = api.challengeApi // 卡密道具类型绑定配置
const userLabelApi = api.userLabelApi // 用户标签
const userLabelApiNew = api.userLabelApiNew // 用户标签
const limittimeactivityApi = api.limittimeactivityApi // 限时秒杀后台接口
const dailyStockApi = api.dailyStockApi // 每日库存
const getSubGameApi = api.getSubGameApi // 查找子游戏专用
const gamePackageApi = api.gamePackageApi // 游戏包配置
const signInAPI = api.signInAPI // 回归签到配置
const backUserTaskConfig = api.backUserTaskConfig // 回归任务配置
const laxinApi = api.laxinApi // 拉新活动配置
const zlinkAPI = api.zlinkAPI;
const permitAPI = api.permitAPI;
const drawLotApi = api.drawLotApi // 求签祈福
const bannerTouchConfig=api.bannerTouchConfig//广告误触配置、对局有利配置
const shuffleConfigApi=api.shuffleConfig//洗牌配置
const strongConfigApi=api.strongConfig //活动强弹配置
const thirdPartyGameApi = api.thirdPartyGameApi // 第三方联运
const pandoraAPI = api.pandoraAPI // 潘多拉
// 相应拦截器
axiosInterceptors()

export default {
  // 拉取潘多拉地区
  getPandoraRegion(data) {
    return axios.post(`${pandoraAPI}/admin/activity/pandora-admin/region_config/listByGameType`, data)
  },
  // 开关拷贝到平台
  switchCopyToPlatform(data) {
    return axios.post(`${wxOpappApi}/wx/activity/switch/copy-to-game`, data)
  },
  // 开关拷贝到渠道
  switchCopyToChannel(data) {
    return axios.post(`${wxOpappApi}/wx/activity/switch/copy-to-channel`, data)
  },
  // 渠道拷贝
  channelCopy(data) {
    return axios.post(`${propAPI}/client-app-channel-list/copy`, data)
  },
  // 数据渠道和包数据获取
  ...channelApis(axios, api.emsSrv),
  // 查找子游戏get-game-core-key
  getSubGame(params) {
    return axios.get(`${getSubGameApi}/game-area-by-type`, { params });
  },
  // 获取菜单数据
  getMenuList(params) {
    return axios.get(`${zlinkAPI}/api/common/v1/permission/account`, { params });
    // return axios.get('http://zlinkdev.test.xq5.com/api/server/v1/permission/account?platformKey=zlink'); // http://zlinkdev.test.xq5.com
  },

  // 日志上报
  logReported(data) {
    return axios.post(`${logApi}/frontend/report`, data)
  },
  // 操作行为上报,
  operationPost(data) {
    return axios.post(`${operationApi}/background/operation/report/`, data)
  },
  // 权限管理
  // authorPermission(data) {
  //   return axios.post(`${authpermissionAPI}/api2/v1/user/authpermission`, data)
  // },
  // 权限管理(新)
  // authorPermission(data) {
  //   return axios.post(`${authpermissionAPI}/v3/permission/userauth`, data)
  // },
  // 获取用户已有游戏id
  getAuthorPermission(params) {
    return axios.get(`${permitAPI}/api/v1/server/getUserPermission`, { params })
  },
  // 获取用户名
  getUserName() {
    return axios.post(`${ksclientAPI}/web/v1/ks/permission`)
  },
  // 平台权限接口
  getPermissionAPI(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/authpermission`, data);
  },
  txCloudAPI,
  fluCard,
  // 将图片文件上传至腾讯云
  updataImgAPI(data) {
    return axios.post(`${txCloudAPI}/v2/file/upload`, data);
  },
  // 查询游戏平台列表
  getGameList() {
    return axios.get(gameListAPI);
  },
  // 查询游戏平台下所有子游戏信息
  getGameAreaList(params) {
    return axios.get(gameAreaListAPI, { params });
  },
  // 用户性别统计
  userSexRate(data) {
    return axios.get(`${wxOpappApi}/web/v1/user/sex/rate/${data}`);
  },
  // 道具批量发送
  propsWholesale(data) {
    return axios.post(`${wxOpappApi}/web/v1/prop/grant/batch`, data);
  },
  // 短信批量发送
  messageWholesaleGet() {
    return axios.get(`${xyxUpdateApi}/phone/send`);
  },
  messageWholesalePost(data) {
    return axios.post(`${xyxUpdateApi}/phone/send`, data);
  },
  // 道具补发
  userPropGrant(data) {
    return axios.post(`${wxOpappApi}/web/v1/prop/grant`, data);
  },
  // 订单金额分日汇总
  userOrderGet(data) {
    return axios.post(`${wxOpappApi}/web/v1/user/order/get`, data);
  },
  // 获取用户当前信息
  userCurrInfo(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/seat`, data)
  },
  // 踢出该用户
  goOutUser(data) {
    return axios.post(`${matchInfoAPI}/v1/match/kick/user`, data)
  },
  // -------------注册用户区分渠道
  // 列表
  channelConfigGet(data) {
    return axios.get(`${wxOpappApi}/web/v1/channel/config/${data}`);
  },
  // 添加
  channelConfigPost(data) {
    return axios.post(`${wxOpappApi}/web/v1/channel/config`, data);
  },
  // 修改
  channelConfigPut(data) {
    return axios.put(`${wxOpappApi}/web/v1/channel/config`, data);
  },
  // 删除
  channelConfigDelete(data) {
    return axios.delete(`${wxOpappApi}/web/v1/channel/config/${data}`);
  },
  // --------------------------活动功能配置
  // 功能活动列表
  activitySwitchGet(data) {
    return axios.post(`${wxOpappApi}/wx/activity/switch/get`, data);
  },
  // 功能活动修改
  ActivitySwitchUpdate(data) {
    return axios.post(`${wxOpappApi}/web/v1/wx/activity/switch/update`, data)
  },
  // 功能活动添加
  activitySwitchAdd(data) {
    return axios.post(`${wxOpappApi}/web/v1/wx/activity/switch/add`, data)
  },
  // 功能活动删除
  activitySwitchDelete(data) {
    return axios.delete(`${wxOpappApi}/web/v1/wx/activity/switch?game_id=${data.game_id}&id=${data.id}`)
  },
  // 张宇锋接口
  // 道具类型配置
  propTypeGet() {
    return axios.get(`${wxOpappApi}/web/v1/prop/type`)
  },
  // 修改道具类型配置
  propTypePut(data) {
    return axios.put(`${wxOpappApi}/web/v1/prop/type`, data)
  },
  // 添加道具类型配置
  propTypePost(data) {
    return axios.post(`${wxOpappApi}/web/v1/prop/type`, data)
  },
  // 添加道具类型字段配置
  roomCardConfigAddAPI(data) {
    return axios.post(`${clubopapi}/v1/roomcardtype/config/change`, data)
  },
  // 添加道具类型字段配置
  roomCardConfigDeleteAPI(data) {
    return axios.post(`${clubopapi}/v1/roomcardtype/config/delete`, data)
  },
  // 添加道具类型字段配置
  roomCardConfigGetAPI(data) {
    return axios.post(`${clubopapi}/v1/roomcardtype/config/get`, data)
  },
  // 获取操作人信息
  operatorGet(params) {
    return axios.get(`${operatorAPI}/api/v1/zonst/group/userinfos`, { params })
  },
  // ---------------图片配置
  // 获取图片配置
  imgDelogGet(data) {
    return axios.get(`${wxOpappApi}/img/deploy/get/${data.game_id}/${data.pageSize}/${data.pageId}`)
  },
  // 添加图片配置
  imgDelogAdd(data) {
    return axios.post(`${wxOpappApi}/web/v1/img/deploy/add`, data)
  },
  // 添加图片配置
  imgDelogUpdate(data) {
    return axios.post(`${wxOpappApi}/web/v1/img/deploy/update`, data)
  },
  // 删除图片配置
  imgDelogDelete(data) {
    return axios.post(`${wxOpappApi}/web/v1/img/deploy/delete`, data)
  },
  // ============================== 自定义事件
  //   查询自定义事件配置
  wxCustomEventGetSub(data) {
    return axios.get(`${wxOpappApi}/web/v1/wx/custom/event/get/sub/${data}`);
  },
  // 删除自定义事件列表
  wxCustomEventDelete(data) {
    return axios.post(`${wxOpappApi}/web/v1/wx/custom/event/delete`, data);
  },
  // 更新自定义事件配置
  wxCustomEventUpdateSub(data) {
    return axios.post(`${wxOpappApi}/web/v1/wx/custom/event/update/sub`, data);
  },
  // 增加自定义事件配置
  wxCustomEventAddSub(data) {
    return axios.post(`${wxOpappApi}/web/v1/wx/custom/event/add/sub`, data);
  },
  // ============================== 元素类型表
  // 查找元素
  getBehavior(data) {
    // return axios.get(`${wxRecodeApi}/behavior/item/get`, { params: data });
    return axios.post(`${eventApi}/behavior/item/get`, data);
  },
  // 增加或修改元素
  addUpdateBehavior(data) {
    return axios.post(`${eventApi}/behavior/item/add-update`, data);
  },
  // 删除元素
  delBehavior(id) {
    return axios.delete(`${eventApi}/behavior/item/delete/${id}`);
  },
  // 查询事件页面配置
  getPageRegion(data) {
    // return axios.get(`${wxRecodeApi}/behavior/page-region/get?game_id=${id}`);
    return axios.post(`${eventApi}/behavior/page-region/get`, data);
  },
  // 增加或修改事件页面配置
  addUpdatePage(data) {
    return axios.post(`${eventApi}/behavior/page-region/add-update`, data);
  },
  // 删除事件页面配置
  delPageRegion(id) {
    return axios.delete(`${eventApi}/behavior/page-region/delete/${id}`);
  },
  // 查询每日注册用户数和留存
  registerUserGet(data) {
    return axios.post(`${wxOpappApi}/web/v1/register/user/get`, data);
  },
  // 查询金币钻石操作日记录
  diamondGoldLog(data) {
    return axios.post(`${wxOpappApi}/web/v1/diamond/gold/log`, data);
  },


  // ---------------------------------------- 冯弢接口
  // 道具配置
  prop(data) {
    return axios.get(`${propAPI}/prop/`, { params: data });
  },
  // 添加道具
  propAdd(data) {
    return axios.post(`${propAPI}/prop/`, data);
  },
  // 修改道具
  propUpdate(data, id) {
    return axios.patch(`${propAPI}/prop/${id}/?command=all`, data);
  },
  // 删除道具
  propDelete(data) {
    return axios.delete(`${propAPI}/prop/${data}/`);
  },
  // ------- 导出道具配置
  // get 区间导出
  getBtachOutPropConf: `${xyxpropapisrvAPI}/prop/external/batch-out-json-between/`,
  // getBtachOutPropConf(data) {
  //   return axios.get(`${xyxpropapisrvAPI}/prop/external/batch-out-json-between/`, data);
  // },
  // post 区间导出
  btachOutIntervalPropConf: `${xyxpropapisrvAPI}/prop/external/batch-out-json-post-between/`,
  // btachOutIntervalPropConf(data) {
  //   return axios.post(`${xyxpropapisrvAPI}/prop/external/batch-out-json-post-between/`, data);
  // },
  // post 指定道具导出
  postBtachOutPropConf: `${xyxpropapisrvAPI}/prop/external/batch-out-json-post-in/`,
  // postBtachOutPropConf(data) {
  //   return axios.post(`${xyxpropapisrvAPI}/prop/external/batch-out-json-post-in/`, data);
  // },
  // 导入道具配置
  btachUpdatePropConf: `${xyxpropapisrvAPI}/prop/external/batch-update/`,
  // btachUpdatePropConf(data) {
  //   return axios.post(`${xyxpropapisrvAPI}/prop/external/batch-update/`, data);
  // },
  // 测试服道具同步直接同步到正式服
  dumpDataFromDevToProd(data) {
    return axios.post(`${xyxpropapisrvAPI}/prop/external/dump-data-from-dev-to-pro/`, data);
  },
  // 测试服删除道具, 同步删除正式服
  delDataFromDevToProd(data) {
    return axios.post(`${xyxpropapisrvAPI}/prop/external/delete-data-from-dev-to-pro/`, data);
  },
  // --------------------------商城配置
  // 商城列表获取
  shopPropGet(data) {
    return axios.get(`${propAPI}/shop/prop/`, { params: data });
  },
  // 添加商城配置
  shopPropAdd(data) {
    return axios.post(`${propAPI}/shop/prop/`, data);
  },
  // 删除商城[配置
  shopPropDelete(data) {
    return axios.delete(`${propAPI}/shop/prop/${data}/`);
  },
  // 更新商城配置
  shopPropUpdate(data, id) {
    return axios.patch(`${propAPI}/shop/prop/${id}/?command=all`, data);
  },
  // 更新商城[配置
  shopPropExchange(data) {
    return axios.post(`${propAPI}/shop/prop/exchange`, data);
  },
  // 商城商品全部删除
  shopDeleteProp(data) {
    return axios.post(`${propAPI}/shop/prop/delete/`, data);
  },
  // 商城商品重新排序
  shopMallReorder(data) {
    return axios.post(`${propAPI}/shop/prop/reorder/`, data);
  },
  // ---------------订单
  // 订单详情
  orderList(data) {
    return axios.get(`${payAPI}/order/`, { params: data });
  },
  // 补发订单(old)
  shopChargePresent(data) {
    return axios.post(`${propAPI}/shop/charge/present/`, data);
  },
  // 补发订单(new)
  shopChargePresentNew(data) {
    return axios.post(`${fluCard}/shop/external/resend-order/`, data)
  },
  // 订单退款
  userOrderDrawback(data) {
    return axios.post(`${propAPI}/user/order/drawback/`, data);
  },
  // 订单退款成功操作
  userOrderDrawbackMoney(data) {
    return axios.post(`${propAPI}/user/order/drawback/money/`, data);
  },
  // ----------------用户反馈
  userFeedbackGet(data) {
    return axios.get(`${propAPI}/feedback-user-record/`, { params: data });
  },
  // ---------------采纳
  handleAccept(data) {
    return axios.post(`${propAPI}/feedback-user-record/backend/adopt-feedback/`, data);
  },
  // -------------查看
  handleCheck(data) {
    return axios.post(`${propAPI}/feedback-user-record/backend/update-view-state/`, data);
  },
  // 删除反馈信息
  deleteFeedBack(data) {
    return axios.delete(`${propAPI}/feedback-user-record/${data}/`);
  },
  // 查看问卷答案
  checkAnswers(data) {
    return axios.get(`${propAPI}/xyx-question-user-answer/`, { params: data });
  },
  // ----------------问卷情况-题库选项列表
  questionAnswerList(data) {
    return axios.post(`${propAPI}/answer-proportion/backend/view-question-analysis/`, data);
  },
  // --------------选项结果里详情展开
  toDeteil(data) {
    return axios.get(`${propAPI}/xyx-question-user-answer/`, { params: data });
  },
  // ----------------用户信息
  // propAPI
  userInfoGet(data) {
    return axios.get(`${propAPI}/user/info/`, { params: data });
  },
  // 查找用户钻石
  userDiamond(data) {
    return axios.get(`${propAPI}/user/diamond/`, { params: data });
  },

  // ------------金币钻石操作
  // 操作钻石
  userDiamondGain(data) {
    return axios.post(`${propAPI}/user/diamond/gain/`, data);
  },
  // 操作金币
  userGold(data) {
    return axios.post(`${propAPI}/user/gold/`, data);
  },
  // 查询用户资产
  userAssetList(data) {
    return axios.post(`${fluCard}/backend/user/external/query-user-asset/`, data);
  },
  // ------------------------------分享,登陆送金币活动配置
  // 活动设置获取
  shareCoinActivityGet(data) {
    return axios.post(`${propAPI}/activity/config/union/`, data)
  },
  // 活动设置修改
  activityConfig(data) {
    return axios.patch(`${propAPI}/activity/config/${data.id}/?command=all`, data)
  },
  // 活动添加
  activityConfigAdd(data) {
    return axios.post(`${propAPI}/activity/config/using-union/`, data)
  },
  // --------------- 任务配置
  taskSystemGet(data) {
    return axios.get(`${propAPI}/tasks/all-tasks/`, { params: data })
  },
  // 活跃度获取
  taskPointAwardConfig(data) {
    return axios.get(`${propAPI}/task/point-award-config`, { params: data })
  },
  // 活跃度修改
  taskPointAwardConfigPost(data) {
    return axios.post(`${propAPI}/task/point-award-config`, data)
  },
  // 对新平台克隆已有平台的配置.
  taskSystemConfigClone(data) {
    return axios.post(`${propAPI}/task/point-award-config/clone/`, data)
  },
  // 任务配置修改
  taskSystemPut(data) {
    return axios.post(`${propAPI}/tasks/modify-task/`, data)
  },
  // // 任务配置添加
  // taskSystemAdd(data) {
  //   return axios.post(`${propAPI}/tasks/add-adapt/`, data)
  // },
  // 任务配置删除
  taskSystemDelete(data) {
    return axios.post(`${propAPI}/tasks/delete-user-task/`, data)
  },
  // 获取跳转链接
  backendJumpToConfig() {
    return axios.get(`${propAPI}/backend/jump-to-config/`)
  },
  // 添加跳转链接
  backendJumpToConfigPost(data) {
    return axios.post(`${propAPI}/backend/jump-to-config/`, data)
  },
  // 修改跳转链接
  backendJumpToConfigPatch(id, data) {
    return axios.patch(`${propAPI}/backend/jump-to-config/${id}/`, data)
  },
  // 删除跳转链接
  backendJumpToConfigDelete(data) {
    return axios.delete(`${propAPI}/backend/jump-to-config/${data}/`)
  },
  // 获取子游戏开关列表
  gameAreaSwitchGet(data) {
    return axios.get(`${wxOpappApi}/web/v1/game/area/switch/${data}`)
  },
  // 获取子游戏开关列表
  gameAreaSwitchPost(data) {
    return axios.post(`${wxOpappApi}/web/v1/game/area/switch`, data)
  },
  // -------------------------------------------------------------
  // ------------------子游戏顺序配置（yufan）----------
  // 获取当前平台下的地区
  getLocationApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active/backend/get-game_location/`, data)
  },
  // 获取排序列表
  getGameAreaListApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active/backend/get-area-game-active-list/`, data)
  },
  // 更新排序
  getBatchUpdateApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active/backend/batch-update/`, data)
  },
  // 跨平台复制
  getCopyAreaApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active/backend/copy-between-area/`, data)
  },
  // 5.删除某个子游戏
  getDeleteApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active/backend/delete-and-sort/`, data)
  },
  // 6.获取平台下所有子游戏信息
  getAllGameAreaApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active/backend/get-platform-subgames/`, data)
  },
  // 7.添加子游戏排序
  getAddGameAreaApi(data) {
    return axios.post(`${gameAreaSortApi}/area-game-active-list/`, data)
  },
  // -------------------子游戏顺序配置end------------------------------------------
  /**
   * 广播推送
   */
  // 获取跑马灯配置
  getBroadcast(data) {
    return axios.get(`${drawLotApi}/broadcast/marquee_config/`, { params: data })
  },

  // 新增跑马灯配置
  createBroadcast(data) {
    return axios.post(`${drawLotApi}/broadcast/marquee_config/`, data)
  },

  // 修改跑马灯配置
  updateBroadcast(data, id) {
    return axios.patch(`${drawLotApi}/broadcast/marquee_config/${id}/`, data)
  },

  // 客服推送
  // 推送列表
  VXpubLink(data) {
    return axios.get(`${xyxZonstApi}/vx-pub/link/`, { params: data })
  },
  // 增加推送
  VXpubLinkAdd(data) {
    return axios.post(`${xyxZonstApi}/vx-pub/add-link/`, data)
  },
  // 删除
  VXpubLinkDelete(data) {
    return axios.post(`${xyxZonstApi}/vx-pub/delete-link-by-game_id/`, data)
  },
  // 删除
  VXpubLinkPatch(data, id) {
    return axios.patch(`${xyxZonstApi}/vx-pub/link/${id}/`, data)
  },
  // -------------- 用户牌局记录
  userBoardsGet(data) {
    return axios.get(`${wxOpappApi}/user/boards`, { params: data })
  },
  // 查询用户牌局记录耗时汇总
  userBoardsUseTime(data) {
    return axios.post(`${wxOpappApi}/user/boards/use/time`, data)
  },

  // -------------- 订阅消息
  // 消息模版列表
  modulePublishTemplateGet(data) {
    return axios.get(`${propAPI}/module/publish-template/`, { params: data })
  },
  // 删除模版
  modulePublishTemplateDelete(data) {
    return axios.delete(`${propAPI}/module/publish-template/${data}`)
  },
  // 新建模版
  modulePublishTemplatePost(data) {
    return axios.post(`${propAPI}/module/publish-template/`, data)
  },
  // 修改模版
  modulePublishTemplatePatch(data) {
    return axios.patch(`${propAPI}/module/publish-template/${data.id}/`, data)
  },

  // 模版消息推送
  modulePublishValueGet(data) {
    return axios.get(`${propAPI}/module/publish-value/`, data)
  },
  // 增加推送记录
  modulePublishValuePost(data) {
    return axios.post(`${propAPI}/module/publish-value/`, data)
  },
  // 修改推送记录
  modulePublishValuePatch(data) {
    return axios.patch(`${propAPI}/module/publish-value/${data.id}/`, data)
  },
  // 删除推送记录
  modulePublishValueDelete(data) {
    return axios.delete(`${propAPI}/module/publish-value/${data}`)
  },
  // 发送一则通知(后台,单个用户，无模版)
  modulePublishVxPost(data) {
    return axios.post(`${propAPI}/module/publish-vx/`, data)
  },
  // 发送给已经订阅的用户信息
  modulePublishAllPost(data) {
    return axios.post(`${propAPI}/module/publish-vx/all/`, data)
  },
  // 发送给已经订阅的用户信息 动态数据，现在使用
  modulePublishAllEventPost(data) {
    return axios.post(`${propAPI}/module/publish-by-event/`, data)
  },
  // 模版类型
  moduleEventGet(data) {
    return axios.get(`${propAPI}/module/event/`, data)
  },
  // 修改模版事件
  moduleEventPatch(id, data) {
    return axios.patch(`${propAPI}/module/event/${id}/`, data)
  },
  // 删除模版事件
  moduleEventDelete(id) {
    return axios.delete(`${propAPI}/module/event/${id}/`)
  },

  // ------------------- 邀请任务
  // 任务列表
  taskListGet(id) {
    return axios.get(`${wxInviteApi}/task/list/${id}`)
  },
  // 添加任务列表
  taskListPost(data) {
    return axios.post(`${wxInviteApi}/task/list`, data)
  },
  // 修改任务列表
  taskListPut(data) {
    return axios.put(`${wxInviteApi}/task/list`, data)
  },
  // 奖励列表
  cashMoneyGet(id) {
    return axios.get(`${wxInviteApi}/cash/money/${id}`)
  },
  // 奖励添加
  cashMoneyPost(data) {
    return axios.post(`${wxInviteApi}/cash/money`, data)
  },
  // 奖励修改
  cashMoneyPut(data) {
    return axios.put(`${wxInviteApi}/cash/money`, data)
  },

  // ------------------- 事件触发配置
  TriggerGet(data) {
    return axios.post(`${wxTriggerApi}/package`, data)
  },
  // 修改
  TriggerPut(data) {
    return axios.put(`${wxTriggerApi}/package`, data)
  },
  // 添加
  TriggerPost(data) {
    return axios.post(`${wxTriggerApi}/package/set`, data)
  },
  // 触发礼包数据
  triggerOrder(data) {
    return axios.get(`${wxRecodeApi}/trigger/order`, { params: data })
  },

  // -------------- 闯关服务配置
  // 查看配置列表
  GameChuangGuanConfigList(data) {
    return axios.get(`${propAPI}/game/chuangguan-config/`, { params: data })
  },
  // 添加配置列表
  GameChuangGuanConfigPost(data) {
    return axios.post(`${propAPI}/game/chuangguan-config/`, data)
  },
  // 修改配置列表
  GameChuangGuanConfigPut(id, data) {
    return axios.patch(`${propAPI}/game/chuangguan-config/${id}/`, data)
  },
  // 删除配置列表
  GameChuangGuanConfigDelete(id) {
    return axios.delete(`${propAPI}/game/chuangguan-config/${id}/`)
  },
  // 一键生成配置
  GameChuangGuaConfigAutoUserUnion(data) {
    return axios.post(`${propAPI}/game/chuangguan-config/auto/use-union/`, data)
  },
  // 关卡配置列表
  GameStageConfigGet(data) {
    return axios.get(`${propAPI}/stage-config-v2/`, { params: data })
    // return axios.get(`${propAPI}/game/stage-config/`, { params: data })
  },
  // 添加关卡配置列表
  GameStageConfigPost(data) {
    return axios.post(`${propAPI}/stage-config-v2/`, data)
    // return axios.post(`${propAPI}/game/stage-config/`, data)
  },
  // 修改关卡配置列表
  GameStageConfigPatch(id, data) {
    return axios.patch(`${propAPI}/stage-config-v2/${id}/`, data)
    // return axios.patch(`${propAPI}/game/stage-config/${id}/`, data)
  },
  // 删除关卡配置列表
  GameStageConfigDelete(id) {
    return axios.delete(`${propAPI}/stage-config-v2/${id}/`)
    // return axios.delete(`${propAPI}/game/stage-config/${id}/`)
  },
  // 一键生成关卡配置
  GameStageConfigAutoUserUnion(data) {
    return axios.post(`${propAPI}/game/stage-config/auto/use-union/`, data)
  },
  // -------------------------- 新手引导配置
  triggerNewLeadGet() {
    return axios.get(`${wxTriggerApi}/new/lead`)
  },
  // 添加和修改
  triggerNewLeadPost(data) {
    return axios.post(`${wxTriggerApi}/new/lead`, data)
  },
  // 删除
  triggerNewLeadDelete(id) {
    return axios.delete(`${wxTriggerApi}/new/lead/${id}`)
  },
  // --------------------------兑换券兑换记录
  // 查询兑换券记录
  couponRecordGet(data) {
    return axios.get(`${propAPI}/coupon-record/`, { params: data })
  },
  // 删除兑换券记录
  couponRecordDelete(data) {
    return axios.delete(`${propAPI}/coupon-record/${data}/`)
  },
  //
  // // ------- 上商城道具配送模版信息配置
  // 获取配送模版
  shopAddrTemplate() {
    return axios.get(`${propAPI}/shop-addr-template/`)
  },
  // 配送信息列表
  shopAddrInfo(data) {
    return axios.post(`${propAPI}/shop-addr-info/external/coupon-record/`, data)
  },
  // 获取已有activity_key
  couponRecordkeysList(data) {
    return axios.post(`${propAPI}/shop/coupon-record-item-keys/`, data)
  },
  // 签到任务
  // 任务池任务列表
  taskUserUnionTaskGet(data) {
    return axios.get(`${propAPI}/task/user-union-task/`, { params: data })
  },
  // 新增任务池任务
  taskUserUnionTaskPost(data) {
    return axios.post(`${propAPI}/task/user-union-task/`, data)
  },
  // 修改任务池任务
  taskUserUnionTaskPatch(data) {
    return axios.patch(`${propAPI}/task/user-union-task/${data.id}`, data)
  },
  // 从任务池挑选任务进平台
  taskUserExternalPickFromPool(data) {
    return axios.post(`${propAPI}/task/user-task/external/pick-from-pool/`, data)
  },
  // 节日礼包配置
  // 获取配置
  newYearPackageGet(data) {
    return axios.get(`${xyxD2Api}/new-year/package/get/${data.game_id}/${data.package_id}`)
  },
  // 修改和添加配置
  newYearPackagePost(data) {
    return axios.post(`${xyxD2Api}/new-year/package/post`, data)
  },
  holidayPackageGet(data) {
    return axios.get(`${xyxD2Api}/holiday/package/config/${data.game_id}`)
  },
  // 奖品类型获取
  awardGet(data) {
    return axios.get(`${daZhuanPanApi}/award/get`, { params: data })
  },
  // 奖品类型获取
  awardPost(data) {
    return axios.post(`${daZhuanPanApi}/award/post`, data)
  },
  // 大转盘配置添加
  turntableConfigPost(data) {
    return axios.post(`${daZhuanPanApi}/turntable-config/post`, data)
  },
  // 大转盘配置修改
  turntableConfigUpdate(data) {
    return axios.post(`${daZhuanPanApi}/turntable-config/update`, data)
  },
  // 大转盘配置获取
  turntableConfigGet(data) {
    return axios.get(`${daZhuanPanApi}/turntable-config/get`, { params: data })
  },
  // 广播配置获取
  broadcastConfigGet(data) {
    return axios.get(`${daZhuanPanApi}/config2/v1/broadcast/config/get`, { params: data })
  },
  // 广播配置修改和添加
  broadcastConfigPost(data) {
    return axios.post(`${daZhuanPanApi}/config2/v1/broadcast/config/post`, data)
  },
  // 广播配置删除
  broadcastConfigDel(data) {
    return axios.delete(`${daZhuanPanApi}/config2/v1/broadcast/config/del`, { params: data })
  },
  // 修改广播权重
  broadcastConfigSort(data) {
    return axios.post(`${daZhuanPanApi}/config2/v1/broadcast/config/sort`, data)
  },
  // --------广告
  // 获取弹窗策略
  getAcitvityStrategy(data) {
    return axios.post(`${middlegroundapi}/pop-windows-global-config/get/`, data)
  },
  // 修改弹窗策略
  updateActivityStrategy(data) {
    return axios.post(`${middlegroundapi}/pop-windows-global-config/upset/`, data)
  },
  // 获取公告活动配置
  getNoticeConfigList(data) {
    return axios.post(`${middlegroundapi}/pop-windows-config/list/`, data)
  },
  // 新增公告活动配置
  addNoticeConfig(data) {
    return axios.post(`${middlegroundapi}/pop-windows-config/add/`, data)
  },
  // 修改公告活动配置
  updateNoticeConfig(data) {
    return axios.post(`${middlegroundapi}/pop-windows-config/update/`, data)
  },
  // 删除公告活动配置
  deleteNoticeConfig(data) {
    return axios.post(`${middlegroundapi}/pop-windows-config/delete/`, data)
  },
  // 公告活动排序
  changeNoticeWeight(data) {
    return axios.post(`${middlegroundapi}/pop-windows-config/weight/`, data)
  },
  // -------活动公告白名单
  // 获取白名单列表
  getPopWhiteList(data) {
    return axios.post(`${middlegroundapi}/pop-windows-white/list/`, data)
  },
  // 新增白名单
  addPopWhiteList(data) {
    return axios.post(`${middlegroundapi}/pop-windows-white/add/`, data)
  },
  // 修改白名单
  updatePopWhiteList(data) {
    return axios.post(`${middlegroundapi}/pop-windows-white/update/`, data)
  },
  // 删除白名单
  deletePopWhiteList(data) {
    return axios.post(`${middlegroundapi}/pop-windows-white/delete/`, data)
  },
  // -------活动跳转链接
  // 获取跳转链接列表
  getActivityJumpLink(data) {
    return axios.post(`${middlegroundapi}/pop-windows-url-config/list/`, data)
  },
  // 新增跳转链接
  addActivityJumpLink(data) {
    return axios.post(`${middlegroundapi}/pop-windows-url-config/add/`, data)
  },
  // 修改跳转链接
  updateActivityJumpLink(data) {
    return axios.post(`${middlegroundapi}/pop-windows-url-config/update/`, data)
  },
  // 删除跳转链接
  deleteActivityJumpLink(data) {
    return axios.post(`${middlegroundapi}/pop-windows-url-config/delete/`, data)
  },

  // 获取广告配置
  xyxNoticeGet(data) {
    return axios.get(`${wxOpappApi}/web/v1/xyx/notice/get`, { params: data })
  },
  // 修改，添加广告配置
  xyxNoticePost(data) {
    return axios.post(`${wxOpappApi}/web/v1/xyx/notice/post`, data)
  },
  // 删除广告配置
  xyxNoticeDelete(data) {
    return axios.delete(`${wxOpappApi}/web/v1/xyx/notice/delete`, { params: data })
  },

  // 道具补发日志
  propGrantLog(data) {
    return axios.get(`${wxOpappApi}/web/v1/prop/grant/log`, { params: data })
  },
  // ------------------
  // 新用户金币活动配置
  newUserActivityConfig(data) {
    return axios.get(`${propAPI}/activity/new-user-activity-config/`, { params: data });
  },
  // 任务池任务添加到任务中
  activityPoolConfigToGame(data) {
    return axios.post(`${propAPI}/activity/new-user-activity/using-union/`, data);
  },
  // 修改平台任务
  activityPoolConfigPatch(id, data) {
    return axios.patch(`${propAPI}/activity/new-user-activity-config/${id}/`, data);
  },
  // 删除平台任务
  activityPoolConfigDelete(id) {
    return axios.delete(`${propAPI}/activity/new-user-activity-config/${id}/`);
  },
  // 任务池任务
  newUserActivityConfigUnion() {
    return axios.get(`${propAPI}/activity/new-user-activity-config-union/`);
  },
  // 修改任务池任务
  newUserActivityConfigUnionPatch(id, data) {
    return axios.patch(`${propAPI}/activity/new-user-activity-config-union/${id}/`, data);
  },
  // 添加任务池任务
  newUserActivityConfigUnionPost(data) {
    return axios.post(`${propAPI}/activity/new-user-activity-config-union/`, data);
  },

  // 比赛场列表
  matchList(data) {
    return axios.post(`${matchAPI}/v1/match/list`, data);
  },
  awardRankGet(data) {
    return axios.get(`${sportMeetAPI}/award/rank`, { params: data });
  },
  awardRankPost(data) {
    return axios.post(`${sportMeetAPI}/award/rank`, data);
  },
  awardRankDelete(data) {
    return axios.delete(`${sportMeetAPI}/award/rank`, { params: data });
  },

  // 赛程新增
  addMatchProgres(data) {
    return axios.post(`${propAPI}/match-progres/`, data);
  },
  // 获取列表(排序)
  getSortMatchProgres() {
    return axios.get(`${propAPI}/match-progres/?order_by=-match_id,start_at`);
  },
  // 获取列表(筛选)
  getfilterMatchProgres(data) {
    return axios.get(`${propAPI}/match-progres/`, { params: data });
  },
  // 删除列表
  deleteMatchProgress(id) {
    return axios.delete(`${propAPI}/match-progres/${id}/`)
  },
  // // 修改列表
  modifyMatchProgress(id, data) {
    return axios.patch(`${propAPI}/match-progres/${id}/`, data)
  },
  // 获取比赛白名单
  getMatchWhiteList(data) {
    return axios.get(`${WhiteListAPI}/whitelist/config`, { params: data });
  },
  // 添加或修改白名单
  addMatchWhiteList(data) {
    return axios.post(`${WhiteListAPI}/whitelist/config`, data);
  },
  // 删除白名单
  deleteMatchWhiteList(data) {
    return axios.delete(`${WhiteListAPI}/whitelist/config`, { params: data })
  },
  // ----------------比赛图片配置
  // 获取赛制配置
  getMatchimgList(data) {
    return axios.get(`${wxOpappApi}/web/v1/match/rules/config`, { params: data })
  },
  // 添加赛制配置列表
  addMatchimgList(data) {
    return axios.post(`${wxOpappApi}/web/v1/match/rules/config`, data)
  },
  // 修改赛制配置列表
  modifyMatchimgList(data) {
    return axios.post(`${wxOpappApi}/web/v1/match/rules/config`, data)
  },
  // 删除赛制配置列表
  delMatchimgList(data) {
    return axios.delete(`${wxOpappApi}/web/v1/match/rules/config`, { params: data })
  },
  // ----------------ost联储杯激活码配置CRUD
  // 增加一个激活码活动
  activityCodePost(data) {
    return axios.post(`${propAPI}/activate-code/`, data);
  },
  // 修改一个激活码活动
  activityCodePatch(id, data) {
    return axios.patch(`${propAPI}/activate-code/${id}`, data);
  },
  // 获取激活码活动
  activityCodeGet() {
    return axios.get(`${propAPI}/activate-code/`);
  },
  // 生成激活码
  activityCodeExternalGenerate(data) {
    return axios.post(`${propAPI}/activate-code/external/generate-code/`, data);
  },
  // ------------五一活动
  // 新增九宫格大奖池
  bigAwardPoolPost(data) {
    return axios.post(`${propAPI}/jiugongge-big-award-pool/`, data);
  },
  // 修改九宫格大奖池
  bigAwardPoolPatch(id, data) {
    return axios.patch(`${propAPI}/jiugongge-big-award-pool/${id}/`, data);
  },
  // 列表九宫格大奖池
  bigAwardPoolGet(data) {
    return axios.get(`${propAPI}/jiugongge-big-award-pool/`, { params: data });
  },
  // 获取某个九宫格大奖池
  bigAwardPoolOneGet(id) {
    return axios.get(`${propAPI}/jiugongge-big-award-pool/${id}/`);
  },

  // 新增九宫格小奖池
  smallAwardPoolPost(data) {
    return axios.post(`${propAPI}/jiugongge-small-award-pool/`, data);
  },
  // 修改九宫格大奖池
  smallAwardPoolPatch(id, data) {
    return axios.patch(`${propAPI}/jiugongge-small-award-pool/${id}/`, data);
  },
  // 列表九宫格小奖池
  smallAwardPoolGet(data) {
    return axios.get(`${propAPI}/jiugongge-small-award-pool/`, { params: data });
  },
  // 删除九宫格小奖池
  smallAwardPoolDelete(id) {
    return axios.delete(`${propAPI}/jiugongge-small-award-pool/${id}/`);
  },
  // 九宫格小奖池配置初始化
  smallAwardPoolInitialize() {
    return axios.post(`${propAPI}/jiugongge-small-award-pool/external/build-awards/`);
  },
  // 九宫格小奖池配置平台间拷贝
  smallAwardPoolCopy(data) {
    return axios.post(`${propAPI}/jiugongge-small-award-pool/external/copy/`, data);
  },
  // 列表九宫格任务
  jggAwardPoolList(data) {
    return axios.get(`${propAPI}/dzp-task/`, { params: data });
  },
  // 列表任务池任务
  jggAwardTeskPoolList(data) {
    return axios.get(`${propAPI}/dzp-task-union/`, { params: data });
  },
  // 提交列表任务池任务
  submitjggAwardTeskPoolList(data) {
    return axios.post(`${propAPI}/dzp-task/use-union/`, data);
  },
  // 新增任务池任务
  addAwardTeskPoolList(data) {
    return axios.post(`${propAPI}/dzp-task-union/`, data);
  },
  // 编辑九宫格任务
  editAwardTeskPoolList(id, data) {
    return axios.patch(`${propAPI}/dzp-task/${id}/`, data);
  },
  // 删除九宫格任务
  deleteAwardTeskPoolList(id) {
    return axios.delete(`${propAPI}/dzp-task/${id}/`);
  },
  // 拷贝任务至目标平台
  copyAwardTeskPoolList(data) {
    return axios.post(`${propAPI}/dzp-task/external/copy/`, data);
  },
  // ------------游戏子号配置以及游戏联合配置
  // 游戏子号配置
  // 子号列表
  areaConfigList() {
    return axios.get(`${propAPI}/backend/game-area-config/`);
  },
  // 增加配置
  addAreaConfigList(data) {
    return axios.post(`${propAPI}/backend/game-area-config/`, data);
  },
  // 修改配置
  editAreaConfigList(id, data) {
    return axios.patch(`${propAPI}/backend/game-area-config/${id}/`, data);
  },
  // 删除配置
  deleteAreaConfigList(id) {
    return axios.delete(`${propAPI}/backend/game-area-config/${id}/`);
  },
  // 列表game_union_config配置
  gameunionconfigList() {
    return axios.get(`${propAPI}/backend/game-union-config/`);
  },
  // 增加game_union_config配置
  addUnionConfig(data) {
    return axios.post(`${propAPI}/backend/game-union-config/`, data);
  },
  // 修改game_union_config配置
  editUnionConfig(id, data) {
    return axios.patch(`${propAPI}/backend/game-union-config/${id}/`, data);
  },
  // 删除game_union_config配置
  deleteUnionConfig(id) {
    return axios.delete(`${propAPI}/backend/game-union-config/${id}/`);
  },


  // ===============金币场接口 廖哲=============
  // 1、添加金币场房间配置
  goldRoomSetAdd(data) {
    return axios.put(`${goldFeildAPI}/web/v1/coin/place/config/add`, data);
  },
  // 1.1、自动适配底分优化（新增字段）
  addAreaGamePlayTagConfig(data) {
    return axios.post(`${adaptiveScoreAPI}/web/v1/area-game-play-tag-config/`, data);
  },

  // 2、金币场房间配置列表
  goldRootSetList(data) {
    return axios.get(`${goldFeildAPI}/web/v1/coin/place/config/list`, { params: data });
  },
  // 2.1 获取自动化适配底分优化（新增字段）
  getAreaGamePlayTagConfig(data) {
    return axios.get(`${adaptiveScoreAPI}/web/v1/area-game-play-tag-config/`, { params: data });
  },

  // 3、修改金币场房间配置
  goldRoomSetUpdate(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/place/config/update`, data);
  },
  // 3.1、修改自动适配底分优化（新增字段）
  updateAreaGamePlayTagConfig(id, data) {
    return axios.patch(`${adaptiveScoreAPI}/web/v1/area-game-play-tag-config/${id}/`, data)
  },
  // 4、删除金币场房间配置
  goldRoomSetDelete(data) {
    return axios.delete(`${goldFeildAPI}/web/v1/coin/place/config/delete`, { params: data });
  },
  // 4.1、删除自动适配底分优化（新增字段）
  deleteAreaGamePlayTagConfig(id) {
    return axios.delete(`${adaptiveScoreAPI}/web/v1/area-game-play-tag-config/${id}/`)
  },
  // 5、添加金币场套餐配置
  goldPackageSetAdd(data) {
    return axios.put(`${goldFeildAPI}/web/v1/coin/package/config/add`, data);
  },

  // 6、金币场套餐配置列表
  goldPackageSetList(data) {
    return axios.get(`${goldFeildAPI}/web/v1/coin/package/config/list`, { params: data });
  },

  // 7、修改金币场套餐配置
  goldPackageSetUpdate(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/package/config/update`, data);
  },
  // 8、删除金币场套餐配置
  goldPackageSetDelete(data) {
    return axios.delete(`${goldFeildAPI}/web/v1/coin/package/config/delete`, { params: data });
  },

  // 8、删除金币场套餐配置
  goldPackageSetCopyAPI(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/package/config/copy`, data);
  },

  // 9、交换金币场套餐配置
  goldPackageSetExchange(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/package/config/exchange`, data);
  },
  // 机器人携带金币下限
  robotLowerLimit(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/place/config/lower_limit/update`, data);
  },
  // 机器人携带金币上限
  robotUpperLimit(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/place/config/upper_limit/update`, data);
  },
  //  删除金币场游戏配置
  goldGameSetDelete(data) {
    return axios.delete(`${goldFeildAPI}/web/v1/coin/game/config/delete`, { params: data });
  },
  //  更新金币场游戏配置
  goldGameSetUpdate(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/game/config/update`, data);
  },
  //  添加金币场游戏配置
  goldGameSetAdd(data) {
    return axios.put(`${goldFeildAPI}/web/v1/coin/game/config/add`, data);
  },
  //  获取金币场游戏配置
  goldGameSetList(data) {
    return axios.get(`${goldFeildAPI}/web/v1/coin/game/config/list`, { params: data });
  },
  //  交换金币场游戏配置
  goldGameSetExchange(data) {
    return axios.post(`${goldFeildAPI}/web/v1/coin/game/config/exchange`, data);
  },
  // 获取用户金币数量
  coinCount(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/coin/get`, data);
  },
  // 获取玩家的金币变更记录
  usercoincoinlog(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/coin/coinlog`, data);
  },
  // 获取玩家的牌局记录
  usercoingamerecords(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/coin/game/records`, data);
  },
  // 创建可分配机器人
  robotInitAPI(data) {
    return axios.post(`${robotAPI}/v1/robot/init`, data)
  },
  // 分配机器人
  robotAddAPI(data) {
    return axios.post(`${robotAPI}/v1/robot/add`, data)
  },
  // 获取待分配机器人数量
  robotUnlocatedNumAPI(data) {
    return axios.post(`${robotAPI}/v1/robot/unlocated/get`, data)
  },
  // 获取已分配机器人数量
  robotLocatedNumAPI(data) {
    return axios.post(`${robotAPI}/v1/robot/located/get`, data)
  },
  // 获取使用中机器人数量
  robotUsingNum(data) {
    return axios.post(`${robotAPI}/v1/robot/using/get`, data)
  },
  // 获取比赛场机器人分配
  robotInMatchNumAPI(data) {
    return axios.post(`${robotAPI}/v1/robot/match/located/get`, data)
  },
  // 分配比赛场机器人
  matchAddRobotAPI(data) {
    return axios.post(`${robotAPI}/v1/robot/match/add`, data)
  },
  // 获取单个平台白名单列表
  getGoldWhiteList(data) {
    return axios.get(`${goldFeildAPI}/web/v1/coin/white/config/list`, { params: data })
  },
  // 单个平台下增加白名单测试
  goldWhiteAdd(data) {
    return axios.put(`${goldFeildAPI}/web/v1/coin/white/config/add`, data)
  },
  // 单个平台下删除白名单测试
  goldWhiteDelete(data) {
    return axios.delete(`${goldFeildAPI}/web/v1/coin/white/config/delete`, { params: data })
  },
  // 获取钻石套餐
  getDiamondConfigList(data) {
    return axios.post(`${goldFeildAPI}/web/v1/diamond/package/config/list`, data);
  },
  // ===============比赛场接口=============
  // 比赛场列表
  matchInfoList(data) {
    return axios.post(`${matchInfoAPI}/v1/match/list`, data);
  },
  // 添加比赛配置
  matchInfoAdd(data) {
    return axios.post(`${matchInfoAPI}/v1/match/add`, data);
  },
  // 修改比赛配置
  matchInfoUpdate(data) {
    return axios.post(`${matchInfoAPI}/v1/match/update`, data);
  },
  // 删除比赛配置
  matchInfoDelete(data) {
    return axios.post(`${matchInfoAPI}/v1/match/delete`, data);
  },
  // 修改比赛限制配置
  updateMatchRedbaglimit(data) {
    return axios.post(`${matchInfoAPI}/v1/match/redbag/limit/update`, data);
  },
  // 获取比赛配置限制
  getMatchRedbaglimit(data) {
    return axios.post(`${matchInfoAPI}/v1/match/redbag/limit/get`, data);
  },
  // 添加比赛限制配置
  addMatchRedbaglimit(data) {
    return axios.post(`${matchInfoAPI}/v1/match/redbag/limit/add`, data);
  },
  // 添加白名单
  addWhiteList(data) {
    return axios.post(`${matchInfoAPI}/v1/whitelist/add`, data);
  },
  // 白名单列表
  whiteList(data) {
    return axios.post(`${matchInfoAPI}/v1/whitelist/list`, data);
  },
  // 白名单列表
  deleteWhiteList(data) {
    return axios.post(`${matchInfoAPI}/v1/whitelist/delete`, data);
  },
  getFoodReward(data) {
    return axios.post(`${foodAPI}/get_count_list`, data)
  },
  // 比赛iconType列表
  getIconTypeList() {
    return axios.get(`${wxOpappApi}/web/v1/match/icon/type/config`)
  },
  // 比赛iconType修改或添加
  editIconType(data) {
    return axios.post(`${wxOpappApi}/web/v1/match/icon/type/config`, data)
  },
  // 比赛iconType删除
  delIconType(id) {
    return axios.delete(`${wxOpappApi}/web/v1/match/icon/type/config/${id}`)
  },
  // s6报名信息
  getRegisterListAPI(data) {
    return axios.post(`${strongConfigApi}/sport6/activeRecord/queryList`, data)
  },
  // S6 云跑配置
  // 查询发放奖励日志
  getRecordListAPI(data) {
    return axios.post(`${strongConfigApi}/yunpao/user/award/record/list`, data)
  },
  // 查询排行榜奖励配置列表
  queryRankingAPI(data) {
    return axios.post(`${strongConfigApi}/yunpao/award/config/list`, data)
  },
  // 添加排行榜奖励配置
  addRankingAPI(data) {
    return axios.post(`${strongConfigApi}/yunpao/award/config/add`, data)
  },
  // 导出
  exportRankingAPI(data){
    return axios.post(`${strongConfigApi}/yunpao/user/award/record/list/download`, data, {
      responseType: 'blob'
    })
  },
  //  ================= 投放码
  // 新增投放码
  addPutCode(data) {
    return axios.post(`${propAPI}/one-off-coupon/`, data)
  },
  // 修改投放码
  modifyPutCode(id, data) {
    return axios.patch(`${propAPI}/one-off-coupon/${id}/`, data)
  },
  // 获取投放码列表
  PutCodeList(data) {
    return axios.get(`${propAPI}/one-off-coupon/`, { params: data })
  },
  // 获取某个投放码
  PutCodeOne(id, data) {
    return axios.get(`${propAPI}/one-off-coupon/${id}/`, { params: data })
  },
  // 删除某个投放码
  delPutCode(id) {
    return axios.delete(`${propAPI}/one-off-coupon/${id}/`)
  },
  // 投放码导出
  outPutCode(data) {
    return axios.post(`${outTxtApi}/one-off-code/external/export-file/`, data)
  },

  // 获取房卡类型配置,
  getRoomcardTypeConfigList(data) {
    return axios.post(`${clubopapiAPI}/v1/roomcardtype/config/get`, data);
  },

  // 牌库配置新增一组牌
  addPokerSet(data) {
    return axios.post(`${pokerSetAPI}/card/card-library/`, data)
  },
  // 牌库配置更新一组牌
  updataPokerSet(id, data) {
    return axios.patch(`${pokerSetAPI}/card/card-library/${id}/`, data)
  },
  // 牌库配置删除一组牌
  deletePokerSet(id) {
    return axios.delete(`${pokerSetAPI}/card/card-library/${id}/`)
  },
  // 牌库配置删除牌库组
  deleteAllPokerSet(type) {
    return axios.delete(`${pokerSetAPI}/card/card-library-del/extra/${type}/`)
  },
  // 查询所有牌库
  getAllPokerSet(data) {
    return axios.get(`${pokerSetAPI}/card/card-library/`, { params: data })
  },
  // 查询牌组接口
  getAllPokerSetName() {
    return axios.post(`${pokerSetAPI}/card/card-library/query-group/`)
  },
  // 将牌库当前行复制到正式服
  pokerToMaster(data) {
    return axios.post('https://xyxcard.xq5.com/card/card-library/', data)
  },
  // -----------------  福卡配置
  // 新增胜局福卡配置
  addFluCardConfig(data) {
    return axios.post(`${fluCard}/win-fuka-config/`, data);
  },
  // 修改胜局福卡配置
  patchFluCardConfig(id, data) {
    return axios.patch(`${fluCard}/win-fuka-config/${id}/`, data);
  },
  //  胜局福卡列表
  getFluCardConfigList(data) {
    return axios.get(`${fluCard}/win-fuka-config/`, { params: data });
  },
  // 获取某个胜局福卡配置
  getFluCardConfigOne(id) {
    return axios.get(`${fluCard}/win-fuka-config/${id}/`);
  },
  // 删除胜局福卡配置
  delFluCardConfig(id) {
    return axios.delete(`${fluCard}/win-fuka-config/${id}/`);
  },
  // -------------------- 连胜奖励配置
  // 新增连胜奖励配置
  addWinStreakAward(data) {
    return axios.post(`${fluCard}/serial-win-config/`, data);
  },
  // 修改连胜奖励配置
  patchWinStreakAward(id, data) {
    return axios.patch(`${fluCard}/serial-win-config/${id}/`, data);
  },
  //  连胜奖励列表
  getWinStreakAwardList(data) {
    return axios.get(`${fluCard}/serial-win-config/`, { params: data });
  },
  // 获取某个连胜奖励配置
  getWinStreakAwardOne(id) {
    return axios.get(`${fluCard}/serial-win-config/${id}/`);
  },
  // 删除连胜奖励配置
  delWinStreakAward(id) {
    return axios.delete(`${fluCard}/serial-win-config/${id}/`);
  },
  // ------------ 对换商店配置
  // 开启/关闭兑换商店
  switchExchangeShop(data) {
    return axios.post(`${fluCard}/fk-exchange-shop/switch/`, data);
  },
  // 新增道具
  addExchangeShop(data) {
    return axios.post(`${fluCard}/fk-exchange-shop-union/add-prop/`, data);
  },
  // 获取商品列表
  getExchangeShop(data) {
    return axios.get(`${fluCard}/fk-exchange-shop-union/list-prop/`, { params: data });
  },
  // 修改道具配置
  compileExchangeShop(data) {
    return axios.post(`${fluCard}/fk-exchange-shop-union/update-prop/`, data);
  },
  // 删除道具配置
  delExchangeShop(data) {
    return axios.post(`${fluCard}/fk-exchange-shop-union/delete-prop/`, data);
  },
  // 道具复制
  copyExchangeShop(data) {
    return axios.post(`${fluCard}/fk-exchange-shop-union/copy-channel/`, data);
  },

  // -------------------- 周卡配置

  // -------------------- vip 配置
  // vip接口合并,vip-level-config和vip-right-config
  // 添加
  addVipConfig(data) {
    return axios.post(`${fluCard}/vip/config/external/vip-config-add/`, data);
  },
  // 修改
  patchVipConfig(data) {
    return axios.patch(`${fluCard}/vip/config/external/vip-config-update/`, data);
  },
  // 删除
  delVipConfig(data) {
    return axios.post(`${fluCard}/vip/config/external/vip-config-delete/`, data);
  },
  // 获取
  getVipConfig(data) {
    return axios.post(`${fluCard}/vip/config/external/vip-config-get/`, data);
  },


  // -------------  vip等级需要的积分
  // 添加
  addVipLevelConfig(data) {
    return axios.post(`${fluCard}/vip-level-config/`, data);
  },
  // 修改
  patchVipLevelConfig(id, data) {
    return axios.patch(`${fluCard}/vip-level-config/${id}/`, data);
  },
  // 删除
  delVipLevelConfig(id) {
    return axios.delete(`${fluCard}/vip-level-config/${id}/`);
  },
  // 获取
  getVipLevelConfig(data) {
    return axios.get(`${fluCard}/vip-level-config/`, { params: data });
  },

  // ------------- vip积分比例, 和看广告积分, 广告观看次数
  // 添加
  addVipGlobalConfig(data) {
    return axios.post(`${fluCard}/vip-global-config/`, data);
  },
  // 修改
  patchVipGlobalConfig(id, data) {
    return axios.patch(`${fluCard}/vip-global-config/${id}/`, data);
  },
  // 删除
  delVipGlobalConfig(id) {
    return axios.delete(`${fluCard}/vip-global-config/${id}/`);
  },
  // 获取列表
  getVipGlobalConfig(data) {
    return axios.get(`${fluCard}/vip-global-config/`, { params: data });
  },
  // vip配置平台间拷贝
  copyToAnotherGame(data) {
    return axios.post(`${fluCard}/vip-config/external/copy-to-another-game/`, data);
  },


  // ------------- vip等级对应的一次性和每日奖励
  // 添加vip各等级奖励配置
  addVipRightConfig(data) {
    return axios.post(`${fluCard}/vip-right-config/`, data);
  },
  // 删除vip各等级奖励配置
  delVipRightConfig(id) {
    return axios.delete(`${fluCard}/vip-right-config/${id}/`);
  },
  // 编辑修改vip各等级奖励配置
  patchVipRightConfig(id, data) {
    return axios.patch(`${fluCard}/vip-right-config/${id}/`, data);
  },
  // 获取vip各等级奖励配置列表
  getVipRightConfigList(data) {
    return axios.get(`${fluCard}/vip-right-config/`, { params: data });
  },

  // ------------------------- 商城礼包配置
  // 添加礼包(特惠) 2.0
  addGiftBags2(data) {
    return axios.post(`${drawLotApi}/gift-bags-new/`, data);
  },
  // 删除礼包(特惠)
  delGiftBags2(id) {
    return axios.delete(`${drawLotApi}/gift-bags-new/${id}/`);
  },
  // 编辑礼包(特惠)
  patchGiftBags2(data, id) {
    return axios.patch(`${drawLotApi}/gift-bags-new/${id}/`, data);
  },
  // 获取礼包列表
  getgiftBagsList2(data) {
    return axios.get(`${drawLotApi}/gift-bags-new/`, { params: data });
  },
  // 获取某个礼包列表
  getgiftBags2(id) {
    return axios.get(`${drawLotApi}/gift-bags-new/${id}/`);
  },
  // 商城礼包
  addGiftBags(data) {
    return axios.post(`${fluCard}/gift-bags/`, data);
  },
  // 删除礼包(特惠)
  delGiftBags(id) {
    return axios.delete(`${fluCard}/gift-bags/${id}/`);
  },
  // 编辑礼包(特惠)
  patchGiftBags(data, id) {
    return axios.patch(`${fluCard}/gift-bags/${id}/`, data);
  },
  // 获取礼包列表
  getgiftBagsList(data) {
    return axios.get(`${fluCard}/gift-bags/`, { params: data });
  },
  // 奖励礼包添加到商城,特惠
  addgiftBagsToShop(data) {
    return axios.post(`${fluCard}/gift-bags/external/add-to-shop/`, data);
  },
  // 奖励礼包添加到商城,特惠
  addgiftBagsToShopNewAPI(data) {
    return axios.post(`${fluCard}/gift-bags/external/add-to-shop-about-white-user/`, data);
  },
  // 修改已添加到商城,特惠奖励礼包
  updateGiftBagsShop(data) {
    return axios.post(`${fluCard}/gift-bags/external/update-to-shop/`, data);
  },

  // 获取某个礼包列表
  getgiftBagsOne(id, data) {
    return axios.get(`${fluCard}/gift-bags/${id}/`, { params: data });
  },

  // ---------------------------- 商城配置(new)
  // 获取商城所有的商品列表
  shopPropList(data) {
    return axios.get(`${drawLotApi}/shop-product/`, { params: data });
  },
  // 获取商城所有的商品列表
  shopPropListOld(data) {
    return axios.get(`${fluCard}/shop/prop/`, { params: data });
  },
  // 根据item_key获取库存信息
  getBackup(data) {
    return axios.post(`${fluCard}/shop-product/get-backup`, data);
  },
  // 新增商城商品(金币, 钻石, 装扮, 道具通用)
  addShopProp(data) {
    return axios.post(`${fluCard}/shop/prop/`, data);
  },
  // 新增商城商品(金币, 钻石, 装扮, 道具通用)
  addShopPropNewAPI(data) {
    return axios.post(`${drawLotApi}/shop-product/`, data);
  },
  patchShopPropNewAPI(data, id) {
    return axios.patch(`${drawLotApi}/shop-product/${id}`, data);
  },
  // 修改商城商品(金币, 钻石, 装扮, 道具通用)
  updateShopProp(data, id) {
    return axios.patch(`${fluCard}/shop/prop/${id}/?command=all`, data);
  },
  // 修改商城商品(金币, 钻石, 装扮, 道具通用)
  updateShopProp3(data, id) {
    return axios.patch(`${drawLotApi}/shop-product/${id}/`, data);
  },
  delShopPropPlus(id, data) {
    return axios.delete(`${drawLotApi}/shop-product/${id}/`, data);
  },
  // 删除商城商品(金币, 钻石, 装扮, 道具通用)
  delShopProp(id) {
    return axios.delete(`${fluCard}/shop/prop/${id}/`);
  },
  shopDeleteProp3(data) {
    return axios.delete(`${drawLotApi}/shop-product/delete-shop/`, { data});
  },
  // 删除商城商品(金币, 钻石, 装扮, 道具通用)
  delShopPropOld(id) {
    return axios.delete(`${fluCard}/shop/prop/${id}/`);
  },
  // 商城商品上/下架
  shopConfigUporDown(data) {
    return axios.post(`${fluCard}/backend/shop-config/up-and-down/`, data);
  },
  // 商品版本复制
  shopCopyVersion(data) {
    return axios.post(`${fluCard}/shop/external/copy-by-version/`, data);
  },
  // 按照版本删除商品
  shopDelVersion(data) {
    return axios.post(`${fluCard}/shop/external/delete-by-version/`, data);
  },
  // 同平台, 渠道间复制
  copyByAppChannel(data) {
    return axios.post(`${fluCard}/shop/external/copy-by-app-channel/`, data);
  },
  // 批量上架-商品
  batchListingProps(data) {
    return axios.post(`${fluCard}/shop-product/batch-add-pkg`, data)
  },
  // 查询商品
  searchShopProduct(data) {
    return axios.post(`${fluCard}/shop-product/search`, data)
  },
  // ---------- 商品标识 2.0

  // 新增
  addPropTag2(data) {
    return axios.post(`${drawLotApi}/prop-tag-config-new/`, data)
  },
  // 修改
  updatePropTag2(data, id) {
    return axios.patch(`${drawLotApi}/prop-tag-config-new/${id}/`, data)
  },
  // 删除
  delPropTag2(id) {
    return axios.delete(`${drawLotApi}/prop-tag-config-new/${id}/`)
  },
  // 获取列表
  PropTagList2(data) {
    return axios.get(`${drawLotApi}/prop-tag-config-new/`, { params: data })
  },
  // ---------- 商品标识 1.0
  // 新增
  addPropTag(data) {
    return axios.post(`${fluCard}/prop-tag-config/`, data)
  },
  // 修改
  updatePropTag(data, id) {
    return axios.patch(`${fluCard}/prop-tag-config/${id}/`, data)
  },
  // 删除
  delPropTag(id) {
    return axios.delete(`${fluCard}/prop-tag-config/${id}/`)
  },
  // 获取列表
  PropTagList(data) {
    return axios.get(`${fluCard}/prop-tag-config/`, { params: data })
  },
  // 获取一个
  getPropTagOne(id) {
    return axios.get(`${fluCard}/prop-tag-config/${id}`)
  },
  // 商品标识配置继承
  shopTagInherit(data) {
    return axios.post(`${fluCard}/prop-tag-config/external/default-copy/`, data)
  },
  // ----------------------- 记牌器配置
  // 新增记牌器配置
  addjiPaiQi(data) {
    return axios.post(`${fluCard}/card-recorder-activity-config/`, data);
  },
  // 删除记牌器配置
  deljiPaiQi(id) {
    return axios.delete(`${fluCard}/card-recorder-activity-config/${id}/`);
  },
  // 修改记牌器配置
  modifyjiPaiQi(id, data) {
    return axios.patch(`${fluCard}/card-recorder-activity-config/${id}/`, data);
  },
  // 获取记牌器配置
  jiPaiQiList(data) {
    return axios.get(`${fluCard}/card-recorder-activity-config/`, { params: data });
  },
  // 记牌器配置平台间复制
  copyJiPaiQi(data) {
    return axios.post(`${fluCard}/game/card-recorder/external/copy-card-recorder-to-another/`, data);
  },
  // ----------------- 专题赛兑换商城
  // 新增
  addSpecialShop(data) {
    return axios.post(`${fluCard}/shop-info/`, data);
  },
  // 页签3.0
  // 添加一级页签
  addTabTripleFirstTab(data) {
    return axios.post(`${drawLotApi}/page-mark/`, data);
  },
  patchTabTripleFirstTab({ id, page_name}) {
    return axios.patch(`${drawLotApi}/page-mark/${id}/`, { id, page_name });
  },
  delTabTripleFirstTab(id) {
    return axios.delete(`${drawLotApi}/page-mark/${id}/`);
  },
  moveTabTripleFirstTab(data) {
    return axios.post(`${drawLotApi}/page-mark/reorder/`, data);
  },
  // 添加二级页签
  addTabTripleSecondTab(data) {
    return axios.post(`${drawLotApi}/second-page/`, data);
  },
  // 更新二级页签
  patchTabTripleSecondTab(data) {
    return axios.patch(`${drawLotApi}/second-page/${data.id}/`, data);
  },
  // 删除二级页签
  delTabTripleSecondTab(id) {
    return axios.delete(`${drawLotApi}/second-page/${id}/`);
  },
  // 移动二级页签顺序
  moveTabTripleSecondTab(data) {
    return axios.post(`${drawLotApi}/second-page/reorder/`, data);
  },
  // 获取一级页签
  getTabTriple(data) {
    return axios.get(`${drawLotApi}/page-mark/`,  { params: data });
  },
  // 获取二级页签
  getTabTripleSecondTab(data) {
    return axios.get(`${drawLotApi}/second-page/`,  { params: data });
  },
  // 跨渠道拷贝页签
  copyMultipleChannelTab(data) {
    return axios.post(`${drawLotApi}/page-mark/copy-all/`, data);
  },
  // 页签新增 new -----
  addSpecialShopNewAPI(data) {
    return axios.post(`${fluCard}/shop-page-type-relation/add-shop-info/`, data);
  },
  // 新商城拷贝功能
  // 批量拷贝
  copyBatchMallShop(data) {
    return axios.post(`${drawLotApi}/shop-product/copy/`, data);
  },
  // 拷贝商城配置
  copyMallConfig(data) {
    return axios.post(`${drawLotApi}/shop-product/copy-shop/`, data);
  },
  // 批量删除
  batchDeletionConfig(data) {
    return axios.post(`${drawLotApi}/shop-product/delete-batch`, data)
  },
  // 批量删除-BPM
  batchDelete(data) {
    return axios.post(`${drawLotApi}/shop-product/batch-delete`, data)
  },
  // 批量下架
  offShelvesInBatches(data) {
    return axios.post(`${drawLotApi}/shop-product/update-batch`, data)
  },
  // 批量下架-BPM
  batchDown(data) {
    return axios.post(`${drawLotApi}/shop-product/batch-down`, data)
  },
  // 修改
  modifySpecialShop(data, id) {
    return axios.patch(`${fluCard}/shop-info/${id}/`, data);
  },
  // 修改页签new
  modifySpecialShopNewAPI(data) {
    return axios.post(`${fluCard}/shop-page-type-relation/update-shop-info/`, data);
  },
  // 删除
  delSpecialShop(id) {
    return axios.delete(`${fluCard}/shop-info/${id}/`);
  },
  // 获取列表
  specialShopList(data) {
    return axios.get(`${fluCard}/shop-info/`, { params: data });
  },
  // 获取列表New
  specialShopListNewAPI(data) {
    return axios.post(`${fluCard}/shop-page-type-relation/get-shop-info-list/`, data);
  },
  // 获取所有页签列表数据（包含页签组）New
  specialShopListAllAPI() {
    return axios.get(`${fluCard}/shop-page-type-relation/get-shop-group-list/`);
  },
  // 根据userid检验白名单信息
  checkShopWhiteUserAPI(data) {
    return axios.post(`${fluCard}/user-info/pick-one/`, data);
  },
  // 获取商品白名单列表
  getShopWhiteUser(data) {
    return axios.get(`${drawLotApi}/product-white-user/`, { params: data });
  },
  // 添加商品白名单信息
  addShopWhiteUserAPI(data) {
    return axios.post(`${drawLotApi}/product-white-user/`, data);
  },
  // 删除白名单信息
  deleteShopWhiteUserAPI(id) {
    return axios.delete(`${drawLotApi}/product-white-user/${id}/`)
  },
  // 获取某个专题赛商店
  specialShopOne(id) {
    return axios.get(`${fluCard}/shop-info/${id}/`);
  },
  // 专题赛兑换商店配置平台间拷贝
  copySpecialShop(data) {
    return axios.post(`${fluCard}/shop/external/copy-by-page-type/`, data);
  },
  // 专题赛兑换商店配置平台间拷贝 没引用，引用之前向服务确定请求域名是否需要替换成drawLotApi域名
  copyMoreChannelShop(data, id) {
    return axios.post(`${fluCard}/shop-product/${id}/copy`, data);
  },
  // ---------------------- 百元提现玩法

  // -------------------百元赛配置
  // 新增
  addHundredMatch(data) {
    return axios.post(`${fluCard}/match100-activity-config/`, data)
  },
  // 删除
  delHundredMatch(id) {
    return axios.delete(`${fluCard}/match100-activity-config/${id}/`)
  },
  // 修改
  modifyHundredMatch(id, data) {
    return axios.patch(`${fluCard}/match100-activity-config/${id}/`, data)
  },
  // 获取列表
  HundredMatchList(data) {
    return axios.get(`${fluCard}/match100-activity-config/`, { params: data })
  },
  // 获取单个
  HundredMatchOne(id) {
    return axios.get(`${fluCard}/match100-activity-config/${id}/`)
  },
  // -------------- 翻倍领取配置
  // 添加
  addDoublRewardConfig(data) {
    return axios.post(`${fluCard}/match100-doubling-reward-config/`, data)
  },
  // 删除
  delDoublRewardConfig(id) {
    return axios.delete(`${fluCard}/match100-doubling-reward-config/${id}/`)
  },
  // 修改
  modifyDoublRewardConfig(id, data) {
    return axios.patch(`${fluCard}/match100-doubling-reward-config/${id}/`, data)
  },
  // 获取列表
  doublRewardList(data) {
    return axios.get(`${fluCard}/match100-doubling-reward-config/`, { params: data })
  },
  // -------------  超值礼包配置
  // 添加
  addSaleconfig(data) {
    return axios.post(`${fluCard}/match100-gift-bags-config/`, data)
  },
  // 删除
  delSaleconfig(id) {
    return axios.delete(`${fluCard}/match100-gift-bags-config/${id}/`)
  },
  // 修改
  modifySaleconfig(id, data) {
    return axios.patch(`${fluCard}/match100-gift-bags-config/${id}/`, data)
  },
  // 获取列表
  getSaleconfig(data) {
    return axios.get(`${fluCard}/match100-gift-bags-config/`, { params: data })
  },

  // -------------------排行榜配置
  // 新增
  addRankListConfig(data) {
    return axios.post(`${fluCard}/match100-ranking-list/add-external/`, data)
  },
  // 删除
  delRankListConfig(id) {
    return axios.delete(`${fluCard}/match100-ranking-list/${id}/`)
  },
  // 修改
  modifyRankListConfig(data) {
    return axios.post(`${fluCard}/match100-ranking-list/update-external/`, data)
  },
  // 获取列表
  rankListConfigList(data) {
    return axios.get(`${fluCard}/match100-ranking-list/`, data)
  },
  // -------------------提现配置
  // 提现人名单
  drawingPeopleList(data) {
    return axios.get(`${fluCard}/match100/external/withdrawal-name-list/`, { params: data })
  },
  // 当日提现人数
  drawingPeopleNum(data) {
    return axios.post(`${fluCard}/match100/external/get-today-withdrawal-num/`, data)
  },
  // 查询用户余额
  searchUserBalance(data) {
    return axios.post(`${fluCard}/match100/external/backend/query-balance/`, data)
  },
  // 用户提现
  userExtract(data) {
    return axios.post(`${fluCard}/match100/external/backend/withdrawal/`, data)
  },
  // -------------------随机红包配置
  // 新增
  addRandomRedPacket(data) {
    return axios.post(`${fluCard}/match100-random-red-packet-config/`, data)
  },
  // 删除
  delRandomRedPacket(id) {
    return axios.delete(`${fluCard}/match100-random-red-packet-config/${id}/`)
  },
  // 修改
  modifyRandomRedPacket(id, data) {
    return axios.patch(`${fluCard}/match100-random-red-packet-config/${id}/`, data)
  },
  // 获取列表
  randomRedPacketList(data) {
    return axios.get(`${fluCard}/match100-random-red-packet-config/`, { params: data })
  },
  // 申请体现名单
  applyMoneyList(data) {
    return axios.post(`${fluCard}/match100/external/backend/list-apply-withdrawal-name-list/`, data)
  },
  // --------------------- 训练牌库开关配置
  // 添加
  addDrillPokerSwitch(data) {
    return axios.post(`${pokerSetAPI}/card/library-state/add`, data)
  },
  // 获取
  getDrillPokerSwitch() {
    return axios.post(`${pokerSetAPI}/card/library-state/get`)
  },
  // 修改
  modifyDrillPokerSwitch(data) {
    return axios.post(`${pokerSetAPI}/card/library-state/update`, data)
  },
  // ---------------------- 新签到配置
  // ------------- 钻石补签配置
  // 添加
  addRetroactive(data) {
    return axios.post(`${fluCard}/checkin/admin/makeup-dm-conf`, data)
  },
  // 获取
  getRetroactive(data) {
    return axios.get(`${fluCard}/checkin/admin/makeup-dm-conf`, { params: data })
  },
  // ------------ 签到奖励配置
  // 添加
  addSignAward(data) {
    return axios.post(`${fluCard}/checkin/admin/day-prop`, data)
  },
  // 获取单日道具配置
  getSignAwardDay(data) {
    return axios.get(`${fluCard}/checkin/admin/day-prop`, { params: data })
  },
  // 获取某月每一天的道具配置
  getSignAwardMonth(data) {
    return axios.get(`${fluCard}/checkin/admin/days-stat`, { params: data })
  },
  // 月份复制奖励配置
  copySignAwardMonth(data) {
    return axios.post(`${fluCard}/checkin/admin/month-copy`, data)
  },
  // ------------- 累计签到奖励配置
  // 添加
  addAccAward(data) {
    return axios.post(`${fluCard}/checkin/admin/month-prop`, data)
  },
  // 获取单个
  getAccAward(data) {
    return axios.get(`${fluCard}/checkin/admin/month-prop`, { params: data })
  },
  // 获取列表
  getAccAwardList(data) {
    return axios.get(`${fluCard}/checkin/admin/month-prop-list`, { params: data })
  },
  // -------------------- 明日有礼
  // 添加
  addTomorrowAward(data) {
    return axios.post(`${fluCard}/tomorrow-prop-config/`, data)
  },
  // 修改
  modifyTomorrowAward(id, data) {
    return axios.patch(`${fluCard}/tomorrow-prop-config/${id}/`, data)
  },
  // 列表
  tomorrowAwardList(data) {
    return axios.get(`${fluCard}/tomorrow-prop-config/`, { params: data })
  },
  // 获取单个
  getTomorrowAward(id) {
    return axios.get(`${fluCard}/tomorrow-prop-config/${id}/`)
  },
  // 删除
  delTomorrowAward(id) {
    return axios.delete(`${fluCard}/tomorrow-prop-config/${id}/`)
  },
  // 余额提现话费记录
  telChargeRecord(data) {
    return axios.get(`${fluCard}/cash-to-huafei-record/`, { params: data })
  },
  // 处理提现
  withdrawDispose(data) {
    return axios.post(`${fluCard}/lingqian-balance/external/backend-handle-huafei/`, data)
  },
  // 退还话费
  returnMoney(data) {
    return axios.post(`${fluCard}/lingqian-balance/external/backend-handle-huafei-withdraw/`, data)
  },
  // ------------------------ 邮件配置
  // Excel获取发送用户列表
  mailSendUserList(data) {
    // return axios.post(`${fluCard}/mail-send-task/back/excel-trans-to-user-list/`, data)
    return axios.post(`${fluCard}/mail-send-task/back/excel-trans-to-game-and-user-list/`, data)
  },
  // 新增发送
  addMailSend(data) {
    // return axios.post(`${fluCard}/mail-send-task/back/new/`, data)
    return axios.post(`${fluCard}/mail-send-task/back/multi-game-id/`, data)
  },
  // 获取列表
  getMailSendList(data) {
    return axios.post(`${fluCard}/mail-send-task/back/lists-by-status/`, data)
  },
  // 获取邮件详情
  getMailSendDetail(id) {
    return axios.get(`${fluCard}/mail-send-task/${id}/`)
  },
  // 批量撤回
  MailSendWithdrew(data) {
    return axios.post(`${fluCard}/mail-send-task/back/withdrew/`, data)
  },
  // ------------------------------- 大转盘new
  // 新增转盘
  addTurntable(data) {
    return axios.post(`${fluCard}/wheel/whl-wheel/`, data)
  },
  // 修改转盘
  modifyTurntable(id, data) {
    return axios.patch(`${fluCard}/wheel/whl-wheel/${id}/`, data)
  },
  // 删除转盘
  delTurntable(id) {
    return axios.delete(`${fluCard}/wheel/whl-wheel/${id}/`)
  },
  // 获取转盘列表
  getTurntableList(data) {
    return axios.get(`${fluCard}/wheel/whl-wheel/`, { params: data })
  },
  // 获取某个转盘
  getTurntableOne(id) {
    return axios.get(`${fluCard}/wheel/whl-wheel/${id}/`)
  },

  // 新增转盘奖品
  addTurntableProp(data) {
    return axios.post(`${fluCard}/wheel/whl-prize/`, data)
  },
  // 修改转盘奖品
  modifyTurntableProp(id, data) {
    return axios.patch(`${fluCard}/wheel/whl-prize/${id}/`, data)
  },
  // 删除转盘奖品
  delTurntableProp(id) {
    return axios.delete(`${fluCard}/wheel/whl-prize/${id}/`)
  },
  // 获取转盘奖品列表
  getTurntableListProp(data) {
    return axios.get(`${fluCard}/wheel/whl-prize/`, { params: data })
  },
  // 获取某个转盘奖品
  getTurntableOneProp(id) {
    return axios.get(`${fluCard}/wheel/whl-prize/${id}/`)
  },
  // --------------------- 训练牌库应用
  // 新增
  addDrillPokerUse(data) {
    return axios.post(`${pokerSetAPI}/card/library/apply-add`, data)
  },
  // 修改
  modifyDrillPokerUse(data) {
    return axios.post(`${pokerSetAPI}/card/library/apply-update`, data)
  },
  // 查询牌数
  searchCards(data) {
    return axios.post(`${pokerSetAPI}/card/library-all/count`, data)
  },
  // 获取列表
  drillPokerUseList(data) {
    return axios.get(`${pokerSetAPI}/card/library/apply-get`, { params: data })
  },
  // 查询牌库剩余未导入到目标牌库的数量
  drillPokerUseNum(data) {
    return axios.post(`${pokerSetAPI}/card/library/all-num`, data)
  },
  // 查询测试表数据导入到common 表 符合胜率 通过牌型
  cardLibrarytestApply(data) {
    return axios.post(`${pokerSetAPI}/card/library/test-apply`, data)
  },
  // 查询 biz_train 可以导入的牌型
  bizTrainQueryList(data) {
    return axios.post(`${pokerSetAPI}/card/library/biz-train/query-list`, data)
  },
  // 添加牌型到牌库组
  addCardToCardLibrary(data) {
    return axios.post(`${pokerSetAPI}/card/library/card-apply/add-cards`, data)
  },
  // 从业务组复制牌型到本业务组
  cardLibraryCopy(data) {
    return axios.post(`${pokerSetAPI}/card/library/card-apply/copy-from-card-type`, data)
  },
  // 查询当前牌库组已有的牌型
  cardLibraryAlreadyCard(data) {
    return axios.post(`${pokerSetAPI}/card/library/card-apply/get-by-type`, data)
  },
  // ================ 玩家账号操作记录
  accountOperationlog(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/forbid/login/operationlog/get`, data)
  },
  // ================ 玩家账号账号禁用
  accountForbid(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/login/forbid`, data)
  },
  // ================ 玩家账号账号解封
  accountJieFeng(data) {
    return axios.post(`${ksclientAPI}/web/v1/user/login/jiefeng`, data)
  },
  // -------------------- 手Q大转盘
  // 获奖名单
  winnerList(data) {
    return axios.get(`${fluCard}/qq-vip-turntable/adm/winning-list`, { params: data })
  },
  // 添加获奖人
  addWinnerList(data) {
    return axios.post(`${fluCard}/qq-vip-turntable/adm/winning-name`, data)
  },
  // 修改获奖人
  upDateWinnerList(id, data) {
    return axios.patch(`${fluCard}/qq-vip-turntable/adm/winning-name/${id}`, data)
  },
  // 删除获奖人
  delWinnerList(id) {
    return axios.delete(`${fluCard}/qq-vip-turntable/adm/winning-name/${id}`)
  },
  // 查看真实的剩余兑换码数量
  couponRemain() {
    return axios.get(`${fluCard}/qq-vip-turntable/adm/coupon-remain`)
  },
  // 录入兑换码(文件上传)
  couponFile(data) {
    return axios.post(`${fluCard}/qq-vip-turntable/adm/coupon-file`, data)
  },
  // ------------------- 牌库测试
  // 查询列表
  cardLibraryList(data) {
    return axios.post(`${pokerSetAPI}/card/library/biz-train-get`, data)
  },
  // 查询满足条件的数据
  cardLibraryRequirements(data) {
    return axios.post(`${pokerSetAPI}/card/library/requirements`, data)
  },
  // 增加测试牌库数据
  addCardLibrary(data) {
    return axios.post(`${pokerSetAPI}/card/library/biz-train-add`, data)
  },
  // 删除测试牌库数据（概率测试通过)
  delCardLibraryT(data) {
    return axios.post(`${pokerSetAPI}/card/library/rate-true/biz-train-delete`, data)
  },
  // 删除不符合概率的牌型  记录黑名单
  delCardLibraryF(data) {
    return axios.post(`${pokerSetAPI}/card/library/rate-false/biz-train-delete`, data)
  },
  // 获取key组列表
  bizKeysList(data) {
    return axios.get(`${pokerSetAPI}/card/library/biz-keys`, { params: data })
  },
  // 修改key组列表
  updateBizKeys(data) {
    return axios.put(`${pokerSetAPI}/card/library/biz-keys`, data)
  },
  // 删除key组列表
  delBizKeys(data) {
    return axios.delete(`${pokerSetAPI}/card/library/biz-keys`, { params: data })
  },
  // 添加key组列表
  addBizKeys(data) {
    return axios.post(`${pokerSetAPI}/card/library/biz-keys`, data)
  },
  // 牌库组应用列表
  getCardLibraryList(data) {
    return axios.post(`${pokerSetAPI}/card/library/card-apply/query-list `, data)
  },
  // ------------------ 余额提现审核
  // 审核处理结果
  withdrawResult(data) {
    return axios.post(`${fluCard}/withdraw-check/withdraw-result/`, data)
  },
  // 提现审核列表
  checkWithdrawList(data) {
    return axios.get(`${fluCard}/check-withdraw-process/`, { params: data })
  },
  // 修改提现审核
  updateCheckWithdraw(id, data) {
    return axios.patch(`${fluCard}/check-withdraw-process/${id}/`, data)
  },
  // 删除提现审核
  delCheckWithdraw(id) {
    return axios.delete(`${fluCard}/check-withdraw-process/${id}/`)
  },
  // 查询某个提现审核
  getCheckWithdrawOne(data) {
    return axios.get(`${fluCard}/check-withdraw-process/`, { params: data })
  },
  // ------------------------- 通行证配置
  // 新增等级配置
  addPassportLevel(data) {
    return axios.post(`${fluCard}/passport/passport-level/`, data)
  },
  // 修改等级配置
  updatePassportLevel(id, data) {
    return axios.patch(`${fluCard}/passport/passport-level/${id}/`, data)
  },
  // 删除等级配置
  delPassportLevel(id) {
    return axios.delete(`${fluCard}/passport/passport-level/${id}`)
  },
  // 等级配置列表
  passportLevelList(data) {
    return axios.get(`${fluCard}/passport/passport-level/`, { params: data })
  },
  // 某个等级配置
  getPassportLevelOne(id) {
    return axios.get(`${fluCard}/passport/passport-level/${id}`)
  },
  // 等级配置复制
  passportLevelCopy(data) {
    return axios.post(`${fluCard}/passport/passport-level/clone`, data)
  },
  // ---------------------- 任务配置
  // 添加任务模块
  addTaskModule(data) {
    return axios.post(`${taskSetApi}/task-srv/admin/task-module/`, data)
  },
  // 修改任务模块
  updateTaskModule(id, data) {
    return axios.patch(`${taskSetApi}/task-srv/admin/task-module/${id}/`, data)
  },
  // 删除任务模块
  delTaskModule(id) {
    return axios.delete(`${taskSetApi}/task-srv/admin/task-module/${id}/`)
  },
  // 任务模块列表
  taskModuleList(data) {
    return axios.get(`${taskSetApi}/task-srv/admin/task-module/`, { params: data })
  },
  // 添加任务
  addTaskParent(data) {
    return axios.post(`${taskSetApi}/task-srv/admin/task-parent/`, data)
  },
  // 修改任务
  updateTaskParent(id, data) {
    return axios.patch(`${taskSetApi}/task-srv/admin/task-parent/${id}/`, data)
  },
  // 删除任务
  delTaskParent(id) {
    return axios.delete(`${taskSetApi}/task-srv/admin/task-parent/${id}/`)
  },
  // 任务列表
  taskParentList(data) {
    return axios.get(`${taskSetApi}/task-srv/admin/task-parent/`, { params: data })
  },
  // 添加任务达成条件
  addTaskChild(data) {
    return axios.post(`${taskSetApi}/task-srv/admin/task-child/`, data)
  },
  // 修改任务达成条件
  updateTaskChild(id, data) {
    return axios.patch(`${taskSetApi}/task-srv/admin/task-child/${id}/`, data)
  },
  // 删除任务达成条件
  delTaskChild(id) {
    return axios.delete(`${taskSetApi}/task-srv/admin/task-child/${id}/`)
  },
  // 任务列表达成条件
  taskChildList(data) {
    return axios.get(`${taskSetApi}/task-srv/admin/task-child/`, { params: data })
  },
  // 列表任务达成方式
  taskProcessingType(data) {
    return axios.get(`${taskSetApi}/task-srv/admin/task-processing-type/`, { params: data })
  },
  // 渠道间任务拷贝
  taskCopyChannel(data) {
    return axios.post(`${taskSetApi}/task-srv/admin/task-parent-copy-between-channels`, data)
  },
  // ------- 任务达成条件配置
  // 新增
  addTaskProces(data) {
    return axios.post(`${taskSetApi}/task-srv/admin/task-processing-type/`, data)
  },
  // 修改
  updateTaskProces(id, data) {
    return axios.patch(`${taskSetApi}/task-srv/admin/task-processing-type/${id}/`, data)
  },
  // 删除
  delTaskProces(id) {
    return axios.delete(`${taskSetApi}/task-srv/admin/task-processing-type/${id}/`)
  },
  // 获取列表
  taskProcesList(data) {
    return axios.get(`${taskSetApi}/task-srv/admin/task-processing-type/`, { params: data })
  },
  // 获取某个
  getTaskProcesOne(id) {
    return axios.get(`${taskSetApi}/task-srv/admin/task-processing-type/${id}`)
  },
  // ---------------------  机器人金币控制
  //  -------- 基础配置
  // 添加
  addRobotGoldBasics(data) {
    return axios.post(`${robotGoldApi}/gameai/card-basics-control/config-add`, data)
  },
  // 修改
  updateRobotGoldBasics(data) {
    return axios.post(`${robotGoldApi}/gameai/card-basics-control/config-update`, data)
  },
  // 删除
  delRobotGoldBasics(id) {
    return axios.delete(`${robotGoldApi}/gameai/card-basics-control/config-delete?${id}`)
  },
  // 查询
  getRobotGoldBasics(data) {
    return axios.post(`${robotGoldApi}/gameai/card-basics-control/config-get`, data)
  },
  // --------- 机器人盈亏比概率配置
  // 添加
  addRobotGoldProfit(data) {
    return axios.post(`${robotGoldApi}/gameai/robot-profit-rate/config-add`, data)
  },
  // 修改
  updateRobotGoldProfit(data) {
    return axios.post(`${robotGoldApi}/gameai/robot-profit-rate/config-update`, data)
  },
  // 删除
  delRobotGoldProfit(id) {
    return axios.delete(`${robotGoldApi}/gameai/robot-profit-rate/config-delete`, { params: id })
  },
  // 查询
  robotGoldProfitList(data) {
    return axios.post(`${robotGoldApi}/gameai/robot-profit-rate/config-get`, data)
  },
  // --------- 玩家金币数/输赢金币配置
  // 添加
  addUserGoldProfit(data) {
    return axios.post(`${robotGoldApi}/gameai/user-profit-strategy/config-add`, data)
  },
  // 修改
  updateUserGoldProfit(data) {
    return axios.post(`${robotGoldApi}/gameai/user-profit-strategy/config-update`, data)
  },
  // 删除
  delUserGoldProfit(id) {
    return axios.delete(`${robotGoldApi}/gameai/user-profit-strategy/config-delete`, { params: id })
  },
  // 查询
  userGoldProfitList(data) {
    return axios.post(`${robotGoldApi}/gameai/user-profit-strategy/config-get`, data)
  },
  // ------ 机器人盈利比
  robotProfiRates(data) {
    return axios.post(`${robotGoldApi}/gameai/robot-profit-rates`, data)
  },
  // ------- 状态
  // 添加
  addCardCtlStates(data) {
    return axios.post(`${robotGoldApi}/gameai/card-control/status-add`, data)
  },
  // 修改
  updateCardCtlStates(data) {
    return axios.post(`${robotGoldApi}/gameai/card-control/status-update`, data)
  },
  // 删除
  delCardCtlStates(id) {
    return axios.delete(`${robotGoldApi}/gameai/card-control/status-delete`, { params: id })
  },
  // 获取
  getCardCtlStates(data) {
    return axios.post(`${robotGoldApi}/gameai/card-control/status-get`, data)
  },
  //  ----------------- 余额提现配置
  // 新增
  addBalanceCash(data) {
    return axios.post(`${fluCard}/balance-to-cash-config/`, data)
  },
  // 修改
  updateBalanceCash(id, data) {
    return axios.patch(`${fluCard}/balance-to-cash-config/${id}/`, data)
  },
  // 删除
  delBalanceCash(id) {
    return axios.delete(`${fluCard}/balance-to-cash-config/${id}`)
  },
  // 列表
  balanceCashList(data) {
    return axios.get(`${fluCard}/balance-to-cash-config/`, { params: data })
  },
  // 获取某个
  getBalanceCashOne(id) {
    return axios.get(`${fluCard}/balance-to-cash-config/${id}`)
  },
  // 获取渠道, 废弃
  userChannelList() {
    return axios.post(`${fluCard}/user-channel/list-all/`)
  },

  // --------------- 渠道配置
  // 新增
  addAppChannel(data) {
    return axios.post(`${fluCard}/client-app-channel-list/`, data)
  },
  // 修改
  updateAppChannel(data, id) {
    return axios.patch(`${fluCard}/client-app-channel-list/${id}/`, data)
  },
  // 删除
  delAppChannel(id) {
    return axios.delete(`${fluCard}/client-app-channel-list/${id}/`)
  },
  // 获取列表
  AppChannelList(data) {
    return axios.get(`${fluCard}/client-app-channel-list/`, { params: data })
  },
  // 获取一个
  getAppChannelOne(id) {
    return axios.get(`${fluCard}/client-app-channel-list/${id}`)
  },

  // ---------------------------- 智力运动会
  // ------------- 广告配置
  // 新增
  addMindGameAd(data) {
    return axios.post(`${fluCard}/zlh-ads-info-config/`, data)
  },
  // 修改
  updateMindGameAd(id, data) {
    return axios.patch(`${fluCard}/zlh-ads-info-config/${id}/`, data)
  },
  // 删除
  dleMindGameAd(id) {
    return axios.delete(`${fluCard}/zlh-ads-info-config/${id}/`)
  },
  // 获取列表
  mindGameAdList(data) {
    return axios.get(`${fluCard}/zlh-ads-info-config/`, { params: data })
  },
  // 获取某个
  getMindGameAdOne(id) {
    return axios.post(`${fluCard}/zlh-ads-info-config/${id}/`)
  },
  // --------------------- 用户资产转移
  userAssetTransfer(data) {
    return axios.post(`${fluCard}/backend/user/external/transfer-user-asset/`, data)
  },
  // ------------------- 商城和专题赛兑换商店库存
  // 新增库存
  addPropInventory(data) {
    return axios.post(`${fluCard}/shop-prop-backup-record/`, data)
  },
  // 获取即时库存
  getNowPropInventory(data) {
    return axios.post(`${fluCard}/shop-prop-backup/external/get-num/`, data)
  },
  // 修改即时库存
  updateNowPropInventory(data) {
    return axios.post(`${fluCard}/shop-prop-backup/external/add-num/`, data)
  },
  // 修改库存
  updatePropInventory(id, data) {
    return axios.patch(`${fluCard}/shop-prop-backup-record/${id}/`, data)
  },
  // 删除库存
  delPropInventory(id) {
    return axios.delete(`${fluCard}/shop-prop-backup-record/${id}`)
  },
  // 获取列表
  propInventoryList(data) {
    return axios.get(`${fluCard}/shop-prop-backup-record/`, { params: data })
  },
  // 获取某个商品库存
  getPropInventoryOne(id) {
    return axios.get(`${fluCard}/shop-prop-backup-record/${id}/`)
  },
  // ------------------------ 头衔系统
  // copy赛季头衔排名奖励配置
  copyRankAward(data) {
    return axios.post(`${fluCard}/rank/backend/copy-season-rank-award/`, data)
  },
  // copy头衔等级配置
  copyRankLevel(data) {
    return axios.post(`${fluCard}/rank/external/copy-level-config/`, data)
  },
  // -------------- 头衔配置
  // 新增
  addRankLevel(data) {
    return axios.post(`${fluCard}/rank-level-config/`, data)
  },
  // 修改
  updateRankLevel(id, data) {
    return axios.patch(`${fluCard}/rank-level-config/${id}/`, data)
  },
  // 删除
  delRankLevel(id) {
    return axios.delete(`${fluCard}/rank-level-config/${id}/`)
  },
  // 获取
  rankLevelList(data) {
    return axios.get(`${fluCard}/rank-level-config/`, { params: data })
  },
  // -------------- 积分额外加成
  // 新增
  addRankScore(data) {
    return axios.post(`${fluCard}/rank-score-addition-config/`, data)
  },
  // 修改
  updateRankScore(id, data) {
    return axios.patch(`${fluCard}/rank-score-addition-config/${id}/`, data)
  },
  // 删除
  delRankScore(id) {
    return axios.delete(`${fluCard}/rank-score-addition-config/${id}/`)
  },
  // 获取
  rankScoreList(data) {
    return axios.get(`${fluCard}/rank-score-addition-config/`, { params: data })
  },
  // -------------- 赛季排行奖励
  // 新增
  addSeasonRankAward(data) {
    return axios.post(`${fluCard}/season-rank-award-config/`, data)
  },
  // 修改
  updateSeasonRankAward(id, data) {
    return axios.patch(`${fluCard}/season-rank-award-config/${id}/`, data)
  },
  // 删除
  delSeasonRankAward(id) {
    return axios.delete(`${fluCard}/season-rank-award-config/${id}/`)
  },
  // 获取
  seasonRankAwardList(data) {
    return axios.get(`${fluCard}/season-rank-award-config/`, { params: data })
  },
  // -------------------- 线下赛事配置 liveGameApi
  // 新增线下赛信息
  addLiveGame(data) {
    return axios.post(`${liveGameApi}/api/match-info/`, data)
  },
  // 修改线下赛信息
  updateLiveGame(id, data) {
    return axios.patch(`${liveGameApi}/api/match-info/${id}/`, data)
  },
  // 删除线下赛信息
  delLiveGame(id) {
    return axios.delete(`${liveGameApi}/api/match-info/${id}/`)
  },
  // 获取线下赛信息列表
  liveGameList(data) {
    return axios.get(`${liveGameApi}/api/match-info/`, { params: data })
  },
  // 获取某个线下赛信息
  getLiveGameOne(id) {
    return axios.get(`${liveGameApi}/api/match-info/${id}/`)
  },
  // ----- 比赛开始
  liveGameStart(data) {
    return axios.post(`${liveGameApi}/api/match-info/external/club-game-start/`, data)
  },
  // ----- 比赛结束
  liveGameOver(data) {
    return axios.post(`${liveGameApi}/api/match-info/external/club-game-over/`, data)
  },
  // ----- 赛事结果
  // 获取用户赛事记录列表
  userMatchRecordList(data) {
    return axios.get(`${liveGameApi}/api/user-match-record/`, { params: data })
  },
  // 获取某个用户赛事记录
  getUserMatchRecordOne(id) {
    return axios.get(`${liveGameApi}/api/user-match-record/${id}/`)
  },
  // --------------------- 同步正式服道具配置
  syncFormalProp() {
    return axios.post(`${fluCard}/prop/external/sync-pro-prop-config/`)
  },
  // --------------------- 麻将牌库
  // 获取麻将和胡法列表
  mahjongList(data) {
    return axios.get(`${mjLibApi}/v1/MjPk/mj_list`, { params: data })
  },
  //  获取麻将所有场景信息
  mahjongGeneralSetList(data) {
    return axios.post(`${mjLibApi}/v1/mj_pk/game_scene_conf/get_all`, data)
  },
  // 编辑(新增和修改)麻将通用配置
  putMjGeneralSetEdit(data) {
    return axios.put(`${mjLibApi}/v1/mj_pk/game_scene_conf/update`, data)
  },
  // 获取某个场景麻将胡法信息
  mjHuRuleSet(data) {
    return axios.post(`${mjLibApi}/v1/mj_pk/mj_hu_rule/get_all`, data)
  },
  // 获取某个场景宝牌信息
  mjBaoPaiSet(data) {
    return axios.post(`${mjLibApi}/v1/mj_pk/bao_config/get_all`, data)
  },
  // 新增和修改麻将胡法信息
  putMjHuRuleInfo(data) {
    return axios.put(`${mjLibApi}/v1/mj_pk/mj_hu_rule/update`, data)
  },
  // 新增和修改宝牌信息
  putBaoPaiInfo(data) {
    return axios.put(`${mjLibApi}/v1/mj_pk/bao_config/update`, data)
  },
  // 编辑(新增和修改)麻将
  putMahjongEdit(data) {
    return axios.put(`${mjLibApi}/v1/MjPk/edit_mj`, data)
  },
  // 删除麻将
  delMahjong(data) {
    return axios.put(`${mjLibApi}/v1/MjPk/del_mj`, data)
  },
  // 编辑(新增和修改)胡法
  putHuEdit(data) {
    return axios.put(`${mjLibApi}/v1/MjPk/edit_hu`, data)
  },
  // 删除胡法
  delHu(data) {
    return axios.put(`${mjLibApi}/v1/MjPk/del_hu`, data)
  },
  // 获取某个麻将组应用
  getMahjongGroupOne(data) {
    return axios.post(`${mjLibApi}/v1/MjPk/mj_group_list`, data)
  },
  // 编辑(新增和修改)麻将组
  putGroupEdit(data) {
    return axios.put(`${mjLibApi}/v1/MjPk/edit_group`, data)
  },
  // 删除麻将组
  delMahjongGroup(data) {
    return axios.put(`${mjLibApi}/v1/MjPk/del_group`, data)
  },
  // --------------- 场次开放率
  // 新增和修改
  addAndUpdateControlMj(data) {
    return axios.put(`${mjLibApi}/v1/control_mj/control_list/edit_unit`, data)
  },
  // 删除
  delControlMj(data) {
    return axios.put(`${mjLibApi}/v1/control_mj/control_list/del`, data)
  },
  // 获取列表
  ControlMjList(data) {
    return axios.post(`${mjLibApi}/v1/control_mj/control_list/get_all`, data)
  },
  // ---------------- 人群包组
  // 添加
  addUserGroup(data) {
    return axios.post(`${robotGoldApi}/gameai/user-group/`, data)
  },
  // 修改
  updateUserGroup(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/user-group/${id}/`, data)
  },
  // 删除
  delUserGroup(id) {
    return axios.delete(`${robotGoldApi}/gameai/user-group/${id}`)
  },
  // 列表
  userGroupList(data) {
    return axios.get(`${robotGoldApi}/gameai/user-group/`, { params: data })
  },
  // --------- 人群包组用户配置
  // 添加
  addUserGroupTag(data) {
    return axios.post(`${robotGoldApi}/gameai/user-group-tag-config/`, data)
  },
  // 修改
  updateUserGroupTag(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/user-group-tag-config/${id}/`, data)
  },
  // 删除
  delUserGroupTag(id) {
    return axios.delete(`${robotGoldApi}/gameai/user-group-tag-config/${id}`)
  },
  // 列表
  userGroupTagList(data) {
    return axios.get(`${robotGoldApi}/gameai/user-group-tag-config/`, { params: data })
  },
  // 获取用户标签
  externalListTag() {
    return axios.post(`${robotGoldApi}/gameai/backend/external/list-tag/`)
  },
  // --------- 人群包/白名单列表
  // 添加白名单
  addUserGroupList(data) {
    return axios.post(`${robotGoldApi}/gameai/user-group-list/`, data)
  },
  // 修改
  updateUserGroupList(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/user-group-list/${id}/`, data)
  },
  // 删除
  delUserGroupLIst(id) {
    return axios.delete(`${robotGoldApi}/gameai/user-group-list/${id}`)
  },
  // 列表
  getUserGroupList(data) {
    return axios.get(`${robotGoldApi}/gameai/user-group-list/`, { params: data })
  },
  // --------- 人群包当前人数
  userTagCurrentNum(data) {
    return axios.get(`${robotGoldApi}/gameai/user-tag-current-instance/`, { params: data })
  },
  // --------- 屏蔽黑名单策略
  // 添加
  addBlackListConfigApi(data) {
    return axios.post(`${fluCard}/game_setting/shield`, data)
  },
  // 修改
  updateBlackListConfigApi(data, id) {
    return axios.patch(`${fluCard}/game_setting/shield/${id}`, data)
  },
  // 删除
  delBlackListConfigApi(id) {
    return axios.delete(`${fluCard}/game_setting/shield/${id}`)
  },
  // 列表
  getBlackListConfigApi(data) {
    return axios.get(`${fluCard}/game_setting/shields`, { params: data })
  },
  // 查询用户
  getUserListApi(id) {
    return axios.get(`${fluCard}/user-info/${id}/`)
  },
  // 批量添加黑名单
  batchAddBlackList(data) {
    return axios.post(`${fluCard}/game_setting/shield/batch-add`, data)
  },
  // --------- 屏蔽白名单策略
  // 添加
  addWhiteListConfigApi(data) {
    return axios.post(`${fluCard}/game_setting/shield`, data)
  },
  // 修改
  updateWhiteListConfigApi(data, id) {
    return axios.patch(`${fluCard}/game_setting/shield/${id}`, data)
  },
  // 删除
  delWhiteListConfigApi(id) {
    return axios.delete(`${fluCard}/game_setting/shield/${id}`)
  },
  // 列表
  getWhiteListConfigApi(data) {
    return axios.get(`${fluCard}/game_setting/shields`, { params: data })
  },
  // 批量添加白名单
  batchAddWhiteList(data) {
    return axios.post(`${fluCard}/game_setting/shield/batch-add`, data)
  },
  // --------- 公共白名单
  // 列表
  getPayWhiteListApi(data) {
    return axios.get(`${fluCard}/white-list-global/list`, { params: data })
  },
  // 添加
  addPayWhiteListApi(data) {
    return axios.put(`${fluCard}/white-list-global`, data)
  },
  // 批量添加
  addMorePayWhiteListApi(data) {
    return axios.post(`${fluCard}/white-list-global/batch-add`, data)
  },
  // 删除
  delPayWhiteListApi(id) {
    return axios.delete(`${fluCard}/white-list-global/${id}`)
  },
  // 查询用户
  getWhiteListUserApi(data) {
    return axios.get(`${fluCard}/white-list-global/user-info`, { params: data })
  },
  // --------- 牌库策略配置
  // 添加
  addCardLibStrategy(data) {
    return axios.post(`${robotGoldApi}/gameai/cardlibrary-strategy-config/`, data)
  },
  // 修改
  updateCardLibStrategy(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/cardlibrary-strategy-config/${id}/`, data)
  },
  // 删除
  delCardLibStrategy(id) {
    return axios.delete(`${robotGoldApi}/gameai/cardlibrary-strategy-config/${id}/`)
  },
  // 列表
  cardLibStrategyList(data) {
    return axios.get(`${robotGoldApi}/gameai/cardlibrary-strategy-config/`, { params: data })
  },
  // ---------- 体验组
  // 添加
  goldExpStrategyGroup(data) {
    return axios.post(`${robotGoldApi}/gameai/gold-experience-strategy-group/`, data)
  },
  // 修改
  updateExpStrategyGroup(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/gold-experience-strategy-group/${id}/`, data)
  },
  // 删除
  delExpStrategyGroup(id) {
    return axios.delete(`${robotGoldApi}/gameai/gold-experience-strategy-group/${id}/`)
  },
  // 列表
  expStrategyGroupList(data) {
    return axios.get(`${robotGoldApi}/gameai/gold-experience-strategy-group/`, { params: data })
  },
  // ---------- 金币极值策略
  // 添加
  addGoldOverFlowGroup(data) {
    return axios.post(`${robotGoldApi}/gameai/gold-over-flow-strategy-config/`, data)
  },
  // 修改
  updateGoldOverFlowGroup(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/gold-over-flow-strategy-config/${id}/`, data)
  },
  // 删除
  delGoldOverFlowGroup(id) {
    return axios.delete(`${robotGoldApi}/gameai/gold-over-flow-strategy-config/${id}/`)
  },
  // 列表
  goldOverFlowGroupList(data) {
    return axios.get(`${robotGoldApi}/gameai/gold-over-flow-strategy-config/`, { params: data })
  },
  // ---------- 战绩极值
  // 添加
  addSerialWinStrategy(data) {
    return axios.post(`${robotGoldApi}/gameai/serial-win-strategy-config/`, data)
  },
  // 修改
  updateSerialWinStrategy(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/serial-win-strategy-config/${id}/`, data)
  },
  // 删除
  delSerialWinStrategy(id) {
    return axios.delete(`${robotGoldApi}/gameai/serial-win-strategy-config/${id}/`)
  },
  // 列表
  serialWinStrategyList(data) {
    return axios.get(`${robotGoldApi}/gameai/serial-win-strategy-config/`, { params: data })
  },
  // ---------- 各阶段牌库配置
  // 添加
  addStrategyCardLib(data) {
    return axios.post(`${robotGoldApi}/gameai/strategy-card-lib-config/`, data)
  },
  // 修改
  updateStrategyCardLib(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/strategy-card-lib-config/${id}/`, data)
  },
  // 删除
  delStrategyCardLib(id) {
    return axios.delete(`${robotGoldApi}/gameai/strategy-card-lib-config/${id}/`)
  },
  // 列表
  strategyCardLibList(data) {
    return axios.get(`${robotGoldApi}/gameai/strategy-card-lib-config/`, { params: data })
  },
  // ---------- 档位配置
  // 添加
  addStrategyLevel(data) {
    return axios.post(`${robotGoldApi}/gameai/strategy-level-config/`, data)
  },
  // 修改
  updateStrategyLevel(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/strategy-level-config/${id}/`, data)
  },
  // 删除
  delStrategyLevel(id) {
    return axios.delete(`${robotGoldApi}/gameai/strategy-level-config/${id}/`)
  },
  // 列表
  strategyLevelList(data) {
    return axios.get(`${robotGoldApi}/gameai/strategy-level-config/`, { params: data })
  },
  // ---------- 福利档位配置
  // 添加
  welfareStrategyLevel(data) {
    return axios.post(`${robotGoldApi}/gameai/welfare-strategy-level-config/`, data)
  },
  // 修改
  updateWelfareStrategyLevel(data, id) {
    return axios.patch(`${robotGoldApi}/gameai/welfare-strategy-level-config/${id}/`, data)
  },
  // 删除
  delWelfareStrategyLevel(id) {
    return axios.delete(`${robotGoldApi}/gameai/welfare-strategy-level-config/${id}/`)
  },
  // 列表
  welfareStrategyLevelList(data) {
    return axios.get(`${robotGoldApi}/gameai/welfare-strategy-level-config/`, { params: data })
  },
  // -------------- 用户金币变更日志
  userLevelTransFormLog(data) {
    return axios.get(`${robotGoldApi}/gameai/user-level-transform-log/`, { params: data })
  },
  // ---------------------- 登录优化
  // 新增用户信息
  addUserInfo(data) {
    return axios.post(`${fluCard}/user-header/`, data)
  },
  // 修改用户信息
  updateUserInfo(data, id) {
    return axios.patch(`${fluCard}/user-header/${id}`, data)
  },
  // 删除用户信息
  delUserInfo(id) {
    return axios.delete(`${fluCard}/user-header/${id}/`)
  },
  // 用户信息列表
  userInfoList(data) {
    return axios.get(`${fluCard}/user-header/`, { params: data })
  },
  // -------------- 批量导入人群包
  externalBatchInput(data) {
    return axios.post(`${robotGoldApi}/gameai/backend/external/batch-input/`, data)
  },
  // 获取用户头像数据统计记录
  userInfoBackendNum(data) {
    return axios.post(`${fluCard}/user-header/backend/count/`, data)
  },
  // 设置用户头像状态
  setUserInfoBackendState(data) {
    return axios.post(`${fluCard}/user-header/backend/vstate/set/`, data)
  },
  // ----------------- 拉新配置
  // 添加
  addActLaxinConfig(data) {
    return axios.post(`${fluCard}/act-laxin-config/`, data)
  },
  // 修改
  updataActLaxinConfig(data, id) {
    return axios.patch(`${fluCard}/act-laxin-config/${id}/`, data)
  },
  // 删除
  delActLaxinConfig(id) {
    return axios.delete(`${fluCard}/act-laxin-config/${id}/`)
  },
  // 列表
  actLaxinConfigList(data) {
    return axios.get(`${fluCard}/act-laxin-config/`, { params: data })
  },
  // 获取某个
  getActLaxinConfigOne(id) {
    return axios.get(`${fluCard}/act-laxin-config/${id}`)
  },
  // 获取最新一期拉新活动act_id
  kvsLatestLaxin() {
    return axios.get(`${fluCard}/kvs/?key=latest_laxin`)
  },
  // 设置最新一期拉新活动act_id
  setKvsLatestLaxin(data) {
    return axios.post(`${fluCard}/kvs/`, data)
  },
  // 移除最新一期拉新活动act_id
  delKvsLatestLaxin(id) {
    return axios.delete(`${fluCard}/kvs/${id}/`)
  },
  // --------------------- 挑战赛配置
  // 以下接口名称中 Chlg(chlg) 表示 challenge
  // ---------- ai配置
  // 新增
  addAiConfig(data) {
    return axios.post(`${fluCard}/ai-config/`, data)
  },
  // 修改
  updateAiConfig(data, id) {
    return axios.patch(`${fluCard}/ai-config/${id}/`, data)
  },
  // 删除
  delAiConfig(id) {
    return axios.delete(`${fluCard}/ai-config/${id}/`)
  },
  // 获取列表
  aiConfigList(data) {
    return axios.get(`${fluCard}/ai-config/`, { params: data })
  },
  // 获取某个
  getAiConfigOne(id) {
    return axios.get(`${fluCard}/ai-config/${id}/`)
  },
  // ---------- 策略配置
  // 新增
  addChlgGameScheme(data) {
    return axios.post(`${fluCard}/challenge-game-scheme-config/`, data)
  },
  // 修改
  updateChlgGameScheme(data, id) {
    return axios.patch(`${fluCard}/challenge-game-scheme-config/${id}/`, data)
  },
  // 删除
  delChlgGameScheme(id) {
    return axios.delete(`${fluCard}/challenge-game-scheme-config/${id}/`)
  },
  // 获取列表
  chlgGameSchemeList(data) {
    return axios.get(`${fluCard}/challenge-game-scheme-config/`, { params: data })
  },
  // 获取某个
  getChlgGameSchemeOne(id) {
    return axios.get(`${fluCard}/challenge-game-scheme-config/${id}/`)
  },
  // ---------- 保底风控配置
  // 新增
  addChlgLowerRist(data) {
    return axios.post(`${fluCard}/challenge-lower-risk-config/`, data)
  },
  // 修改
  updateChlgLowerRist(data, id) {
    return axios.patch(`${fluCard}/challenge-lower-risk-config/${id}/`, data)
  },
  // 删除
  delChlgLowerRist(id) {
    return axios.delete(`${fluCard}/challenge-lower-risk-config/${id}/`)
  },
  // 获取列表
  chlgLowerRistList(data) {
    return axios.get(`${fluCard}/challenge-lower-risk-config/`, { params: data })
  },
  // 获取某个
  getChlgLowerRistOne(id) {
    return axios.get(`${fluCard}/challenge-lower-risk-config/${id}/`)
  },
  // ---------- 盈利风控配置
  // 新增
  addChlgProfitRist(data) {
    return axios.post(`${fluCard}/challenge-profit-risk-config/`, data)
  },
  // 修改
  updateChlgProfitRist(data, id) {
    return axios.patch(`${fluCard}/challenge-profit-risk-config/${id}/`, data)
  },
  // 删除
  delChlgProfitRist(id) {
    return axios.delete(`${fluCard}/challenge-profit-risk-config/${id}/`)
  },
  // 获取列表
  chlgProfitRistList(data) {
    return axios.get(`${fluCard}/challenge-profit-risk-config/`, { params: data })
  },
  // 获取某个
  getChlgProfitRistOne(id) {
    return axios.get(`${fluCard}/challenge-profit-risk-config/${id}/`)
  },
  // ---------- 挑战赛配置
  // 新增
  addChlgGameConfig(data) {
    return axios.post(`${fluCard}/challenge-game-config/`, data)
  },
  // 修改
  updateChlgGameConfig(data, id) {
    return axios.patch(`${fluCard}/challenge-game-config/${id}/`, data)
  },
  // 删除
  delChlgGameConfig(id) {
    return axios.delete(`${fluCard}/challenge-game-config/${id}/`)
  },
  // 获取列表
  chlgGameConfigList(data) {
    return axios.get(`${fluCard}/challenge-game-config/`, { params: data })
  },
  // 获取某个
  getChlgGameConfigOne(id) {
    return axios.get(`${fluCard}/challenge-game-config/${id}/`)
  },
  // ----------- 挑战赛关卡配置
  // 新增
  addChlgStageConfig(data) {
    return axios.post(`${fluCard}/challenge-stage-config/`, data)
  },
  // 修改
  updateChlgStageConfig(data, id) {
    return axios.patch(`${fluCard}/challenge-stage-config/${id}/`, data)
  },
  // 删除
  delChlgStageConfig(id) {
    return axios.delete(`${fluCard}/challenge-stage-config/${id}/`)
  },
  // 获取列表
  chlgStageConfigList(data) {
    return axios.get(`${fluCard}/challenge-stage-config/`, { params: data })
  },
  // 获取某个
  getChlgStageConfigOne(id) {
    return axios.get(`${fluCard}/challenge-stage-config/${id}/`)
  },
  // ----------- 挑战赛关卡文本配置
  // 新增
  addChlgStageContext(data) {
    return axios.post(`${fluCard}/challenge-stage-context-config/`, data)
  },
  // 修改
  updateChlgStageContext(data, id) {
    return axios.patch(`${fluCard}/challenge-stage-context-config/${id}/`, data)
  },
  // 删除
  delChlgStageContext(id) {
    return axios.delete(`${fluCard}/challenge-stage-context-config/${id}/`)
  },
  // 获取列表
  chlgStageContextList(data) {
    return axios.get(`${fluCard}/challenge-stage-context-config/`, { params: data })
  },
  // 获取某个
  getChlgStageContextOne(id) {
    return axios.get(`${fluCard}/challenge-stage-context-config/${id}/`)
  },
  // ---------------- 跑得快牌库组应用
  // 查询牌库组牌型数据
  cardSceneQueryList(data) {
    return axios.post(`${cardLibApi}/pdk/card-library-common/scene-query-list`, data)
  },
  // 应用牌库牌型上下架
  cardLibstate(data) {
    return axios.post(`${cardLibApi}/pdk/card-library-common/state`, data)
  },
  // 应用组查询配置
  cardApplyQueryList(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/apply-query-list`, data)
  },
  // 应用组删除配置
  cardApplyDelete(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/apply-delete`, data)
  },
  // 应用组添加配置
  cardApplyAdd(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/apply-add`, data)
  },
  // ------- 玩法配置
  // 获取玩法
  ruleConfigList(data) {
    return axios.get(`${cardLibApi}/pdk/card-library/rule-config-query-list`, { params: data })
  },
  // 添加玩法
  addRuleConfig(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/rule-config-add`, data)
  },
  // 修改玩法
  updateRuleConfig(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/rule-config-update`, data)
  },
  // 删除玩法
  delRuleConfig(id) {
    return axios.delete(`${cardLibApi}/pdk/card-library/rule-config-delete/${id}`)
  },
  // ------ 通用牌库
  // 查询牌库数量
  cardLibAllCount(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/all-count`, data)
  },
  // 条件查询all表牌型
  cardLibAllGet(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/all-get`, data)
  },
  // 上下架牌型
  cardLibAllState(data) {
    return axios.post(`${cardLibApi}/pdk/card-library/all-state`, data)
  },
  // -------------- 活动公告
  // 新增
  addActivityInfo(data) {
    return axios.post(`${fluCard}/activity-info/`, data)
  },
  // 修改
  updateActivityInfo(data, id) {
    return axios.patch(`${fluCard}/activity-info/${id}/`, data)
  },
  // 删除
  delActivityInfo(id) {
    return axios.delete(`${fluCard}/activity-info/${id}/`)
  },
  // 获取列表
  activityInfoList(data) {
    return axios.get(`${fluCard}/activity-info/`, { params: data })
  },
  // 获取一个
  getActivityInfoOne(id) {
    return axios.get(`${fluCard}/activity-info/${id}/`)
  },
  // 设置活动状态
  setActivityStatus(data) {
    return axios.post(`${fluCard}/activity-info/activity-status/set/`, data)
  },
  // --------------- 定时奖励
  // 新增
  addTimeAwardConfig(data) {
    return axios.post(`${fluCard}/time-award-config/`, data)
  },
  // 修改
  updateTimeAwardConfig(data, id) {
    return axios.patch(`${fluCard}/time-award-config/${id}/`, data)
  },
  // 删除
  delTimeAwardConfig(id) {
    return axios.delete(`${fluCard}/time-award-config/${id}/`)
  },
  // 获取列表
  timeAwardConfigList(data) {
    return axios.get(`${fluCard}/time-award-config/`, { params: data })
  },
  // 获取一个
  getTimeAwardConfigOne(id) {
    return axios.get(`${fluCard}/time-award-config/${id}`)
  },
  // --------------- 挑战赛, 道具价值配置
  // 新增
  addPropValue(data) {
    return axios.post(`${fluCard}/prop-value-config/`, data)
  },
  // 修改
  updatePropValue(data, id) {
    return axios.patch(`${fluCard}/prop-value-config/${id}/`, data)
  },
  // 删除
  delPropValue(id) {
    return axios.delete(`${fluCard}/prop-value-config/${id}/`)
  },
  // 获取列表
  propValueList(data) {
    return axios.get(`${fluCard}/prop-value-config/`, { params: data })
  },
  // 获取一个
  getPropValueOne(id) {
    return axios.get(`${fluCard}/prop-value-config/${id}`)
  },
  // --------------- icon_key 配置
  // 新增
  addPicConfig(data) {
    return axios.post(`${fluCard}/pic-config/`, data)
  },
  // 修改
  updatePicConfig(data, id) {
    return axios.patch(`${fluCard}/pic-config/${id}/`, data)
  },
  // 删除
  delPicConfig(id) {
    return axios.delete(`${fluCard}/pic-config/${id}/`)
  },
  // 获取列表
  PicConfigList(data) {
    return axios.get(`${fluCard}/pic-config/`, { params: data })
  },
  // 获取一个
  getPicConfigOne(id) {
    return axios.get(`${fluCard}/pic-config/${id}`)
  },
  // iconkey配置继承
  iconkeyInherit(data) {
    return axios.post(`${fluCard}/pic-config/external/default-copy/`, data)
  },
  // --------------- 装扮免费体验礼包
  // 新增
  addUserSendConfig(data) {
    return axios.post(`${fluCard}/user-send-config/`, data)
  },
  // 修改
  updateUserSendConfig(data, id) {
    return axios.patch(`${fluCard}/user-send-config/${id}/`, data)
  },
  // 删除
  delUserSendConfig(id) {
    return axios.delete(`${fluCard}/user-send-config/${id}/`)
  },
  // 获取列表
  userSendConfigList(data) {
    return axios.get(`${fluCard}/user-send-config/`, { params: data })
  },
  // 获取一个
  getUserSendConfigOne(id) {
    return axios.get(`${fluCard}/user-send-config/${id}`)
  },
  // --------------- 道具补发(新)
  // 新增
  addBackendPropPresent(data) {
    return axios.post(`${fluCard}/backend/prop-present/`, data)
  },
  // 获取列表
  backendPropPresentList(data) {
    return axios.get(`${fluCard}/resend-record/`, { params: data })
  },
  // --------------- 新人礼包配置
  // 新增
  addNewUser7DaysAward(data) {
    return axios.post(`${fluCard}/new-user7-days-award-config/`, data)
  },
  // 修改
  updateNewUser7DaysAward(data, id) {
    return axios.patch(`${fluCard}/new-user7-days-award-config/${id}/`, data)
  },
  // 删除
  delNewUser7DaysAward(id) {
    return axios.delete(`${fluCard}/new-user7-days-award-config/${id}/`)
  },
  // 获取列表
  newUser7DaysAwardList(data) {
    return axios.get(`${fluCard}/new-user7-days-award-config/`, { params: data })
  },
  // 获取一个
  getNewUser7DaysAwardOne(id) {
    return axios.get(`${fluCard}/new-user7-days-award-config/${id}`)
  },
  // --------------- 邀请有礼
  // 新增
  addInviteNew(data) {
    return axios.post(`${fluCard}/invite-new-config/`, data)
  },
  // 修改
  updateInviteNew(data, id) {
    return axios.patch(`${fluCard}/invite-new-config/${id}/`, data)
  },
  // 删除
  delInviteNew(id) {
    return axios.delete(`${fluCard}/invite-new-config/${id}/`)
  },
  // 获取列表
  inviteNewList(data) {
    return axios.get(`${fluCard}/invite-new-config/`, { params: data })
  },
  // 获取一个
  getInviteNewOne(id) {
    return axios.get(`${fluCard}/invite-new-config/${id}`)
  },
  // --------------- 邀请有礼的活动场景
  // 新增
  addInviteScene(data) {
    return axios.post(`${fluCard}/invite-scene-config/`, data)
  },
  // 修改
  updateInviteScene(data, id) {
    return axios.patch(`${fluCard}/invite-scene-config/${id}/`, data)
  },
  // 删除
  delInviteScene(id) {
    return axios.delete(`${fluCard}/invite-scene-config/${id}/`)
  },
  // 获取列表
  inviteSceneList(data) {
    return axios.get(`${fluCard}/invite-scene-config/`, { params: data })
  },
  // 获取一个
  getInviteSceneOne(id) {
    return axios.get(`${fluCard}/invite-scene-config/${id}`)
  },
  // --------------- 七日签到活动
  // 新增
  addUserSignIn(data) {
    return axios.post(`${fluCard}/user-sign-in-config/`, data)
  },
  // 修改
  updateUserSignIn(data, id) {
    return axios.patch(`${fluCard}/user-sign-in-config/${id}/`, data)
  },
  // 删除
  delUserSignIn(id) {
    return axios.delete(`${fluCard}/user-sign-in-config/${id}/`)
  },
  // 获取列表
  userSignInList(data) {
    return axios.get(`${fluCard}/user-sign-in-config/`, { params: data })
  },
  // 获取一个
  getUserSignInOne(id) {
    return axios.get(`${fluCard}/user-sign-in-config/${id}`)
  },
  // 获取切换双倍方式开关
  getRewardMethodType(data) {
    return axios.get(`${fluCard}/user-sign-in-config/switch-of-double/`, { params: data })
  },
  // 切换双倍方式
  switchRewardMethodType(data, id) {
    return axios.patch(`${fluCard}/user-sign-in-config/switch-of-double/${id}/`, data)
  },
  // --------------- 碎片道具组
  // 新增
  addFragmentGroup(data) {
    return axios.post(`${fluCard}/fragment-group/`, data)
  },
  // 修改
  updateFragmentGroup(data, id) {
    return axios.patch(`${fluCard}/fragment-group/${id}/`, data)
  },
  // 删除
  delFragmentGroup(id) {
    return axios.delete(`${fluCard}/fragment-group/${id}/`)
  },
  // 获取列表
  fragmentGroupList(data) {
    return axios.get(`${fluCard}/fragment-group/`, { params: data })
  },
  // 获取一个
  getFragmentGroupOne(id) {
    return axios.get(`${fluCard}/fragment-group/${id}`)
  },
  // --------------- 用户标签配置
  // 新增
  addLabelConfig(data) {
    return axios.post(`${fluCard}/label-config/`, data)
  },
  // 修改
  updateLabelConfig(data, id) {
    return axios.patch(`${fluCard}/label-config/${id}/`, data)
  },
  // 删除
  delLabelConfig(id) {
    return axios.delete(`${fluCard}/label-config/${id}/`)
  },
  // 获取列表
  labelConfigList(data) {
    return axios.get(`${fluCard}/label-config/`, { params: data })
  },
  // 获取一个
  getLabelConfigOne(id) {
    return axios.get(`${fluCard}/label-config/${id}`)
  },
  // --------------- 用户标签类型配置
  // 新增
  addLabelGroupConfig(data) {
    return axios.post(`${fluCard}/label-group-config/`, data)
  },
  // 修改
  updateLabelGroupConfig(data, id) {
    return axios.patch(`${fluCard}/label-group-config/${id}/`, data)
  },
  // 删除
  delLabelGroupConfig(id) {
    return axios.delete(`${fluCard}/label-group-config/${id}/`)
  },
  // 获取列表
  labelGroupConfigList(data) {
    return axios.get(`${fluCard}/label-group-config/`, { params: data })
  },
  // 获取一个
  getLabelGroupConfigOne(id) {
    return axios.get(`${fluCard}/label-group-config/${id}`)
  },
  // --------------- 用户标签白名单配置
  // 新增
  addLabelWhite(data) {
    return axios.post(`${fluCard}/label-white/`, data)
  },
  // 修改
  updateLabelWhite(data, id) {
    return axios.patch(`${fluCard}/label-white/${id}/`, data)
  },
  // 删除
  delLabelWhite(id) {
    return axios.delete(`${fluCard}/label-white/${id}/`)
  },
  // 获取列表
  labelWhiteList(data) {
    return axios.get(`${fluCard}/label-white/`, { params: data })
  },
  // 获取一个
  getLabelWhiteOne(id) {
    return axios.get(`${fluCard}/label-white/${id}`)
  },
  // --------------- 用户场景标签配置
  // 新增
  addLabelScene(data) {
    return axios.post(`${fluCard}/label-scene/`, data)
  },
  // 修改
  updateLabelScene(data, id) {
    return axios.patch(`${fluCard}/label-scene/${id}/`, data)
  },
  // 删除
  delLabelScene(id) {
    return axios.delete(`${fluCard}/label-scene/${id}/`)
  },
  // 获取列表
  labelSceneList(data) {
    return axios.get(`${fluCard}/label-scene/`, { params: data })
  },
  // 获取一个
  getLabelSceneOne(id) {
    return axios.get(`${fluCard}/label-scene/${id}`)
  },
  // --------------- 祈福活动开关
  // 新增
  addQifuConfigSwitch(data) {
    return axios.post(`${fluCard}/qifu-config-switch/`, data)
  },
  // 修改
  updateQifuConfigSwitch(data, id) {
    return axios.patch(`${fluCard}/qifu-config-switch/${id}/`, data)
  },
  // 删除
  delQifuConfigSwitch(id) {
    return axios.delete(`${fluCard}/qifu-config-switch/${id}/`)
  },
  // 获取列表
  qifuConfigSwitchList(data) {
    return axios.get(`${fluCard}/qifu-config-switch/`, { params: data })
  },
  // --------------- 后台配置拷贝
  // 每日签到
  copyDailySignConf(data) {
    return axios.post(`${fluCard}/copy-config/daily-sign-in-config/`, data)
  },
  // 分享有礼
  copyShareConf(data) {
    return axios.post(`${fluCard}/copy-config/share-config/`, data)
  },
  // 金币树
  copyGoldTreeConf(data) {
    return axios.post(`${fluCard}/copy-config/gold-tree-config/`, data)
  },
  // 定时奖励
  copyTimingWelfareConf(data) {
    return axios.post(`${fluCard}/copy-config/timing-welfare-config/`, data)
  },
  // 反馈有礼
  copyFeedbackConf(data) {
    return axios.post(`${fluCard}/copy-config/feedback-config/`, data)
  },
  // 新人七日有礼
  copyNewUserSevenConf(data) {
    return axios.post(`${fluCard}/copy-config/new-user-seven-config/`, data)
  },
  // 商城(以及礼包)
  copyGiftBagShopConf(data) {
    return axios.post(`${fluCard}/copy-config/gift-bag-shop/`, data)
  },
  // 活跃度任务
  copyTaskBetweenConf(data) {
    return axios.post(`${taskSetApi}/task-srv/admin/task-parent-copy-between-games`, data)
  },
  // 商品标识
  copyPropTagConf(data) {
    return axios.post(`${fluCard}/copy-config/prop-tag-config/`, data)
  },
  // 邀请新人获得的奖励配置
  copyInciteNewConf(data) {
    return axios.post(`${fluCard}/copy-config/incite-new-config/`, data)
  },
  // 给用户发送装扮配置
  copyUserSendConf(data) {
    return axios.post(`${fluCard}/copy-config/user-send-config/`, data)
  },
  // icon key 配置
  copyPicConfig(data) {
    return axios.post(`${fluCard}/pic-config/external/copy/`, data)
  },
  // --------------- 客服微信配置
  // 新增
  addPlatformVxConfig(data) {
    return axios.post(`${fluCard}/platform-vx-config/`, data)
  },
  // 修改
  updatePlatformVxConfig(data, id) {
    return axios.patch(`${fluCard}/platform-vx-config/${id}/`, data)
  },
  // 删除
  delPlatformVxConfig(id) {
    return axios.delete(`${fluCard}/platform-vx-config/${id}/`)
  },
  // 获取列表
  platformVxConfigList(data) {
    return axios.get(`${fluCard}/platform-vx-config/`, { params: data })
  },
  // 获取一个
  getPlatformVxConfigOne(id) {
    return axios.get(`${fluCard}/platform-vx-config/${id}`)
  },
  // --------------- 国庆礼包配置
  // 新增
  addGuoqingGiftBagsConf(data) {
    return axios.post(`${fluCard}/guoqing-gift-bags-config/`, data)
  },
  // 修改
  updateGuoqingGiftBagsConf(data, id) {
    return axios.patch(`${fluCard}/guoqing-gift-bags-config/${id}/`, data)
  },
  // 删除
  delGuoqingGiftBagsConf(id) {
    return axios.delete(`${fluCard}/guoqing-gift-bags-config/${id}/`)
  },
  // 获取列表
  guoqingGiftBagsConfList(data) {
    return axios.get(`${fluCard}/guoqing-gift-bags-config/`, { params: data })
  },
  // 获取一个
  getGuoqingGiftBagsConfOne(id) {
    return axios.get(`${fluCard}/guoqing-gift-bags-config/${id}`)
  },
  // --------------- 金币场体验配置, 分享配置
  // 新增
  addCountdownConfig(data) {
    return axios.post(`${middlegroundapi}/countdown-share-config/`, data)
  },
  // 修改
  updateCountdownConfig(data, id) {
    return axios.patch(`${middlegroundapi}/countdown-share-config/${id}/`, data)
  },
  // 删除
  delCountdownConfig(id) {
    return axios.delete(`${middlegroundapi}/countdown-share-config/${id}/`)
  },
  // 获取列表
  countdownConfigList(data) {
    return axios.get(`${middlegroundapi}/countdown-share-config/`, { params: data })
  },
  // 获取一个
  getCountdownConfigOne(id) {
    return axios.get(`${middlegroundapi}/countdown-share-config/${id}/`)
  },
  // --------------- 可配置活动通用模板
  // -------- 活动组配置
  // 新增
  addActivityGroupConfig(data) {
    return axios.post(`${fluCard}/activity-group-config/`, data)
  },
  // 修改
  updateActivityGroupConfig(data, id) {
    return axios.patch(`${fluCard}/activity-group-config/${id}/`, data)
  },
  // 删除
  delActivityGroupConfig(id) {
    return axios.delete(`${fluCard}/activity-group-config/${id}/`)
  },
  // 获取列表
  activityGroupConfigList(data) {
    return axios.get(`${fluCard}/activity-group-config/`, { params: data })
  },
  // 获取一个
  getActivityGroupConfigOne(id) {
    return axios.get(`${fluCard}/activity-group-config/${id}/`)
  },
  // -------- 子活动配置
  // 新增
  addChildActivityConfig(data) {
    return axios.post(`${fluCard}/child-activity-config/`, data)
  },
  // 修改
  updateChildActivityConfig(data, id) {
    return axios.patch(`${fluCard}/child-activity-config/${id}/`, data)
  },
  // 删除
  delChildActivityConfig(id) {
    return axios.delete(`${fluCard}/child-activity-config/${id}/`)
  },
  // 获取列表
  ChildActivityConfigList(data) {
    return axios.get(`${fluCard}/child-activity-config/`, { params: data })
  },
  // 获取一个
  getChildActivityConfigOne(id) {
    return axios.get(`${fluCard}/child-activity-config/${id}/`)
  },
  // --------------- 赛季主题
  // 新增
  addLevelThemeConfig(data) {
    return axios.post(`${middlegroundapi}/level-theme-config/`, data)
  },
  // 修改
  updateLevelThemeConfig(data, id) {
    return axios.patch(`${middlegroundapi}/level-theme-config/${id}/`, data)
  },
  // 删除
  delLevelThemeConfig(id) {
    return axios.delete(`${middlegroundapi}/level-theme-config/${id}/`)
  },
  // 获取列表
  LevelThemeConfigList(data) {
    return axios.get(`${middlegroundapi}/level-theme-config/`, { params: data })
  },
  // 获取一个
  getLevelThemeConfigOne(id) {
    return axios.get(`${middlegroundapi}/level-theme-config/${id}/`)
  },
  // --------------- 大段位配置
  // 新增
  addLevelConfig(data) {
    return axios.post(`${middlegroundapi}/level-config/`, data)
  },
  // 修改
  updateLevelConfig(data, id) {
    return axios.patch(`${middlegroundapi}/level-config/${id}/`, data)
  },
  // 删除
  delLevelConfig(id) {
    return axios.delete(`${middlegroundapi}/level-config/${id}/`)
  },
  // 获取列表
  LevelConfigList(data) {
    return axios.get(`${middlegroundapi}/level-config/`, { params: data })
  },
  // 获取一个
  getLevelConfigOne(id) {
    return axios.get(`${middlegroundapi}/level-config/${id}/`)
  },
  // --------------- 大段位, 至尊王者段位配置
  // 新增
  addKingLevelConfig(data) {
    return axios.post(`${middlegroundapi}/king-level-config/`, data)
  },
  // 修改
  updateKingLevelConfig(data, id) {
    return axios.patch(`${middlegroundapi}/king-level-config/${id}/`, data)
  },
  // 删除
  delKingLevelConfig(id) {
    return axios.delete(`${middlegroundapi}/king-level-config/${id}/`)
  },
  // 获取列表
  KingLevelConfigList(data) {
    return axios.get(`${middlegroundapi}/king-level-config/`, { params: data })
  },
  // 获取一个
  getKingLevelConfigOne(id) {
    return axios.get(`${middlegroundapi}/king-level-config/${id}/`)
  },
  // --------------- 小段位配置
  // 新增
  addSubLevelConfig(data) {
    return axios.post(`${middlegroundapi}/sub-level-config/`, data)
  },
  // 修改
  updateSubLevelConfig(data, id) {
    return axios.patch(`${middlegroundapi}/sub-level-config/${id}/`, data)
  },
  // 删除
  delSubLevelConfig(id) {
    return axios.delete(`${middlegroundapi}/sub-level-config/${id}/`)
  },
  // 获取列表
  SubLevelConfigList(data) {
    return axios.get(`${middlegroundapi}/sub-level-config/`, { params: data })
  },
  // 获取一个
  getSubLevelConfigOne(id) {
    return axios.get(`${middlegroundapi}/sub-level-config/${id}/`)
  },
  // --------------- 赛季配置
  // 新增
  addThemeSeasonConfig(data) {
    return axios.post(`${middlegroundapi}/theme-season-config/`, data)
  },
  // 修改
  updateThemeSeasonConfig(data, id) {
    return axios.patch(`${middlegroundapi}/theme-season-config/${id}/`, data)
  },
  // 删除
  delThemeSeasonConfig(id) {
    return axios.delete(`${middlegroundapi}/theme-season-config/${id}/`)
  },
  // 获取列表
  ThemeSeasonConfigList(data) {
    return axios.get(`${middlegroundapi}/theme-season-config/`, { params: data })
  },
  // 获取一个
  getThemeSeasonConfigOne(id) {
    return axios.get(`${middlegroundapi}/theme-season-config/${id}/`)
  },
  // --------------- 拷贝赛季段位配置
  copySeasonLevelConfig(data) {
    return axios.post(`${middlegroundapi}/copy-season-level-config/`, data)
  },
  // --------------- 返现/提现日志信息
  // 新增
  addUserCashOutLogRecord(data) {
    return axios.post(`${fluCard}/user-cash-out-log-record/`, data)
  },
  // 修改
  updateUserCashOutLogRecord(data, id) {
    return axios.patch(`${fluCard}/user-cash-out-log-record/${id}/`, data)
  },
  // 删除
  delUserCashOutLogRecord(id) {
    return axios.delete(`${fluCard}/user-cash-out-log-record/${id}/`)
  },
  // 获取列表
  UserCashOutLogRecordList(data) {
    return axios.get(`${fluCard}/user-cash-out-log-record/`, { params: data })
  },
  // 获取一个
  getUserCashOutLogRecordOne(id) {
    return axios.get(`${fluCard}/user-cash-out-log-record/${id}/`)
  },
  // --------------- 小程序赛事公告报名功能
  // 报名信息查询
  offlineMatchRegisterList(data) {
    return axios.get(`${liveGameApi}/api/offline-match-register/`, { params: data })
  },
  // 报名信息导出, post
  offlineMatchDumpOutPost(data) {
    return axios.post(`${liveGameApi}/api/offline-match-register/external/dump-out/`, data)
  },
  // 报名信息导出-GET版
  offlineMatchDumpOutGet(data) {
    return axios.get(`${liveGameApi}/api/offline-match-register/external/dump-out-get/`, { params: data })
  },
  offlineMatchDumpOutGetAPi: `${liveGameApi}/api/offline-match-register/external/dump-out-get/`,
  // --------------- 渠道配置(卡密使用)
  // 新增
  addChannelConfig(data) {
    return axios.post(`${kamiapisrvAPI}/channel-config/`, data)
  },
  // 修改
  updateChannelConfig(data, id) {
    return axios.patch(`${kamiapisrvAPI}/channel-config/${id}/`, data)
  },
  // 删除
  delChannelConfig(id) {
    return axios.delete(`${kamiapisrvAPI}/channel-config/${id}/`)
  },
  // 获取列表
  ChannelConfigList(data) {
    return axios.get(`${kamiapisrvAPI}/channel-config/`, { params: data })
  },
  // 获取一个
  getChannelConfigOne(id) {
    return axios.get(`${kamiapisrvAPI}/channel-config/${id}/`)
  },
  // --------------- 卡密配置
  // 新增
  addCardOrder(data) {
    return axios.post(`${kamiapisrvAPI}/card-order/`, data)
  },
  // 修改
  updateCardOrder(data, id) {
    return axios.patch(`${kamiapisrvAPI}/card-order/${id}/`, data)
  },
  // 删除
  delCardOrder(id) {
    return axios.delete(`${kamiapisrvAPI}/card-order/${id}/`)
  },
  // 获取列表
  CardOrderList(data) {
    return axios.get(`${kamiapisrvAPI}/card-order/`, { params: data })
  },
  // 获取一个
  getCardOrderOne(id) {
    return axios.get(`${kamiapisrvAPI}/card-order/${id}/`)
  },
  // 换绑手机
  changeBindingPhone(data) {
    return axios.post(`${propAPI}/prop-hash-serial-no-relation/external/update-phone/`, data)
  },
  // 京东e卡批量上传
  giftCradUploadJDEK: `${kamiapisrvAPI}/gift-card/JDEK-Batch-import/`,
  // 中石化卡批量上传
  giftCradUploadZSHK: `${kamiapisrvAPI}/gift-card/ZSHK-Batch-import/`,
  // 给用户发送短信
  cardOrderSendCode(data) {
    return axios.post(`${kamiapisrvAPI}/card-order/backend-send-code/`, data)
  },
  // 查询用户的卡密信息
  getCardOrderInfo(data) {
    return axios.post(`${kamiapisrvAPI}/card-order/backend-get-order-info/`, data)
  },
  // 卡密兑换记录
  getKamiCardExchangeLog(data) {
    return axios.get(`${fluCard}/prop-hash-serial-no-relation/`, { params: data })
  },
  getKamiCardPropOrigin(data) {
    return axios.post(`${fluCard}/prop-hash-serial-no-relation/get-prop-origin/`, data)
  },
  // 消耗汇总
  postCardConsumeAmount(data) {
    return axios.post(`${kamiapisrvAPI}/gift-card/get-card-consume-amount/`, data)
  },
  postCardConsumeNumber(data) {
    return axios.post(`${kamiapisrvAPI}/gift-card/get-card-consume-number/`, data)
  },
  // --------------- 每日分享有礼
  // 新增
  addShareGiftBagsConf(data) {
    return axios.post(`${fluCard}/share-gift-bags-config/`, data)
  },
  // 修改
  updateShareGiftBagsConf(data, id) {
    return axios.patch(`${fluCard}/share-gift-bags-config/${id}/`, data)
  },
  // 删除
  delShareGiftBagsConf(id) {
    return axios.delete(`${fluCard}/share-gift-bags-config/${id}/`)
  },
  // 获取列表
  ShareGiftBagsConfList(data) {
    return axios.get(`${fluCard}/share-gift-bags-config/`, { params: data })
  },
  // 获取一个
  getShareGiftBagsConfOne(id) {
    return axios.get(`${fluCard}/share-gift-bags-config/${id}/`)
  },
  // --------------- 卡密类型配置
  // 新增
  addKamiCardType(data) {
    return axios.post(`${kamiapisrvAPI}/kami-card-type/`, data)
  },
  // 修改
  updateKamiCardType(data, id) {
    return axios.patch(`${kamiapisrvAPI}/kami-card-type/${id}/`, data)
  },
  // 删除
  delKamiCardType(id) {
    return axios.delete(`${kamiapisrvAPI}/kami-card-type/${id}/`)
  },
  // 获取列表
  KamiCardTypeList(data) {
    return axios.get(`${kamiapisrvAPI}/kami-card-type/`, { params: data })
  },
  // 获取一个
  getKamiCardTypeOne(id) {
    return axios.get(`${kamiapisrvAPI}/kami-card-type/${id}/`)
  },
  // 卡密剩余库存
  giftCardStock(data) {
    return axios.post(`${kamiapisrvAPI}/gift-card/gift-card-stock-v2/`, data)
  },
  // --------------- 卡密道具类型绑定配置
  // 已选卡密列表
  kamiPropTypeConfigList(data) {
    return axios.get(`${kamiwatchsrvAPI}/kami-prop-type-config/list/`, data)
  },
  // 新增
  addKamiPropTypeConfig(data) {
    return axios.post(`${kamiwatchsrvAPI}/kami-prop-type-config/`, data)
  },
  // 批量新增
  batchAddKamiPropTypeConfig(data) {
    return axios.post(`${kamiwatchsrvAPI}/kami-prop-type-config/patch-bind/`, data)
  },
  // 修改
  updateKamiPropTypeConfig(data) {
    return axios.post(`${kamiwatchsrvAPI}/kami-prop-type-config/update/`, data)
  },
  // 删除
  delKamiPropTypeConfig(data) {
    return axios.post(`${kamiwatchsrvAPI}/kami-prop-type-config/delete/`, data)
  },
  // 获取列表
  KamiPropTypeConfigList(data) {
    return axios.get(`${kamiwatchsrvAPI}/kami-prop-type-config/`, { params: data })
  },
  // 获取一个
  getKamiPropTypeConfigOne(id) {
    return axios.get(`${kamiwatchsrvAPI}/kami-prop-type-config/${id}/`)
  },
  // --------------- 新年红包奖励
  // 新增
  addSpringEnvelopeConfig(data) {
    return axios.post(`${fluCard}/spring-envelope-config/`, data)
  },
  // 修改
  updateSpringEnvelopeConfig(data, id) {
    return axios.patch(`${fluCard}/spring-envelope-config/${id}/`, data)
  },
  // 删除
  delSpringEnvelopeConfig(id) {
    return axios.delete(`${fluCard}/spring-envelope-config/${id}/`)
  },
  // 获取列表
  SpringEnvelopeConfigList(data) {
    return axios.get(`${fluCard}/spring-envelope-config/`, { params: data })
  },
  // 获取一个
  getSpringEnvelopeConfigOne(id) {
    return axios.get(`${fluCard}/spring-envelope-config/${id}/`)
  },
  // --------------- 新春鞭炮礼包配置
  // 新增
  addSpringFireCrackerConf(data) {
    return axios.post(`${middlegroundapi}/spring-fire-cracker-config/`, data)
  },
  // 修改
  updateSpringFireCrackerConf(data, id) {
    return axios.patch(`${middlegroundapi}/spring-fire-cracker-config/${id}/`, data)
  },
  // 删除
  delSpringFireCrackerConf(id) {
    return axios.delete(`${middlegroundapi}/spring-fire-cracker-config/${id}/`)
  },
  // 获取列表
  SpringFireCrackerConfList(data) {
    return axios.get(`${middlegroundapi}/spring-fire-cracker-config/`, { params: data })
  },
  // 获取一个
  getSpringFireCrackerConfOne(id) {
    return axios.get(`${middlegroundapi}/spring-fire-cracker-config/${id}/`)
  },
  // --------------- 大地红点燃次数礼包配置
  // 新增
  addredEarthProcessAward(data) {
    return axios.post(`${middlegroundapi}/red-earth-process-award-config/`, data)
  },
  // 修改
  updateredEarthProcessAward(data, id) {
    return axios.patch(`${middlegroundapi}/red-earth-process-award-config/${id}/`, data)
  },
  // 删除
  delredEarthProcessAward(id) {
    return axios.delete(`${middlegroundapi}/red-earth-process-award-config/${id}/`)
  },
  // 获取列表
  redEarthProcessAwardList(data) {
    return axios.get(`${middlegroundapi}/red-earth-process-award-config/`, { params: data })
  },
  // 获取一个
  getredEarthProcessAwardOne(id) {
    return axios.get(`${middlegroundapi}/red-earth-process-award-config/${id}/`)
  },
  // --------------- 斗地主奖券兑换
  // 新增
  addPropExchangeConfig(data) {
    return axios.post(`${fluCard}/prop-exchange-config/`, data)
  },
  // 修改
  updatePropExchangeConfig(data, id) {
    return axios.patch(`${fluCard}/prop-exchange-config/${id}/`, data)
  },
  // 删除
  delPropExchangeConfig(id) {
    return axios.delete(`${fluCard}/prop-exchange-config/${id}/`)
  },
  // 获取列表
  PropExchangeConfigList(data) {
    return axios.get(`${fluCard}/prop-exchange-config/`, { params: data })
  },
  // 获取一个
  getPropExchangeConfigOne(id) {
    return axios.get(`${fluCard}/prop-exchange-config/${id}/`)
  },
  // --------------- 比赛场场景配置
  // 新增
  addMatchScene(data) {
    return axios.post(`${matchAPI}/v1/match/scene/add`, data)
  },
  // 修改
  updateMatchScene(data) {
    return axios.post(`${matchAPI}/v1/match/scene/update`, data)
  },
  // 删除
  delMatchScene(data) {
    return axios.post(`${matchAPI}/v1/match/scene/delete`, data)
  },
  // 获取列表
  MatchSceneList(data) {
    return axios.post(`${matchAPI}/v1/match/scene/list`, data)
  },
  // --------------- 智运会决赛奖励描述配置
  // 新增
  addZlhFinalAwardDesc(data) {
    return axios.post(`${matchhonoursAPI}/zlh-final-award-desc/`, data)
  },
  // 修改
  updateZlhFinalAwardDesc(data, id) {
    return axios.patch(`${matchhonoursAPI}/zlh-final-award-desc/${id}/`, data)
  },
  // 删除
  delZlhFinalAwardDesc(id) {
    return axios.delete(`${matchhonoursAPI}/zlh-final-award-desc/${id}/`)
  },
  // 获取列表
  ZlhFinalAwardDescList(data) {
    return axios.get(`${matchhonoursAPI}/zlh-final-award-desc/`, { params: data })
  },
  // 获取一个
  getZlhFinalAwardDescOne(id) {
    return axios.get(`${matchhonoursAPI}/zlh-final-award-desc/${id}/`)
  },
  // --------------- 智运会决赛获奖图片配置
  // 新增
  addZlhAwardPictureRecord(data) {
    return axios.post(`${matchhonoursAPI}/zlh-award-picture-record/`, data)
  },
  // 修改
  updateZlhAwardPictureRecord(data, id) {
    return axios.patch(`${matchhonoursAPI}/zlh-award-picture-record/${id}/`, data)
  },
  // 删除
  delZlhAwardPictureRecord(id) {
    return axios.delete(`${matchhonoursAPI}/zlh-award-picture-record/${id}/`)
  },
  // 获取列表
  ZlhAwardPictureRecordList(data) {
    return axios.get(`${matchhonoursAPI}/zlh-award-picture-record/`, { params: data })
  },
  // 获取一个
  getZlhAwardPictureRecordOne(id) {
    return axios.get(`${matchhonoursAPI}/zlh-award-picture-record/${id}/`)
  },
  // 批量上传图片
  zlhAwardBatchAddPictures(data) {
    return axios.post(`${matchhonoursAPI}/zlh-award-picture-record/batch-add-pictures/`, data)
  },

  // 获取邀请活动配置
  getInviteActiveConfig(data) {
    return axios.get(`${activeConfigApi}/common-invite-config/`, { params: data })
  },

  // 新增邀请活动总配置CRUD
  addInviteActiveConfig(data) {
    return axios.post(`${activeConfigApi}/common-invite-config/`, data)
  },


  // 编辑邀请活动总配置CRUD
  editInviteActiveConfig(id, data) {
    return axios.patch(`${activeConfigApi}/common-invite-config/${id}/`, data)
  },

  // 新增场景key配置CRUD
  addScreenKey(data) {
    return axios.post(`${activeConfigApi}/common-invite-period-config/`, data)
  },


  // 获取某个场景key配置CRUD
  getScreenKey(id) {
    return axios.get(`${activeConfigApi}/common-invite-period-config/?order_by=-id&game_id=${id}`)
  },

  // 删除某个场景key配置CRUD
  delScreenKey(id) {
    return axios.delete(`${activeConfigApi}/common-invite-period-config/${id}/`)
  },

  // 删除邀请活动总配置CRUD
  delInviteActiveConfig(id) {
    return axios.delete(`${activeConfigApi}/common-invite-config/${id}/`)
  },


  // 新增活动时间间隔
  addTimeInterval(data) {
    return axios.post(`${activeConfigApi}/common-invite-small-period-record/`, data)
  },

  // 列表大活动下小活动区间配置CRUD
  getTImeIntervalList(data) {
    return axios.get(`${activeConfigApi}/common-invite-small-period-record/`, { params: data })
  },
  // 修改大活动下小活动区间配置CRUD
  editTImeIntervalList(id, data) {
    return axios.patch(`${activeConfigApi}/common-invite-small-period-record/${id}/`, data)
  },

  deleteTimeInterval(id) {
    return axios.delete(`${activeConfigApi}/common-invite-small-period-record/${id}/`)
  },
  // --------------- 控牌配置
   // 删除子游戏
  delGameCoreKey(data) {
    return axios.post(`${controlCardApi}/coinplace-balance-user-rate/del-game-core-key/`, data)
  },
  // 新增子游戏
  addGameCoreKey(data) {
    return axios.post(`${controlCardApi}/coinplace-balance-user-rate/add-game-core-key/`, data)
  },
  // 获取所有子游戏列表
  getAllGameRulesList(params) {
    return axios.get(`${controlCardApi}/coinplace-balance-user-rate/get-game/`, { params })
  },
  // 获取当前子游戏列表
  getGameRulesList(params) {
    return axios.get(`${controlCardApi}/coinplace-balance-user-rate/get-game-core-key/`, { params })
  },
  // ---------- 麻将分数配置
  // 查询配置数据
  getMjBalanceConfig(data) {
    return axios.get(`${controlCardApi}/majiang-balance-config/`, { params: data })
  },
  updateMjBalanceConfig(data) {
    return axios.post(`${controlCardApi}/majiang-balance-config/`, data)
  },
  // 查询用户调控概率
  getBalanceUserRateApi(data) {
    return axios.post(`${controlCardApi}/coinplace-balance-user-rate/get-balance-user-rate/`, data)
  },
  // 修改用户概率
  updateBalanceUserRateApi(data) {
    return axios.post(`${controlCardApi}/coinplace-balance-user-rate/update-balance-user-rate/`, data)
  },
  // 查询调控策略
  getBalanceSchemeListApi(data) {
    return axios.post(`${controlCardApi}/coin-place-balance-scheme/get-balance-scheme-list/`, data)
  },
  // 修改调控策略
  updateBalanceSchemeApi(data) {
    return axios.post(`${controlCardApi}/coin-place-balance-scheme/update-balance-scheme/`, data)
  },
  // 查询扑克分数
  searchPokerScore(data) {
    return axios.post(`${controlCardApi}/poker-score/`, data)
  },
  // --------------- 控牌配置
  // 获取所有平台
  getPlatformList(data) {
    return axios.post(`${operationApi}/back-mj-user-game-id`, data)
  },
  // 获取平台下对应的子游戏
  getGameAreaOfPlatform(data) {
    return axios.post(`${operationApi}/back-mj-game-area-name`, data)
  },
  // 查询子游戏牌局人数
  getGameAreaUserNumApi(data) {
    return axios.post(`${operationApi}/back-mj-user-count`, data)
  },
  // 调控明细表
  getCoinGameAdjustCardsModelApi(data) {
    // return axios.post(`${dealStrategyApi}/coinplace/balance/get-coin-game-adjust-cards-model/`, data)
    return axios.post(`${operationApi}/app-mj-optimize-detail`, data)
  },
  // 配置牌型-配置牌型分布比例
  getGameSurplusModelDistributionRateApi(data) {
    // return axios.post(`${dealStrategyApi}/coinplace/balance/get-game-surplus-model-distribution-rate/`, data)
    return axios.post(`${operationApi}/app-mj-model-distribution`, data)
  },
  // 配置牌型-剩余牌张数
  getGameSurplusModelRelationApi(data) {
    // return axios.post(`${dealStrategyApi}/coinplace/balance/get-game-surplus-model-relation/`, data)
    return axios.post(`${operationApi}/app-mj-model-detail`, data)
  },
  // 配置牌型-剩余牌张数(平均小局时长，托管率，胜率)
  getNumberOfRemainingCardsApi(data) {
    return axios.post(`${operationApi}/app-game-card-type-detail`, data)
  },
  // 列表关卡特殊积分CRUD
  getSpecialScoreList(data) {
    return axios.get(`${challengeApi}/stage-special-point-config/`, { params: data })
  },
  // 新增特殊关卡CRUD
  addSpecialLevelApi(data) {
    return axios.post(`${challengeApi}/special-stage-config/`, data)
  },
  // 获取特殊关卡CRUD
  getSpecialLevelApi(data) {
    return axios.get(`${challengeApi}/special-stage-config/`, { params: data })
  },
  // 编辑特殊关卡CRUD
  editSpecialLevelApi(id, data) {
    return axios.patch(`${challengeApi}/special-stage-config/${id}/`, data)
  },
  // 编辑特殊关卡CRUD
  deleteSpecialLevelApi(id) {
    return axios.delete(`${challengeApi}/special-stage-config/${id}/`)
  },
  // 获取挑战赛大厅---基础配置
  getChallengeHallApi(data) {
    return axios.get(`${challengeApi}/participate-nums-probability-config/`, { params: data })
  },
  // 编辑挑战赛大厅---基础配置
  editChallengeHallApi(data) {
    return axios.post(`${challengeApi}/participate-nums-probability-config-update/`, data)
  },
  // 用户标签----------------------------- userLabelApi
  // 新增标签
  addLabelConfigApi(data) {
    return axios.post(`${userLabelApi}/userlabelv2/label-config/`, data)
  },
  addLabelConfigApiNew(data) {
    return axios.post(`${userLabelApiNew}/userlabelv4/label-config/`, data)
  },
  // 修改标签
  updateLabelConfigApi(data, id) {
    return axios.patch(`${userLabelApi}/userlabelv2/label-config/${id}/`, data)
  },
  updateLabelConfigApiNew(data, id) {
    return axios.patch(`${userLabelApiNew}/userlabelv4/label-config/${id}/`, data)
  },
  // 查询标签详情
  getLabelConfigByIdApi(data, id) {
    return axios.get(`${userLabelApi}/userlabelv2/label-config/${id}/`, { params: data })
  },
  // 删除标签
  deleteLabelConfigApi(id) {
    return axios.delete(`${userLabelApi}/userlabelv2/label-config/${id}/`)
  },
  deleteLabelConfigApiNew(id) {
    return axios.delete(`${userLabelApiNew}/userlabelv4/label-config/${id}/`)
  },
  // 获取标签的列表
  getLabelConfigApi(data) {
    return axios.get(`${userLabelApi}/userlabelv2/label-config/`, { params: data })
  },
  getLabelConfigApiNew(data) {
    return axios.get(`${userLabelApiNew}/userlabelv4/label-config/`, { params: data })
  },
  // 标签控制
  changeLabelApi(id) {
    return axios.post(`${userLabelApi}/userlabelv2/label-config/switch/${id}/`)
  },
  changeLabelApNew(id) {
    return axios.post(`${userLabelApiNew}/userlabelv4/label-config/switch/${id}/`)
  },
  // 新增人群
  addPersonaConfigApi(data) {
    return axios.post(`${userLabelApi}/userlabelv2/persona-config/`, data)
  },
  addPersonaConfigApiNew(data) {
    return axios.post(`${userLabelApiNew}/userlabelv4/persona-config/`, data)
  },
  // 修改人群
  updatePersonaConfigApi(data, id) {
    return axios.patch(`${userLabelApi}/userlabelv2/persona-config/${id}/`, data)
  },
  updatePersonaConfigApiNew(data, id) {
    return axios.patch(`${userLabelApiNew}/userlabelv4/persona-config/${id}/`, data)
  },
  // 查询人群详情
  getPersonaConfigByIdApi(data, id) {
    return axios.get(`${userLabelApi}/userlabelv2/persona-config/${id}/`, { params: data })
  },
  // 删除人群
  deletePersonaConfigApi(id) {
    return axios.delete(`${userLabelApi}/userlabelv2/persona-config/${id}/`)
  },
  deletePersonaConfigApiNew(id) {
    return axios.delete(`${userLabelApiNew}/userlabelv4/persona-config/${id}/`)
  },
  // 获取人群的列表
  getPersonaConfigApi(data) {
    return axios.get(`${userLabelApi}/userlabelv2/persona-config/`, { params: data })
  },
  // 获取人群的列表
  getPersonaConfigApiNew(data) {
    return axios.get(`${userLabelApiNew}/userlabelv4/persona-config/`, { params: data })
  },
  // 人群命中查询
  getPersonaHitedApi(data) {
    return axios.post(`${userLabelApiNew}/userlabelv4/user-fit-persona/`, data)
  },
  // 获取扑克调控配置接口
  getCardControlConfigApi(data) {
    return axios.get(`${controlCardApi}/poker-balance-config/${data.gameKey}`)
  },
  // 编辑扑克调控配置接口
  editCardControlConfigApi(gameKey, data) {
    return axios.post(`${controlCardApi}/poker-balance-config/${gameKey}`, data)
  },
  // =======================商品礼包拷贝=========================
  // 跨平台批量复制礼包
  batchCopyGiftApi(data) {
    return axios.post(`${propAPI}/shop/external/gift-bags/batch-copy-bag-gameid/`, data)
  },
  // 跨平台批量复制商品
  batchCopyshopApi(data) {
    return axios.post(`${propAPI}/shop/external/shop/batch-copy-shop-gameid/`, data)
  },
  // 跨平台批量复制商品
  batchCopyappchannelApi(data) {
    return axios.post(`${propAPI}/shop/external/shop/batch-copy-shop-appchannel/`, data)
  },
  // =======================限时秒杀后台接口=========================
  // -------------------------秒杀活动配置---------------------------
  // 新增秒杀活动配置
  addTicketSeckillConfig(data) {
    return axios.post(`${limittimeactivityApi}/ticket-seckill-config/`, data)
  },
  // 修改秒杀活动配置
  editTicketSeckillConfig(data, id) {
    return axios.patch(`${limittimeactivityApi}/ticket-seckill-config/${id}/`, data)
  },
  // 秒杀活动配置列表
  getTicketSeckillConfig(data) {
    return axios.get(`${limittimeactivityApi}/ticket-seckill-config/`, { params: data })
  },
  // 获取某个秒杀活动配置
  getSingleTicketSeckillConfig(id) {
    return axios.get(`${limittimeactivityApi}/ticket-seckill-config/${id}/`)
  },
  // 删除秒杀活动配置
  deleteTicketSeckillConfig(id) {
    return axios.delete(`${limittimeactivityApi}/ticket-seckill-config/${id}/`)
  },
  // --------------------------秒杀奖励配置------------------------------
  // 新增秒杀奖励配置
  addTicketExchangePropConfig(data) {
    return axios.post(`${limittimeactivityApi}/ticket-exchange-prop-config/`, data)
  },
  // 修改秒杀奖励配置
  editTicketExchangePropConfig(data, id) {
    return axios.patch(`${limittimeactivityApi}/ticket-exchange-prop-config/${id}/`, data)
  },
  // 秒杀奖励配置列表
  getTicketExchangePropConfig(data) {
    return axios.get(`${limittimeactivityApi}/ticket-exchange-prop-config/`, { params: data })
  },
  // 获取某个秒杀奖励配置
  getSingleTicketExchangePropConfig(id) {
    return axios.get(`${limittimeactivityApi}/ticket-exchange-prop-config/${id}/`)
  },
  // 删除秒杀奖励配置
  deleteTicketExchangePropConfig(id) {
    return axios.delete(`${limittimeactivityApi}/ticket-exchange-prop-config/${id}/`)
  },
  // --------------------------每日道具库存------------------------------
  // 新增道具每日库存配置
  addActivityPropDateStockConfig(data) {
    return axios.post(`${dailyStockApi}/activity-prop-date-stock-config/`, data)
  },
  //  修改道具每日库存配置
  editActivityPropDateStockConfig(data, id) {
    return axios.patch(`${dailyStockApi}/activity-prop-date-stock-config/${id}/`, data)
  },
  // 道具每日库存配置列表
  getActivityPropDateStockConfig(data) {
    return axios.get(`${dailyStockApi}/activity-prop-date-stock-config/`, { params: data })
  },
  // 获取某个道具每日库存配置
  getSingleActivityPropDateStockConfig(id) {
    return axios.get(`${dailyStockApi}/activity-prop-date-stock-config/${id}`)
  },
  // 删除秒杀奖励配置
  deleteActivityPropDateStockConfig(id) {
    return axios.delete(`${dailyStockApi}/activity-prop-date-stock-config/${id}/`)
  },
  // --------------------------限时礼包------------------------------
  // 获取限时礼包配置
  getGiftPropConfig(data) {
    return axios.get(`${limittimeactivityApi}/new_year_3_days_shop_config/`, { params: data })
  },
    // 编辑礼包配置
  editGiftPropConfig(data, id) {
    return axios.patch(`${limittimeactivityApi}/new_year_3_days_shop_config/${id}`, data)
  },
    // 删除礼包配置
  deleteGiftPropConfig(id) {
    return axios.delete(`${limittimeactivityApi}/new_year_3_days_shop_config/${id}`)
  },
  // 新增礼包配置
  addGiftPropConfig(data) {
    return axios.post(`${limittimeactivityApi}/new_year_3_days_shop_config/`, data)
  },
  // --------
  // 交换位置
  changeShopPositionAPI(data) {
    return axios.post(`${drawLotApi}/shop-product/reorder/`, data)
  },
  // 查询一级分组
  getShopInfoGroup(data) {
    return axios.get(`${fluCard}/shop-page-type-relation/get-shop-info-group/`, { params: data })
  },
  //= ===========================前端游戏包配置接口===========================
  //   新增游戏包配置
  addGamePackageConfig(data) {
    return axios.post(`${gamePackageApi}/game-package-config/`, data)
  },
  //   修改游戏包配置
  editGamePackageConfig(data, id) {
    return axios.patch(`${gamePackageApi}/game-package-config/${id}/`, data)
  },
  //   获取游戏包配置列表
  getGamePackageConfig(data) {
    return axios.get(`${gamePackageApi}/game-package-config/`, { params: data })
  },
  //   删除游戏包配置
  delGamePackageConfig(id) {
    return axios.delete(`${gamePackageApi}/game-package-config/${id}/`)
  },
   //   新增渠道配置
  addGameChannelConfig(data) {
    return axios.post(`${gamePackageApi}/channel-package-config/`, data)
  },
  //   修改渠道配置
  editGameChannelConfig(data, id) {
    return axios.patch(`${gamePackageApi}/channel-package-config/${id}/`, data)
  },
  //   渠道配置2 获取渠道配置列表
  getChannelPackageList(data) {
    return axios.get(`${gamePackageApi}/channel-package-config/`, { params: data })
  },
  //   获取渠道配置列表
  getGameChannelList(data) {
    return axios.get(`${gamePackageApi}/channel-config/`, { params: data })
  },
  //   删除渠道配置
  delGameChannelConfig(id) {
    return axios.delete(`${gamePackageApi}/channel-package-config/${id}/`)
  },
  //= ========================新开关配置=============================
  //   添加开关
  addFuncSwitchConfig(data) {
    return axios.post(`${gamePackageApi}/func-switch-config/add/`, data)
  },
  //   获取开关列表
  getFuncSwitchConfig(data) {
    return axios.get(`${gamePackageApi}/func-switch-config/`, { params: data })
  },
  //   修改开关
  editFuncSwitchConfig(data) {
    return axios.post(`${gamePackageApi}/func-switch-config/update/`, data)
  },
  //   删除开关
  delFuncSwitchConfig(data) {
    return axios.post(`${gamePackageApi}/func-switch-config/delete/`, data)
  },
  // 功能开关里面获取当前平台配置的游戏包
  getCurGamePackage(data) {
    return axios.post(`${gamePackageApi}/func-switch-config/get-func-switch-marks/`, data)
  },
  // 获取回归签到配置列表
  getSignInConfig(data) {
    return axios.get(`${signInAPI}/middlegroundapisrv/user-back-daily-signin-config/`, { params: data })
    // return axios.get('http://129.211.113.36:8140/middlegroundapisrv/user-back-daily-signin-config/', { params: data })
  },
  // 新增回归签到配置
  addSignInConfig(data) {
    return axios.post(`${signInAPI}/middlegroundapisrv/user-back-daily-signin-config/`, data)
    // return axios.post('http://129.211.113.36:8140/middlegroundapisrv/user-back-daily-signin-config/', data)
  },
  // 更新回归签到配置
  updateSignInConfig(data, id) {
    return axios.patch(`${signInAPI}/middlegroundapisrv/user-back-daily-signin-config/${id}/`, data)
    // return axios.patch(`http://129.211.113.36:8140/middlegroundapisrv/user-back-daily-signin-config/${id}/`, data)
  },
  // 删除回归签到配置
  deleteSignInConfig(id) {
    return axios.delete(`${signInAPI}/middlegroundapisrv/user-back-daily-signin-config/${id}/`)
    // return axios.delete(`http://129.211.113.36:8140/middlegroundapisrv/user-back-daily-signin-config/${id}/`)
  },
  // 获取任务配置列表
  getTaskConfigList(data) {
    return axios.get(`${backUserTaskConfig}/task-srv/admin/task-parent-child/`, { params: data })
    // return axios.get('http://129.211.113.36:30012/task-srv/admin/task-parent-child/', { params: data })
  },
  // 新增任务配置
  addTaskConfig(data) {
    return axios.post(`${backUserTaskConfig}/task-srv/admin/task-parent-child/`, data)
    // return axios.post('http://129.211.113.36:30012/task-srv/admin/task-parent-child/', data)
  },
  // 更新任务配置
  updateTaskConfig(data, id) {
    return axios.patch(`${backUserTaskConfig}/task-srv/admin/task-parent-child/${id}/`, data)
    // return axios.patch(`http://129.211.113.36:30012/task-srv/admin/task-parent-child/${id}/`, data)
  },
  // 删除任务配置
  deleteTaskConfig(id) {
    return axios.delete(`${backUserTaskConfig}/task-srv/admin/task-parent-child/${id}/`)
    // return axios.delete(`http://129.211.113.36:30012/task-srv/admin/task-parent-child/${id}/`)
  },
  // 获得任务类型列表
  getUserBackTaskProcessingType() {
    return axios.post(`${backUserTaskConfig}/task-srv/admin/user-back-task-processing-type/`)
    // return axios.post('http://129.211.113.36:30012/task-srv/admin/user-back-task-processing-type/')
  },
  // 查询运营活动配置列表
  getActivityConfigList(data) {
    return axios.post(`${middlegroundapi}/task-activity/get-task-activity-config-list/`, data)
  },
  // 新增运营活动配置
  addActivityConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/add-task-activity-config/`, data)
  },
  // 编辑运营活动配置
  editActivityConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/update-task-activity-config/`, data)
  },
  // 删除运营活动配置
  deleteActivityConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/del-task-activity-config/`, data)
  },
  // 查询任务配置列表
  getActivityTaskConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/get-task-activity-config-parent-list/`, data)
  },
  // 新增任务配置
  addActivityTaskConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/add-task-activity-parent-config/`, data)
  },
  // 编辑任务配置
  editActivityTaskConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/update-task-activity-parent-config/`, data)
  },
  // 删除任务配置
  deleteActivityTaskConfig(data) {
    return axios.post(`${middlegroundapi}/task-activity/del-task-activity-parent-config/`, data)
  },
  //= =======================分享卡片库=======================================
  // 添加卡片库配置
  addCardBaseConfig(data) {
    return axios.post(`${gamePackageApi}/card-base-config/`, data)
  },
  // 修改卡片库配置
  editCardBaseConfig(data, id) {
    return axios.patch(`${gamePackageApi}/card-base-config/${id}/`, data)
  },
  // 获取卡片库配置列表
  getCardBaseList(data) {
    return axios.get(`${gamePackageApi}/card-base-config/`, { params: data })
  },
  // 删除卡片库配置
  delCardBaseConfig(id) {
    return axios.delete(`${gamePackageApi}/card-base-config/${id}/`)
  },
  // 添加分享点配置
  addShareCardConfig(data) {
    return axios.post(`${gamePackageApi}/share-card-config/`, data)
  },
  // 修改分享点配置
  editShareCardConfig(data, id) {
    return axios.patch(`${gamePackageApi}/share-card-config/${id}/`, data)
  },
  // 获取分享点配置列表
  getShareCardList(data) {
    return axios.post(`${gamePackageApi}/share-card-config/get/`, data)
  },
  // 删除分享点配置
  delShareCardConfig(id) {
    return axios.delete(`${gamePackageApi}/share-card-config/${id}/`)
  },
  // -------------------------拉新活动配置-------------------------------
  // 列表拉新奖励一级配置
  getlaxinAwardList(data) {
    return axios.post(`${drawLotApi}/hupenghuanyou-get-period-config/`, data)
  },
  // 新增拉新奖励配置(一级配置)
  addlaxinAwardConfig(data) {
    return axios.post(`${drawLotApi}/hupenghuanyou-add-period-config/`, data)
  },
  // 修改拉新奖励配置
  updatelaxinAwardConfig(data) {
    return axios.post(`${drawLotApi}/hupenghuanyou-update-period-config/`, data)
  },
  // 拉新奖励二级配置
  getlaxinAwardDetail(data) {
    return axios.post(`${drawLotApi}/hupenghuanyou-get-detail-config/`, data)
  },
  // 删除配置（一级配置）
  dellaxinAwardConfig(data) {
    return axios.post(`${drawLotApi}/hupenghuanyou-delete-config/`, data)
  },
  // 配置开关控制
  switchlaxinAwardConfig(data) {
    return axios.post(`${drawLotApi}/hupneghuanyou-period-config-switch/`, data)
  },
  // 智运会大转盘（新）
  // ----- 获取大转盘基础配置列表
  getTurnTableConfig() {
    return axios.get(`${matchhonoursAPI}/dazhuanpan-base-config/`)
  },
  // ----- 新增大转盘基础配置
  addTurnTableBaseConfig(data) {
    return axios.post(`${matchhonoursAPI}/dazhuanpan-base-config/`, data)
  },
  // ----- 新增大转盘奖励配置
  addTurnTableReward(data) {
    return axios.post(`${matchhonoursAPI}/dazhuanpan-prop-config/`, data)
  },
  // ---- 删除大转盘基础配置
  deleteTurnTableBaseConfig(id) {
    return axios.delete(`${matchhonoursAPI}/dazhuanpan-base-config/${id}/`)
  },
  // ---- 获取大转盘奖励配置
  getTurnTableReward(data) {
    return axios.get(`${matchhonoursAPI}/dazhuanpan-prop-config/`, { params: data })
  },
  // ---- 修改大转盘基础配置
  editTurnTableBaseConfig(id, data) {
    return axios.patch(`${matchhonoursAPI}/dazhuanpan-base-config/${id}/`, data)
  },
  // ---- 修改大转盘奖励配置
  editTurnTableReward(id, data) {
    return axios.patch(`${matchhonoursAPI}/dazhuanpan-prop-config/${id}/`, data)
  },
  // ===============================特权配置===============================
  // 查询特权配置
  getPrivilegeConfigApi(data) {
    return axios.get(`${drawLotApi}/privilege/privilege_right_config/`, { params: data })
  },
  // 新增特权配置
  addPrivilegeConfigApi(data) {
    return axios.post(`${drawLotApi}/privilege/privilege_right_config/`, data)
  },
  // 修改特权配置
  editPrivilegeConfigApi(id, data) {
    return axios.patch(`${drawLotApi}/privilege/privilege_right_config/${id}/`, data)
  },
  // 查询特权团购配置
  getPrivilegePurchaseApi(data) {
    return axios.get(`${drawLotApi}/privilege/group_buy_config/`, { params: data })
  },
  // 新增特权团购配置
  addPrivilegePurchaseApi(data) {
    return axios.post(`${drawLotApi}/privilege/group_buy_config/`, data)
  },
  // 修改特权团购配置
  editPrivilegePurchaseApi(id, data) {
    return axios.patch(`${drawLotApi}/privilege/group_buy_config/${id}/`, data)
  },
  // 修改特权团购状态配置
  editPurchaseStatusApi(data) {
    return axios.post(`${drawLotApi}/privilege/group_buy_config_switch/`, data)
  },
  // 查询特权神秘商店配置
  getPrivilegeShopApi(data) {
    return axios.get(`${drawLotApi}/privilege/mysterious_shop_config/`, { params: data })
  },
  // 新增特权神秘商店配置
  addPrivilegeShopApi(data) {
    return axios.post(`${drawLotApi}/privilege/mysterious_shop_config/`, data)
  },
  // 修改特权神秘商店配置
  editPrivilegeShopApi(id, data) {
    return axios.patch(`${drawLotApi}/privilege/mysterious_shop_config/${id}/`, data)
  },
  // 修改特权神秘商店状态配置
  editShopStatusApi(data) {
    return axios.post(`${drawLotApi}/privilege/mysterious_shop_config_switch/`, data)
  },
  // ===============================求签祈福===============================
  // 查询求签配置
  getDrawLotConfig(data) {
    return axios.get(`${drawLotApi}/draw-lot-config-v2/`, { params: data })
  },
  // 新增求签配置
  addDrawLotConfig(data) {
    return axios.post(`${drawLotApi}/draw-lot-config-v2/`, data)
  },
  // 修改求签配置
  editDrawLotConfig(id, data) {
    return axios.patch(`${drawLotApi}/draw-lot-config-v2/${id}/`, data)
  },
  // 删除配置
  delDrawLotConfig(id) {
    return axios.delete(`${drawLotApi}/draw-lot-config-v2/${id}/`)
  },
  // copy配置根据平台id
  copyGameIds(data) {
    return axios.post(`${drawLotApi}/draw-lot-config-v2/copy-game-ids/`, data)
  },
  // copy配置根据渠道
  copyAppChannels(data) {
    return axios.post(`${drawLotApi}/draw-lot-config-v2/copy-app-channels/`, data)
  },
  // 查询祝福配置列表
  getPrayConfig(data) {
    return axios.get(`${drawLotApi}/pray-config/`, { params: data })
  },
  // 获取单个祝福
  getOnePrayConfig(id) {
    return axios.get(`${drawLotApi}/pray-config/${id}/`)
  },
  // 修改祈福状态(new)
  editPrayStatus(id, data) {
    return axios.post(`${drawLotApi}/pray-config/state/${id}/`, data )
  },
  // 新增祝福配置
  addPrayConfig(data) {
    return axios.post(`${drawLotApi}/pray-config/`, data )
  },
  // 修改祝福配置
  editPrayConfig(id, data) {
    return axios.patch(`${drawLotApi}/pray-config/${id}/`, data)
  },
  // 删除祝福配置
  delPrayConfig(id) {
    return axios.delete(`${drawLotApi}/pray-config/${id}/`)
  },
  // copy配置根据平台id
  coryPrayIdsConfig(data) {
    return axios.post(`${drawLotApi}/pray-config/copy-game-ids/`,data)
  },
  // copy配置根据渠道
  coryPrayChannelConfig(data) {
    return axios.post(`${drawLotApi}/pray-config/copy-app-channels/`,data)
  },
  // 查询历史配置记录
  getDrawLotConfigHistory(data) {
    return axios.get(`${drawLotApi}/pray-config-log/`, { params: data })
  },
  // ========================小程序好友赠送=============================
  // 通过渠道查询配置列表接口
  getAskforConfigList(data) {
    return axios.get(`${laxinApi}/askfor/admin/config/queryPage`, { params: data })
  },
  // 新增配置接口
  addAskforConfig(data) {
    return axios.post(`${laxinApi}/askfor/admin/config/add`, data)
  },
  // 修改配置接口
  updateAskforConfig(data) {
    return axios.post(`${laxinApi}/askfor/admin/config/update`, data)
  },
  // 删除配置接口
  deleteAskforConfig(data) {
    return axios.post(`${laxinApi}/askfor/admin/config/delete`, data)
  },
  //广告误触配置查询
  getBannerTouchConfig(channel,gamepack,currentPage,pageSize) {
    return axios.get(`${bannerTouchConfig}/nextgame-banner-touch-config/?package_channel=${channel}&game_package_mark=${gamepack}&page=${currentPage}&size=${pageSize}&order_by=-id`)
  },
  //新增广告误触配置
  addBannerTouchConfig(data) {
    return axios.post(`${bannerTouchConfig}/nextgame-banner-touch-config/`,data)
  },
  //删除广告误触配置
  deleteBannerTouchConfig(id) {
    return axios.delete(`${bannerTouchConfig}/nextgame-banner-touch-config/${id}/`)
  },
  //修改广告误触配置
  patchBannerTouchConfig(id,data) {
    return axios.patch(`${bannerTouchConfig}/nextgame-banner-touch-config/${id}/`,data)
  },
  //对局有礼开关配置
  getMatchSwitchConfig(channel,gamePack,currentPage,pageSize) {
    return axios.get(`${bannerTouchConfig}/nextgame-times-global-config/?package_channel=${channel}&game_package_mark=${gamePack}&page=${currentPage}&size=${pageSize}&order_by=-id`)
  },
  //对局有礼开关修改
  patchMatchSwitchConfig(id,data) {
    return axios.patch(`${bannerTouchConfig}/nextgame-times-global-config/${id}/`,data)
  },
  //对局有礼开关新增
  AddMatchSwitchConfig(data) {
    return axios.post(`${bannerTouchConfig}/nextgame-times-global-config/`,data)
  },
  //对局有礼配置查询
  getMatchConfig(channel,gamePack,currentPage,pageSize) {
    return axios.get(`${bannerTouchConfig}/nextgame-times-award-config/?package_channel=${channel}&game_package_mark=${gamePack}&page=${currentPage}&size=${pageSize}&order_by=-times`)
  },
  //新增对局有礼配置
  addMatchConfig(data) {
    return axios.post(`${bannerTouchConfig}/nextgame-times-award-config/`,data)
  },
  //删除对局有礼配置
  deleteMatchConfig(id) {
    return axios.delete(`${bannerTouchConfig}/nextgame-times-award-config/${id}/`)
  },
  //修改对局有礼配置
  patchMatchConfig(id,data) {
    return axios.patch(`${bannerTouchConfig}/nextgame-times-award-config/${id}/`,data)
  },
  // 洗牌配置查询
  getShuffleConfig(channel,gamePack,currentPage,pageSize) {
    return axios.get(`${shuffleConfigApi}/api/shuffle-config/?package_channel=${channel}&game_package_mark=${gamePack}&page=${currentPage}&size=${pageSize}`)
  },
  //新增洗牌配置
  addShuffleConfig(data) {
    return axios.post(`${shuffleConfigApi}/api/shuffle-config/`,data)
  },
  //删除洗牌配置
  deleteShuffleConfig(id) {
    return axios.delete(`${shuffleConfigApi}/api/shuffle-config/${id}/`)
  },
  //修改洗牌配置
  patchShuffleConfig(id,data) {
    return axios.patch(`${shuffleConfigApi}/api/shuffle-config/${id}/`,data)
  },
   // 批量拷贝洗牌配置
   postShuffleCopy(data) {
    return axios.post(`${shuffleConfigApi}/api/shuffle-config/copy/`,data)
  },
  //配置查重
  postShuffleConfigIsexist(data){
    return axios.post(`${shuffleConfigApi}/api/shuffle-config/is-exist/`,data)
  },

    //获取弹窗配置
    postManageConfig(){
      return axios.post(`${strongConfigApi}/admin/management/pop/out/list`)
    },
    //添加弹窗
    addManageConfig(data){
      return axios.post(`${strongConfigApi}/admin/management/pop/out/add`,data)
    },
    // 修改弹窗
    updateManageConfig(data){
      return axios.post(`${strongConfigApi}/admin/management/pop/out/update`,data)
    },
    // 删除弹窗
    delManageConfig(data){
      return axios.post(`${strongConfigApi}/admin/management/pop/out/del`,data)
    },
    //获取活动强弹配置
    postStrongConfig(data){
      return axios.post(`${strongConfigApi}/admin/activity/pop/out/list`,data)
    },
    // 修改强弹配置
    updateStrongConfig(data){
      return axios.post(`${strongConfigApi}/admin/activity/pop/out/update`,data)
    },
    // 强弹配置复制
    copyStrongConfig(data){
      return axios.post(`${strongConfigApi}/admin/activity/pop/out/copy`,data)
    },
  // ------- 平台跳转 --------- 联运
  // 获取联运游戏配置列表
  getJointGameList(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-config/list/`, data)
  },
  // 新增联运游戏配置
  addJointGameConfig(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-config/add/`, data)
  },
  // 修改联运游戏配置
  updateJointGameConfig(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-config/update/`, data)
  },
  // 删除联运游戏配置
  deleteJointGameConfig(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-config/delete/`, data)
  },
  changeJointGameWeight(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-config/sort/`, data)
  },
  // ------- 平台跳转 --------- 同主体
  // 获取同主体游戏配置列表
  getSameSubjectGameList(data) {
    return axios.post(`${thirdPartyGameApi}/same-subject-game-config/list/`, data)
  },
  // 新增同主体游戏配置
  addSameSubjectGameConfig(data) {
    return axios.post(`${thirdPartyGameApi}/same-subject-game-config/add/`, data)
  },
  // 修改同主体游戏配置
  updateSameSubjectGameConfig(data) {
    return axios.post(`${thirdPartyGameApi}/same-subject-game-config/update/`, data)
  },
  // 删除同主体游戏配置
  deleteSameSubjectGameConfig(data) {
    return axios.post(`${thirdPartyGameApi}/same-subject-game-config/delete/`, data)
  },
    //======================广告ID后台============================
  //广告ID管理
  getAdList(data) {
    return axios.get(`${drawLotApi}/ad/list`, { params: data })
  },
  // addAdConfig(data) {
  //   return axios.post(`${drawLotApi}/ad/add`,  data )
  // },
  editAdConfig(data) {
    return axios.post(`${drawLotApi}/ad/edit`,  data )
  },
  // delAdConfig(data) {
  //   return axios.get(`${drawLotApi}/ad/del`,  { params: data } )
  // },
  // 广告位管理
  getAdObjectList(data) {
    return axios.get(`${drawLotApi}/ad_object/list`, { params: data })
  },
  addAdObjectConfig(data) {
    return axios.post(`${drawLotApi}/ad_object/add`,  data )
  },
  editAdObjectConfig(data) {
    return axios.post(`${drawLotApi}/ad_object/edit`,  data )
  },
  delAdObjectConfig(data) {
    return axios.get(`${drawLotApi}/ad_object/del`,  { params: data } )
  },
  // 同步广告位
  syncAllConfigAPI() {
    return axios.post(`${drawLotApi}/ad/sync-all-config`)
  },
  // 上传广告位
  addUploadFileAPI(data) {
    return axios.post(`${drawLotApi}/ad/upload-file`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // ================运营活动==其他活动奖励======祈福广告===start==========================
  // 获取投放配置列表
  getPrayAdsFreeConfigAPI(data) {
    return axios.get(`${liveGameApi}/api/pray-free-ads-config/`, { params: data })
  },
  // 获取祈福选择道具
  getPrayPropList() {
    return axios.get(`${liveGameApi}/api/pray-prop-list`)
  },
  // 获取投放配置列表单条记录
  getPrayAdsFreeConfigInfoAPI(id) {
    return axios.get(`${liveGameApi}/api/pray-free-ads-config/${id}/`)
  },
  // 新增投放配置
  addPrayAdsFreeConfigAPI(data) {
    return axios.post(`${liveGameApi}/api/pray-free-ads-config/`, data)
  },
  // 编辑投放配置
  editPrayAdsFreeConfigAPI(id, data) {
    return axios.patch(`${liveGameApi}/api/pray-free-ads-config/${id}/`,data)
  },
  // 删除投放配置
  delPrayAdsFreeConfigAPI(id) {
    return axios.delete(`${liveGameApi}/api/pray-free-ads-config/${id}/`)
  },
  // ================运营活动==其他活动奖励======祈福广告===end==========================
  // =======运营活动==其他活动奖励==好运大转盘===start===============
  // 添加配置
  postAddLuckyTurnTableConfig(data){
    return axios.post(`${strongConfigApi}/lucky-turntable-config/`,data)
  },
  //查询配置
  getLuckyTurnTableConfig(channel,currentPage,pageSize){
    return axios.get(`${strongConfigApi}/lucky-turntable-config/?package_channel=${channel}&page=${currentPage}&size=${pageSize}&order_by=id`)
  },
  // 修改配置
  patchLuckyTurnTableConfig(id,data){
   return axios.patch(`${strongConfigApi}/lucky-turntable-config/${id}/`,data)
  },
   // 删除配置
   deleteLuckyTurnTableConfig(id){
    return axios.delete(`${strongConfigApi}/lucky-turntable-config/${id}/`)
   },
  //  活动开关
  postLtActivitySwitchApi(id){
    return axios.post(`${strongConfigApi}/lt-activity-switch/${id}/`)
  },
  // 双倍开关
  postLtDoubleSwitchApi(id){
    return axios.post(`${strongConfigApi}/lt-double-switch/${id}/`)
  },
  // 广告间隔开关
  postLtAdCdSwitchApi(id) {
    return axios.post(`${strongConfigApi}/lt-ad-cd-switch/${id}/`)
  },
  // 订阅开关
  postLtSignSwitchApi(id) {
    return axios.post(`${strongConfigApi}/lt-sign-switch/${id}/`)
  },
  //=======运营活动==其他活动奖励===好运大转盘===end============
  // ================运营活动==群友红包=========start==========================
  // 查询红包配置
  getRedBagAPI(data){
    return axios.get(`${thirdPartyGameApi}/activity/redbags`,{ params: data })
  },
  // 新增奖励配置
  addRedBagReward(data) {
    return axios.post(`${thirdPartyGameApi}/activity/redbag/reward`, data)
  },
  // 修改奖励配置
  editRedBagReward(data, id) {
    return axios.patch(`${thirdPartyGameApi}/activity/redbag/reward/${id}`,data)
  },
  // 删除奖励配置
  delRedBagReward(id, data) {
    return axios.delete(`${thirdPartyGameApi}/activity/redbag/reward/${id}`, { data: data })
  },
  // 修改配置（状态/包配置）
  editRedBagAPI(id, data){
    return axios.post(`${thirdPartyGameApi}/activity/redbag/${id}`, data)
  },
  // 同步配置（状态/包配置）
  copyRedBagConfigAPI(data){
    return axios.post(`${thirdPartyGameApi}/activity/redbag/sync`, data)
  },
  // ================运营活动==群友红包=========end==========================
  // 商城操作记录
  getBpmLog(data) {
    return axios.post(`${propAPI}/shop-product/bpm/log/list`, data)
  },
  // 查询当前是否同类型申请中流程
  getZlinkMember(data) {
    return axios.post(`${propAPI}/backend/bpm/get-zlink-member`, data)
  },
  // ================运营活动==其他活动奖励======钻石充值双倍===start==========================
  // 获取首充双倍活动配置列表
  getFirstDoubleActivityConfig(data) {
    return axios.get(`${liveGameApi}/api/first-double-activity-config/list/`, { params: data})
  },
  // 新增首充双倍活动
  addFirstDoubleActivityConfig(data) {
    return axios.post(`${liveGameApi}/api/first-double-activity-config/`, data)
  },
  // 修改首充双倍活动
  updateFirstDoubleActivityConfig(id, data) {
    return axios.patch(`${liveGameApi}/api/first-double-activity-config/${id}/`,data)
  },
  // 删除首充双倍活动
  deleteFirstDoubleActivityConfig(id) {
    return axios.delete(`${liveGameApi}/api/first-double-activity-config/${id}/`)
  },
  // 获取计费点列表
  getFirstDoubleItem(data) {
    return axios.get(`${liveGameApi}/api/first-double-items/list/`, { params: data})
  },
  // 新增计费点
  addFirstDoubleItem(data) {
    return axios.post(`${liveGameApi}/api/first-double-items/`, data)
  },
  // 修改计费点
  updateFirstDoubleItem(id, data) {
    return axios.patch(`${liveGameApi}/api/first-double-items/${id}/`,data)
  },
  // 删除计费点
  deleteFirstDoubleItem(id) {
    return axios.delete(`${liveGameApi}/api/first-double-items/${id}/`)
  },
  // ================运营活动==其他活动奖励======钻石充值双倍===end==========================
  // ================运营活动==其他活动奖励======卡片充值福利===start==========================
  // 获取指定渠道支付福利配置
  getPayPresentConfig(data){
    return axios.get(`${shuffleConfigApi}/api/pay-present-config/`,{params:data})
  },
  //新增支付福利配置
  postPayPresentConfig(data){
    return axios.post(`${shuffleConfigApi}/api/pay-present-config/`,data)
  },
  // 修改支付福利配置
  patchPayPresentConfig(id,data){
    return axios.patch(`${shuffleConfigApi}/api/pay-present-config/${id}/`,data)
  },
  // 删除支付福利配置
  deletePayPresentConfig(id){
    return axios.delete(`${shuffleConfigApi}/api/pay-present-config/${id}/`)
  },
  // ================运营活动==其他活动奖励======卡片充值福利===end==========================
  // ================游戏设置==其他设置======支付渠道配置===start==========================
  // 获取  充值列表
  getWebRechargeListAPI(data) {
    return axios.get(`${thirdPartyGameApi}/web-recharge-config/list/`,{ params: data })
  },

  // 启用/停用  充值配置
  changeWebRechargeStatusAPI(data, id) {
    return axios.patch(`${thirdPartyGameApi}/web-recharge-config/change-status/${id}`,data)
  },

  // 添加  充值配置
  addWebRechargeListAPI(data) {
    return axios.post(`${thirdPartyGameApi}/web-recharge-config/`, data)
  },

  // 修改  充值配置
  editWebRechargeListAPI(data, id) {
    return axios.patch(`${thirdPartyGameApi}/web-recharge-config/${id}`,data)
  },

  // 删除  充值配置
  delWebRechargeListAPI(id) {
    return axios.delete(`${thirdPartyGameApi}/web-recharge-config/${id}`)
  },

  // 添加/编辑时 获取请求地址参数
  getWebRechargeUrlsAPI(data) {
    return axios.get(`${thirdPartyGameApi}/web-recharge-config/urls/`,{ params: data })
  },

  // 重排序
  reorderRecharge(data) {
    return axios.post(`${thirdPartyGameApi}/web-recharge-config/reorder/`, data)
  },
  // ================游戏设置==其他设置======支付渠道配置===end==========================
  // ================全局配置==约局子游戏配置======start==========================
  // 渠道列表
  getRefGamePlayConfig(data){
    return axios.get(`${strongConfigApi}/ref_gameplay_config/`,{params:data})
  },
  // 渠道列表
  getUgcGames(data){
    return axios.get(`${strongConfigApi}/ref_gameplay_config/ugc/games`,{params:data})
  },
  // 单个渠道数据
  getRefGamePlayConfigById(id){
    return axios.get(`${strongConfigApi}/ref_gameplay_config/${id}/`)
  },
  // 修改渠道和地区配置
  postRefGamePlayConfig(id,data){
    return axios.post(`${strongConfigApi}/ref_gameplay_area_config/${id}/`,data)
  },
  // 删除渠道
  deleteRefGamePlayConfig(id){
    return axios.delete(`${strongConfigApi}/ref_gameplay_config/${id}/`)
  },
  //修改渠道和子游戏配置
  postRefGamePlayGameAreaConfig(id,data){
    return axios.post(`${strongConfigApi}/ref_gameplay_game_area_config/${id}/`,data)
  },
  //新增渠道和地区配置
  addRefGamePlayGameAreaConfig(data){
    return axios.post(`${strongConfigApi}/ref_gameplay_area_config/`,data)
  },
  // 新增跳转平台
  addPlatformConfig(data){
    return axios.post(`${strongConfigApi}/platform_app_id/`,data)
  },
  // 修改跳转平台
  patchPlatformConfig(id,data){
    return axios.patch(`${strongConfigApi}/platform_app_id/${id}/`,data)
  },
  // 查询跳转平台
  getPlatformConfig(data){
    return axios.get(`${strongConfigApi}/platform_app_id/`,{params:data})
  },
  // 删除跳转平台
  deletePlatformConfig(id){
    return axios.delete(`${strongConfigApi}/platform_app_id/${id}/`)
  },
  // 搜索失败信息收集
  exportExcelErrorConfig(data){
    return axios.post(`${strongConfigApi}/searchFailedInfoCollect/export/excel`, data, {
      responseType: 'blob'
    })
  },
  // ================全局配置==约局子游戏配置======end==========================
  // ================游戏模块==平台跳转/强弹、图文======start==========================
  //联运强弹获取
  getIntermodalGamePopConfig(data) {
    return axios.get(`${thirdPartyGameApi}/intermodal-game-pop-config/`,{ params: data })
  },
  //联运强弹新增
  addIntermodalGamePopConfig(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-pop-config/`,data)
  },
  //联运强弹修改
  updateIntermodalGamePopConfig(data) {
    return axios.patch(`${thirdPartyGameApi}/intermodal-game-pop-config/${data.id}/`,data)
  },
  //联运强弹删除
  delIntermodalGamePopConfig(id) {
    return axios.delete(`${thirdPartyGameApi}/intermodal-game-pop-config/${id}/`)
  },
  //联运图文获取
  getIntermodalGamePicturesConfig(data) {
    return axios.get(`${thirdPartyGameApi}/intermodal-game-pictures-config/`,{ params: data })
  },
  //联运图文新增
  addIntermodalGamePicturesConfig(data) {
    return axios.post(`${thirdPartyGameApi}/intermodal-game-pictures-config/`,data)
  },
  //联运图文修改
  updateIntermodalGamePicturesConfig(data) {
    return axios.patch(`${thirdPartyGameApi}/intermodal-game-pictures-config/${data.id}/`,data)
  },
  //联运图文删除
  delIntermodalGamePicturesConfig(id) {
    return axios.delete(`${thirdPartyGameApi}/intermodal-game-pictures-config/${id}/`)
  },
  // ================游戏模块==平台跳转/强弹、图文======end==========================
  // 获取求签配置2.1列表
  getDrawLotConfigListV3(data) {
    return axios.get(`${fluCard}/draw-lot-config-v3/`, { params: data})
  },
  // 根据ID获取求签配置2.1详情
  getDrawLotConfigByIdV3(id) {
    return axios.get(`${fluCard}/draw-lot-config-v3/${id}/`)
  },
  // 更新求签配置2.1
  updateDrawLotConfigV3(data) {
    return axios.patch(`${fluCard}/draw-lot-config-v3/${data.id}/`, data)
  },
  // 新增求签配置2.1
  addDrawLotConfigV3(data) {
    return axios.post(`${fluCard}/draw-lot-config-v3/`, data)
  },
  // 更新求签配置2.1状态
  updateDrawLotConfigStateV3(id, data) {
    return axios.patch(`${fluCard}/draw-lot-config-v3/state/${id}/`, data)
  },
  // 删除求签配置2.1
  deleteDrawLotConfigV3(id) {
    return axios.delete(`${fluCard}/draw-lot-config-v3/${id}/`)
  },
  // ======== 中至农场兑换配置 ===========
  // 获取农场兑换配置列表
  getExchangeConfigList(data) {
    return axios.get(`${propAPI}/backend/farm/exchange_config/list`, { params: data })
  },
  // 新增农场兑换配置
  addExchangeConfig(data) {
    return axios.post(`${propAPI}/backend/farm/exchange_config/add`, data)
  },
  // 更新农场兑换配置
  updateExchangeConfig(data) {
    return axios.post(`${propAPI}/backend/farm/exchange_config/update/${data.id}`, data)
  },
  // 查询已关联兑换配置的游戏包
  searchExchangeConfiguredPkg() {
    return axios.get(`${propAPI}/backend/farm/exchange_config/packages`)
  },
  // 修改农场兑换配置启停状态
  updateExchangeConfigStatus(data) {
    return axios.post(`${propAPI}/backend/farm/exchange_config/switch/${data.id}`, data)
  },
  // 删除农场兑换配置
  delExchangeConfigStatus(id) {
    return axios.delete(`${propAPI}/backend/farm/exchange_config/delete/${id}`)
  },
  // ======== 中至农场兑换配置 ===========
  // ======== 中至农场 ===========
  // 获取农场配置列表
  getFarmConfigList(data) {
    return axios.get(`${propAPI}/farmconfig/backend/list`, { params: data })
  },
  // 新增农场配置
  addFarmConfig(data) {
    return axios.post(`${propAPI}/farmconfig/backend/add`, data)
  },
  // 更新农场配置
  updateFarmConfig(data) {
    return axios.put(`${propAPI}/farmconfig/backend/update`, data)
  },
  // 查询已关联配置的游戏包
  searchConfiguredPkg() {
    return axios.get(`${propAPI}/farmconfig/backend/configuredApkIds`)
  },
  // 修改农场配置启停状态
  updateFarmConfigStatus(data) {
    return axios.put(`${propAPI}/farmconfig/backend/disable`, data)
  },
  // 删除农场配置
  delFarmConfigStatus(id) {
    return axios.delete(`${propAPI}/farmconfig/backend/delete/${id}`)
  },
  // ======== 中至农场 ===========
  // ======== 中至农场-活动配置 ========
  // 获取活动列表
  getActiveConfigList(data) {
    return axios.post(`${propAPI}/farmconfig/backend/activity/list`, data)
  },
  // 新增活动配置
  addActiveConfig(data) {
    return axios.post(`${propAPI}/farmconfig/backend/activity/add`, data)
  },
  // 删除活动配置
  delActiveConfig(id) {
    return axios.delete(`${propAPI}/farmconfig/backend/activity/delete/${id}`)
  },
  // 更新活动配置
  updateActiveConfig(data) {
    return axios.put(`${propAPI}/farmconfig/backend/activity/update`, data)
  },
  // 查询活动配置已关联的游戏包
  searchActiveConfiguredPkg() {
    return axios.get(`${propAPI}/farmconfig/backend/activity/configuredGamePackageMarks`)
  },
  // 活动开关
  switchActivity(data) {
    return axios.put(`${propAPI}/farmconfig/backend/activity/disable`, data)
  },
  // ======== 中至农场-活动配置 ========

  // ======== 联运游戏-礼包配置 ========
  // 获取礼包配置列表
  getGiftConfigList(data) {
    return axios.post(`${propAPI}/intermodal-game-gift-config/list`, data)
  },
  // 新增礼包配置
  addGiftConfig(data) {
    return axios.post(`${propAPI}/intermodal-game-gift-config/add`, data)
  },
  // 编辑礼包配置
  updateGiftConfig(data) {
    return axios.post(`${propAPI}/intermodal-game-gift-config/update`, data)
  },
  // 删除礼包配置
  delGiftConfigById(data) {
    return axios.post(`${propAPI}/intermodal-game-gift-config/delete`, data)
  },
  // 拖拽排序礼包
  dropSortGiftConfig(data) {
    return axios.post(`${propAPI}/intermodal-game-gift-config/sort`, data)
  },
  // 获取兑换码列表
  getGiftCodeList(data) {
    return axios.post(`${propAPI}/intermodal-game-cd-key-record/list`, data)
  },
  // 删除兑换码
  delGiftCodeById(data) {
    return axios.post(`${propAPI}/intermodal-game-cd-key-record/delete`, data)
  },
  // 替换兑换码
  replaceCodeList(data) {
    return axios.post(`${propAPI}/intermodal-game-cd-key-record/replace`, data)
  },
  // 补充兑换码
  supplementCode(data) {
    return axios.post(`${propAPI}/intermodal-game-cd-key-record/supplement`, data)
  },
  // ======== 联运游戏-礼包配置 ========
  // 玩法图库
  getRefGameplayImageConfig(data){
    return axios.post(`${strongConfigApi}/ref_gameplay_image_config/list`, data)
  },
  addRefGameplayImageConfig(data){
    return axios.post(`${strongConfigApi}/ref_gameplay_image_config/add`, data)
  },
  editRefGameplayImageConfig(data){
    return axios.post(`${strongConfigApi}/ref_gameplay_image_config/update`, data)
  },
  delRefGameplayImageConfig(data){
    return axios.post(`${strongConfigApi}/ref_gameplay_image_config/delete`, data)
  },
};
